import {
  Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChildren, HostListener, ViewChild, ElementRef, Renderer2,
  DoCheck,
  QueryList,
  ChangeDetectorRef
} from '@angular/core';
import { Config } from '../../config/config';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { RestDataService } from '../../service/rest-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { AfterViewInit, OnChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { EmbedVideoService } from 'ngx-embed-video';
import { RelatedStoryViewComponent } from '../related-story-view/related-story-view.component';
import { AngularCropperjsComponent } from 'angular-cropperjs';
import { SnotifyService } from 'ng-snotify';
import { SharedDataService } from '../../service/shared-data.service';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import * as QuillNamespace from 'quill';
import { DragulaService } from 'ng2-dragula';
import * as dragula from 'dragula';
import * as QuillDelta from 'quill-delta';
const Quill: any = QuillNamespace;
import { PlainClipboard } from '../../service/PlainClipboard.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as deepEqual from "deep-equal";
import { SpeechService } from '../../service/speech.service';
import { GoogleAnalyticsService } from '../../service/google-analytics.service';
import Editor from "../../../assets/js/ckeditor";
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import { cloneDeep } from 'lodash';
import { environment } from '../../../environments/environment';
import { escapeRegExp } from '@angular/compiler/src/util';

Quill.register('modules/clipboard', PlainClipboard, true);
@Component({
  selector: '.element-module',
  templateUrl: './element-module.component.html',
  styleUrls: ['./element-module.component.scss']
})
export class ElementModuleComponent implements OnInit, OnDestroy, AfterViewInit, DoCheck, OnChanges {
  showAmazonMeta: boolean;
  newAdName: string;
  adTitle: string;
  newAdEmbed: string;
  newAmazonAdName: string;
  newAmazonAdEmbed: string;

  newCromaAdName: string;
  newCromaAdEmbed: string;

  newFlipkartAdName:string;
  newFlipkartAdEmbed:string;

  newSnapdealAdName:string;
  newSnapdealAdEmbed:string;
  amazonNewAd: boolean;
  amazonAds= [];
  amazonAdDisplay: boolean;
  cropAllGallery: boolean;
  newMarketPopup: boolean = false;
  mutualFundSuggestion: any;
  mutualFundList: any = [];
  focusedCard: any;
  lastindex: any;
  createTable: boolean = false;
  topicName: string;
  lenQuill: any;
  selectedText: any;
  topicUrl: string;
  marketList: any = [];
  newMarketList: any = []
  marketSuggestion: any;
  newMarketSuggestion: any = [];
  showMutualFunds: any;
  deactivateMarketSuggestion: boolean =false;
  deactivateNewMarketSuggestion:boolean;
  relatedStoryDescriptionEditor: null;
  relatedStoryTitleEditor: null;
  relatedStoryArray = [];
  relatedStoryTitleArray = [];
  words: any;
  selectedToRemove :any;
  tempImage: string;
  replaceImagePopupPhotoStory: boolean = false;
  matchPopupLiveBLog: boolean;
  isSlideTitleEnabled = this.sharedService.isdomainConfig('story','isSlideTitleEnabled');
  multipleElementLiveblog: boolean;
  enableReplaceVideoThumbnail:boolean
  enableLeadVideoCaption:boolean;
  enableLeadVideoImageCaption:boolean;
  enableLeadVideoPreview:boolean;
  tempOtherAffiliateData: FormGroup;
  tempRecipeData: FormGroup;
  showRecipePopup: boolean = false;
  imageLoaded: boolean = true;
  imageLoaderShow = false;
  enableRelatedStoryInlineImage:any;
  enableRelatedVideoStoryInlineImage:any;
  enableSpeechToTextPara:boolean=false;
  isImageCaptionHyperlink:boolean=false;
  brandEleQuery: any = '';
  modelEleQuery: any = '';
  showProductPopup: boolean;
  insideBrandEle: boolean;
  filteredBrandSuggestion: any;
  insideModelEle: boolean;
  productElement: any = {};
  filteredModelSuggestion: any;
  showCategoryProductPopup: boolean;
  categoryEleQuery: string = '';
  insideCategoryEle: boolean;
  filteredCategorySuggestion: any;
  categorySuggestion: any;
  modelSuggestionValues: any = {};
  viewImage: any;
  langCode: any = 'en-US'
  currentCursorPosition:number=0;
  speechButton:boolean=true;
  msg:any='';
  msg1:any='';
  isStoryListing: boolean = false;
  showHyperlinkTooltip: boolean;
  showHyperlinkIcon: boolean;
  showLBcropper: boolean;
  showAlsoReadStoryPopup: boolean;
  showViewImagePopup: boolean;
  isDraggedImages: boolean;
  viewImagesData: any[];
  chosenEditor: any;
  openRelatedStoryPreview = false;
  tempOtherAffiliateProductImage: any = [];
  showProductImageCropper: boolean = false;
  logoGalleryFlag: boolean;
  addProductImageGalleryFlag: boolean;
  showSnapdealMeta: boolean;
  snapdealAds: any = [];
  snapdealNewAd: boolean;
  showCromaMeta : boolean;
  cromaAds : any = [];
  cromaNewAd: boolean;
  showFlipkartMeta : boolean;
  flipkartAds: any = [];
  flipkartNewAd: boolean;
  showEditRelatedStoryPopup = false;
  showPostEditRelatedStoryPopup = false;
  minAusScore: number;
  autoBacklinkResponse : any;
  paraElementId: any;
  tempListicleData: FormGroup;
  tempnewFAQData: FormGroup;
  enableFAQImageOption: boolean;
  faqArray : FormArray;
  ansArray : FormArray;
  FAQvideo: any;
  faqEmbedCode: string;
  quesFaqEmbedCode: string;
  showEmbedForFAQElement: boolean;
  enableQuesFAQImageOption: boolean;
  showEmbedForQuesFAQElement: boolean;
  recipeEditorArray=[];
  stepEditorArray = [];
  showLabelPopup=false;
  label = '';
  separator: '';
  showSeparatorPopup=false;
  @Input()
  set storyId(storyId_string: string) {
    this.story_Id = (storyId_string) ? storyId_string : null;
  }
  @Input() id: string;
  @Input() index: number;
  @Input() cardData: any;
  @Input() photoStoryType: any;
  @Input() preLoadedcardData: any;
  @Input() cardId: string;
  @Input() storytype: string;
  @Input() EditMode: boolean;
  @Input() editCardFlag: boolean;
  @Input() editCardId: string;
  @Input() disableEditPara : boolean;
  @Input() isDeletable: boolean;
  @Input() isEditable: boolean;
  @Input() cardTypeFlag: boolean;
  @Input() leadMediaId: string;
  @Input() draggableFlag: boolean;
  @Input() cardType: string;
  @Input() showToggle: boolean;
  @Input() hideDragger: boolean;
  @Input() liveblogPostImage: boolean;
  @Input() nestedElement: boolean;
  @Input() leadMedia: boolean;
  @Input() leadMediaGif: boolean;
  @Input() cardTypeGif: string;
  @Input() activePin: boolean;
  @Input() textDifferenceCase: boolean;
  @Input() leadVideoThumbnail: boolean;
  @Input() brandSuggestion: any;
  @Input() modelSuggestion: any;
  @Input() sampleImage : any;
  @Input() isPage: boolean;
  @Input() ogImage : any;
  @Output() failedImageUploadEmit = new EventEmitter<any>();
  @Input() removedBacklinkList: any;
  @Input() storySlug: string;
  @Input()
  set currentFocusedElementId(currentFocusedElementId: string) {
    this.currentEditingElementID = currentFocusedElementId ? currentFocusedElementId : '';
  }
  @Input()
  set showErrorForPublish(showErrorForPublish: boolean) {
    this.publishError = showErrorForPublish ? showErrorForPublish : false;
  }
  publishError = false;
  currentEditingElementID: any;
  elementArray: any;

  @Input()
  set storyElementArray(storyElementArray: any[]) {
    // console.log(storyElementArray);
    this.elementArray = (storyElementArray && (storyElementArray.length > 0)) ? storyElementArray : [];
  }
  @Output() dragfn = new EventEmitter<any>();
  @Output() setCardTypefn = new EventEmitter<any>();
  @Output() editCardfn = new EventEmitter<any>();
  @Output() deleteCardfn = new EventEmitter<any>();
  @Output() deleteTempParafn = new EventEmitter<any>();
  @Output() deletePinCardfn = new EventEmitter<any>();
  @Output() pinCardfn = new EventEmitter<any>();
  @Output() unPinCardfn = new EventEmitter<any>();
  @Output() cancelCardfn = new EventEmitter<any>();
  @Output() saveCardfn = new EventEmitter<any>();
  @Output() addTagfn = new EventEmitter<any>();
  @Output() editTagfn = new EventEmitter<any>();
  @Output() deleteTagfn = new EventEmitter<any>();
  @Output() updateCardDatafn = new EventEmitter<any>();
  @Output() tempSaveCard = new EventEmitter<any>();
  @Output() afterInitializeEmit = new EventEmitter<any>();
  @Output() selectOneStory = new EventEmitter<any>();
  @Output() currentcardfn = new EventEmitter<any>();
  @Output() childKeyDown = new EventEmitter<any>();
  @Output() sendWordCountToStory = new EventEmitter<any>();
  @Output() setAsLeadMediafn = new EventEmitter<any>();
  @Output() setPhotoStoryLeadMedia = new EventEmitter<any>();
  @Output() replaceImageEmit = new EventEmitter<any>();
  @Output() emitInsertInlineElement = new EventEmitter<any>();
  @Output() previousFocusEmit = new EventEmitter<any>();
  @Output() nextFocusEmit = new EventEmitter<any>();
  @Output() emitParaDeleteContent = new EventEmitter<any>();
  @Output() changeRelated = new EventEmitter<any>();
  @Output() changeRelatedHowto = new EventEmitter<any>();
  @Output() getAlsoReadEmit = new EventEmitter<any>();
  @Output() lastindexfn = new EventEmitter<any>();
  @Output() tempParaSaveEmit = new EventEmitter<any>();
  @Output() deleteTempViewOfPara = new EventEmitter<any>();
  @Output() incrementPendingRequest = new EventEmitter<any>();
  @Output() decrementPendingRequest = new EventEmitter<any>();
  @Output() scrollOut = new EventEmitter<any>();
  @Output() storySave = new EventEmitter<any>();
  @Output() ampValidationOutput = new EventEmitter<any>();
  @Output() embedChangeOutput = new EventEmitter<any>();
  @Output() outputEmbedSourceUrl = new EventEmitter<any>();
  @Output() manualLinkCountIncr = new EventEmitter<any>();
  @Output() manualLinkCountDecr = new EventEmitter<any>();
  @Output() liveblogDelete = new EventEmitter<any>();
  @Output() sendVideoCaption = new EventEmitter<any>();
  @Output() sendVideoImageCaption = new EventEmitter<any>();
  @Output() paraContentChanged = new EventEmitter<any>();
  @Output() sendReplaceVideoImage = new EventEmitter<any>();
  @Output() emitEnableDisableSampleImagePopup = new EventEmitter<any>();
  @Output() emitStockWidgetDelete = new EventEmitter<any>();
  video_iframe_html: any;
  quillText = '';
  story_page_id = StaticDataService.story_page_id;
  page_id = StaticDataService.element_page_id;
  save_api = StaticDataService.element_save_api;
  get_api = StaticDataService.element_get_api;
  story_get_api = StaticDataService.story_get_api;
  lockAcquire_api = StaticDataService.story_lockAcquire_api;
  lockRelease_api = StaticDataService.story_lockRelease_api;
  customValue = '';
  focusFlag;
  pdfSrc: string;
  openPdf = false;
  titleFocusFlag = false;
  storyList:any
  descFocusFlag = false;
  cardLoaded = false;
  firstLoadCheck = 0;
  autosave: any;
  page = 1;
  totalNumberOfPages = 0;
  editFlag = false;
  loaded = false;
  temporaryChangesFlag = false;
  lastCardTempData: any;
  iseditVideCaptionClick:boolean=false;
  iseditVideImageCaptionClick:boolean=false;
  tempCardData = {
    'caption': '',
    'name': '',
    'tags': [],
    'title': '',
    'imageUrl':'',
    'source': '',
    'link': '',
    'videoImageCaption':'',
    'relatedStoryHeadline':'',
    'verticalImage': false,
    "amazonAds": [
      {
        "key": '',
        "value": '',
        "isPresent": false
      },
    ],
    "amazonMeta": false,
    "amazonTitle": '',
    "amazonCheckedItem": false,
    "overImage": false
  };

  lastCardData: any;
  changeFlag = false;
  isCursorHovering = false;
  @ViewChildren('textE') vcE;
  @ViewChildren('relatedStoryRef') relatedStoryElements: RelatedStoryViewComponent;
  @ViewChildren('brandEleInput') brandEleField;
  @ViewChildren('modelEleInput') modelEleField;
  @ViewChildren('categoryEleInput') categoryEleField;
  marketCode: string;
  marketText: string;
  marketPopup = false;
  matchPopup = false;
  recommendedAutobacklinkContentData:any;
  toolbarConfig = {
    toolbar: [
      [{ header: [2, 3, false] }],
      ['bold', 'italic'],
      ['link'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }],
    ],
    keyboard: {
      bindings: {
        tab: {
          key: 9,
          handler: function () {
            // console.log('tab is pressed');
          }
        }
      }
    },
    disableTwoWayDataBinding: false
  };

  toolbarConfigWithoutAlignment = {
    toolbar: [
      ['bold', 'italic'],
      ['link'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    ],
    keyboard: {
      bindings: {
        tab: {
          key: 9,
          handler: function () {
            // console.log('tab is pressed');
          }
        }
      }
    },
    disableTwoWayDataBinding: false
  };

  headlineToolbar = {
    toolbar: [
      ['italic']
    ],
    keyboard: {
      bindings: {
        tab: false,
        handleEnter: {
          key: 13,
          handler: function () {
          }
        }
      }
    },
    disableTwoWayDataBinding: false
  };

  captionToolbar = {
    toolbar: [],
    keyboard: {
      bindings: {
        tab: false,
        handleEnter: {
          key: 13,
          handler: function () {
            // Do nothing
          }
        }
      }
    },
    disableTwoWayDataBinding: false
    // maxLength: 80
  };

  captionEditor = null;
  captionFocusFlag = false;

  selectedValue: string;
  leadMediaImageToggle = false;
  isPhotopopup = false;
  isLightbox = false;
  selectedFile: File = null;
  // elementWordCount = 0;
  videoUrl = '';
  videoUrlPopup = false;
  @ViewChild('angularCropper169', {static: false}) public angularCropper169: AngularCropperjsComponent;
  @ViewChild('angularCropper11', {static: false}) public angularCropper11: AngularCropperjsComponent;
  @ViewChild('angularCropper23', {static: false}) public angularCropper23: AngularCropperjsComponent;
  cropperConfig169 = {
    aspectRatio: 16 / 9,
    cropBoxResizable: false,
    cropBoxMovable: false,
    dragMode: 'move',
    viewMode: 1,
    toggleDragModeOnDblClick: false,
    autoCropArea: 0,
    movable: true,
    scalable: true,
    zoomable: true
  };
  cropperConfig11 = {
    aspectRatio: 1 / 1,
    cropBoxResizable: false,
    cropBoxMovable: false,
    dragMode: 'move',
    viewMode: 1,
    toggleDragModeOnDblClick: false,
    autoCropArea: 0,
    movable: true,
    scalable: true,
    zoomable: true
  };

  cropperConfig23 = {
    aspectRatio: 2 / 3,
    cropBoxResizable: false,
    cropBoxMovable: false,
    dragMode: 'move',
    viewMode: 1,
    toggleDragModeOnDblClick: false,
    autoCropArea: 0,
    movable: true,
    scalable: true,
    zoomable: true
  };
  initZoom169 = 2;
  initZoom11 = 2;
  initZoom23 = 2;
  cropperImageUrl = {
    url: null,
    data: null,
    blobData: null
  };
  showCropper = false;
  addVideoThumbnail=false;
  leadMediaImageGif = false;
  embedPopup = false;
  showFaqPopup = false;
  embedCode = '';
  embedSourceUrl = '';
  embedSubType = '';
  showOptions = false;
  replaceImagePopup = false;
  isLocked = false;
  saveInQueue = 0;
  focusTimer = 0;
  cropForLeadMedia = false;
  serverUrl = this.config.get('product').socketUrl;
  stompClient = null;
  @Output() emitParentImageId = new EventEmitter<any>();
  @Output() emitRefereshStory = new EventEmitter<any>();
  @Output() emitParentImageIdDelete = new EventEmitter<any>();
  @Output() emitParentPaywallIdDelete = new EventEmitter<any>();
  @ViewChild('paraEl', {static: false}) paragraphElement: ElementRef;
  @ViewChild('tableEl', {static: false}) tableElement: ElementRef;
  @ViewChild('descEl', {static: false}) descriptionElement: ElementRef;
  @ViewChild('imageEl', {static: false}) imageElement: ElementRef;
  @ViewChild('captionInput', {static: false}) imgCaptionInput: ElementRef;
  @ViewChild('embedEl', {static: false}) embedElement: ElementRef;
  @ViewChild('relatedEl', {static: false}) relatedElement: ElementRef;
  @ViewChild('relatedElhowto', {static: false}) relatedElementhowto: ElementRef;
  @ViewChild('videoEl', {static: false}) videoElement: ElementRef;
  @ViewChild('quoteEl', {static: false}) quoteElement: ElementRef;
  @ViewChild('captionEl', {static: false}) captionElement: ElementRef;
  @ViewChild('reviewEl', {static: false}) reviewElement: ElementRef;
  @ViewChild('nestedOptions', {static: false}) nestedOptionDropdown: ElementRef;
  @ViewChildren('liveblogLeadEl') liveblogLeadElement: ElementModuleComponent;
  @ViewChildren('photoPhotoStory') photoStoryImg: ElementModuleComponent;
  @ViewChildren('sampleImageEle') sampleImageEle: ElementModuleComponent;
  @ViewChildren('listicleLeadEl') listicleLeadElement: ElementModuleComponent;
  @ViewChild('innerLeadel', {static: false}) leadEl: ElementRef;
  paraEditor = null;
  titleEditor = null;
  descriptionEditor = null;
  inlineElementEditor = null;
  faqEditor = null;
  stepEditor = null;
  cursorFocus = false;
  outerDivFocus = false;
  trustedHTML = null;
  temporaryView = null;
  tempViewData = null;
  autoBackLinkList = [];
  showRelatedStoryPopup = false;
  showPostRelatedStoryPopup = false;
  relatedStoryTempList = [];
  relatedStoryMultipleSelectFlag = false;
  relatedStoryType:string='';
  enabledRelatedStoryIdData:boolean;
  tempRelatedStoryId = null;
  tempRelatedStoryIdhowto = null;
  videoDuration = 0;
  requestInQueue = 0;
  pendingCallsInQueue = [];
  apiCallHit = false;
  showListiclePopup = false;
  showNewFAQPopup = false;
  tempRelatedStoryForm: FormGroup;
  showNewPollPopup = false;
  FAQInlineImageFlag = false;
  quesFAQInlineImageFlag = false;
  pollInlineImageFlag = false;
  showListicleCropper = false;
  elementDestination = null;
  // firstTimeHit = false;
  monthNames = [
    'Jan', 'Feb', 'March', 'April', 'May', 'June',
    'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  @Output() cardDataFromElement = new EventEmitter<any>();
  @Output() removeSavedCardData = new EventEmitter<any>();
  @Output() updateContentOnParent = new EventEmitter<any>();
  @ViewChild('extra', {static: false}) extra: ElementRef;
  timer = null;
  story_Id: string;
  range: any;
  tablePopup = false;
  tableHTML = '';
  Editor = Editor;
  tableConfig = {
    toolbar: ['bold', 'italic', 'numberedList', 'bulletedList', 'link', '|', 'insertTable'],
    table: {
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
    },
    disableTwoWayDataBinding: false
  };
  domainConfig: any;
  cropperToShow;
  public ckEditor = Editor;
  public ckEditor2 = Editor;

  ckconfig = {
    toolbar: ['numberedList', 'bulletedList', 'link'],
    link: {
      decorators: {
        isExternal: {
          mode: 'automatic',
          callback: url => url,
          attributes: {
            target: '_blank'
          }
        }
      }
    },
    disableTwoWayDataBinding: false
  };
  ckconfigwithalignment = {
    toolbar: ['numberedList', 'bulletedList', 'link', 'alignment', 'heading'],
    heading: {
      options: [
        { model: 'heading2', view: 'h2', title: 'Headline 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Headline 3', class: 'ck-heading_heading3' },
        { model: 'paragraph', view: 'p', title: 'Paragraph', class: '' }
      ]
      },
    alignment: {
      options: ['left', 'right', 'center', 'justify']
    },
    htmlSupport: {
      allow: [
          {
              name: 'a',
              attributes: true,
              classes: true,
              styles: true
          }
      ]
    },
    link: {
      decorators: {
        isExternal: {
          mode: 'automatic',
          callback: url => url,
          attributes: {
            target: '_blank',
          },
        },
        isManual:{
          mode: 'manual',
          label: 'Manual Backlink',
          defaultValue: true,
          attributes: {
            class: 'manualbacklink',
          },
        },
        toggleDoFollow: {
          mode: 'manual',
          label: 'Do Follow',
          attributes: {
            rel: 'dofollow'
          }
        }
      }
    },
    disableTwoWayDataBinding: false
  };

  ckconfigwithalignmentMobile = {
    toolbar: ['numberedList', 'bulletedList', 'bold',  'italic', 'link', 'alignment', 'heading'],
    heading: {
      options: [
        { model: 'heading2', view: 'h2', title: 'Headline 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Headline 3', class: 'ck-heading_heading3' },
        { model: 'paragraph', view: 'p', title: 'Paragraph', class: '' }
      ]
      },
    alignment: {
      options: ['left', 'right', 'center', 'justify']
    },
    link: {
      decorators: {
        isExternal: {
          mode: 'automatic',
          callback: url => url,
          attributes: {
            target: '_blank'
          }
        },
        toggleDoFollow: {
          mode: 'manual',
          label: 'Do Follow',
          attributes: {
            rel: 'dofollow'
          }
        }
      }
    },
    disableTwoWayDataBinding: false
  };

  ckplainconfig = {
    toolbar: [],
    link: {
      decorators: {
        isExternal: {
          mode: 'automatic',
          callback: url => url,
          attributes: {
            target: '_blank'
          }
        }
      }
    },
    disableTwoWayDataBinding: false
  };
  clipboardPlugin;
  editingView;
  ckwriter;
  ckselection;
  lastSelection = {
    'title': null,
    'body': null
  };
  isCKEditorEnabled = false;
  lastCardForChange = null;
  lastCardForImageChange = null;
  uploadImageInProgress = false;
  quotePopup = false;
  quoteText = '';
  quoteHTML = '';
  typesWithoutEditor = ['document', 'image', 'video', 'embed', 'relatedstory', 'table', 'quote', 'review', 'market', 'cricket','movie-review'];
  maxReviewRating = 5;
  tempReviewData = null;
  tempMovieReviewData = null;
  isReviewEditable = false;
  reviewCons: string;
  reviewPros: string;
  specHeading: string;
  specDescription: string;
  @ViewChild('ratingEl', {static: false}) ratingEl: ElementRef;
  captionRestrictionEnabled = false;
  isMultipleLeadImageAllowed = false;
  videoOptions = false;
  isLightboxVideo = false;
  isPageListing = false;
  tableEditor;
  tempFaqData: FormGroup;
  faqs: FormArray;
  SingleselectedFile: File = null;
  imageUploadInProgress = false;
  inlineImageToggle = false;
  showHowToStepsCropper = false;
  showRecipeStepsCropper = false;
  recipeInlineImageFlag: boolean = false;
  showLoader = false;
  currentStep = 0;
  tempHowToStepsData: FormGroup;
  steps: FormArray;
  showStepPopup = false;
  howToStepsInlineImageFlag = false;
  enableCustomThumbnail: boolean = false;
  enableVerdict=false;
  enableListicleHeading:boolean;
  enableListicleProduct:boolean;
  listicleProductList:any;
  listicleProductBrandList=[];
  actualListicleBrandModelList=[];
  listicleModelList:any;
  listcleCategory:string='';
  listcleBrand:string='';
  listcleModel:string='';
  listicleProductPopup = false;
  showPodcastPopup = false;
  showJW: boolean = false;
  showYT: boolean = false;
  enableJW = 'true';
  enableYT = false;
  enableBrand=false;
  enableModel=false;
  enableVerticalFlag = false;
  autoSaveInterval:number = 1000;
  enableAmazonMeta: boolean;
  enableContentRecommendation: any;
  liveBlogPostEdit = false;
  listicleArray: FormArray;
  enableListicleImageOption: boolean;
  autoBacklinkMaxLinkLimit: any;
  videoIndex:any;
  listicleEmbedCode:any;
  showEmbedForListcleElement=false;
  listicleInlineImageFlag = false;
  showQuotes: boolean;
  callRecommendation : boolean;
  indicesNewMarketList : any[] = [];
  enableUrlInListicle = false;
  @ViewChild('editorPara',{static:false})
  editorPara: CKEditorComponent;
  @ViewChild('editorCaption',{static:false})
  editorCaption: CKEditorComponent;
  @ViewChild('editorTitle',{static:false})
  editorTitle: CKEditorComponent;
  @ViewChild('editorVideoCaption',{static:false})
  editorVideoCaption: CKEditorComponent;
  @ViewChild('editorListicle',{static:false})
  editorListicle: CKEditorComponent;
  @ViewChild('editorListicleTitle',{static:false})
  editorListicleTitle: CKEditorComponent;
  @ViewChild('editorLiveBlogBody',{static:false})
  editorLiveBlogBody: CKEditorComponent;
  @ViewChild('editorShortVerdict',{static:false})
  editorShortVerdict: CKEditorComponent;
  @ViewChild('editorMovieDescription',{static:false}) editorMovieDescription: CKEditorComponent;
  @ViewChild('editorMovieReview',{static:false}) editorMovieReview: CKEditorComponent;
  @ViewChild('editortable',{static:false})
  editortable: CKEditorComponent;
  liveblogCollabEnabled = false;
  enableRelatedStoryPreview = false;


  @Output() cropCompletedEvent = new EventEmitter<string>();
  constructor(
    public config: Config,
    public restService: RestDataService,
    private embedService: EmbedVideoService,
    private http: HttpClient,
    private snotify: SnotifyService,
    private sharedService: SharedDataService,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private dragulaService: DragulaService,
    private formBuilder: FormBuilder,
    private changeDetection:ChangeDetectorRef,
    private speechRecognitionService:SpeechService,
    private gaService:GoogleAnalyticsService
  ) {
    this.domainConfig = this.sharedService.currentDomainConfiguration;
    this.liveblogCollabEnabled = this.sharedService.isdomainConfig('story','liveblogCollabEnabled')
    this.isCKEditorEnabled = this.sharedService.isdomainConfig('story','vernacular-editor');
    this.cropperToShow = (this.domainConfig['imageRatios'] && (this.domainConfig['imageRatios'].length > 0))
      ? this.domainConfig['imageRatios'] : StaticDataService.defaultConfig.imageRatios;
    this.captionRestrictionEnabled = (this.domainConfig && this.domainConfig['config']
    && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['imageRestriction']
    && this.domainConfig['config']['story']['imageRestriction'] !== '');
    this.enableAmazonMeta = this.domainConfig['config']['story']['enableAmazonMeta'];
    let mas = (this.domainConfig['config'] && this.domainConfig['config']['image'] && this.domainConfig['config']['image']['minAusScore'] ? this.domainConfig['config']['image']['minAusScore'] : 2.49);
     this.minAusScore = Number(mas);
     console.log("MIN AUS SCORE", this.minAusScore)
    this.isMultipleLeadImageAllowed = this.sharedService.isdomainConfig('image','multipleLeadImage');
    this.multipleElementLiveblog = this.sharedService.isdomainConfig('story','multipleElementLiveblog');
    this.enableReplaceVideoThumbnail= this.domainConfig['config']['story']['enableReplaceVideoThumbnail'];
    this.enableLeadVideoCaption=  this.domainConfig['config']['story']['enableLeadVideoCaption'];
    this.enableLeadVideoImageCaption=  this.domainConfig['config']['story']['enableLeadVideoImageCaption'];
    this.enableLeadVideoPreview= this.domainConfig['config']['story']['enableLeadVideoPreview'];
    this.enableRelatedStoryInlineImage=this.domainConfig['config']['story'] && this.domainConfig['config']['story']['enableRelatedStoryInlineImage']==undefined?[]:this.domainConfig['config']['story']['enableRelatedStoryInlineImage'];
    this.enableVerdict = this.domainConfig['config']['story']['enableVerdict'] ? this.domainConfig['config']['story']['enableVerdict'] : false;
    this.enableListicleHeading=  this.domainConfig['config']['listicle'] && this.domainConfig['config']['listicle']['enableHeading'];
    this.enableListicleProduct= this.domainConfig['config']['listicle'] && this.domainConfig['config']['listicle']['enableProduct'];
    this.enableRelatedStoryInlineImage=this.domainConfig['config']['story'] && this.domainConfig['config']['story']['enableRelatedStoryInlineImage']==undefined?[]:this.domainConfig['config']['story']['enableRelatedStoryInlineImage']
    this.enableRelatedVideoStoryInlineImage = this.domainConfig['config']['story'] && this.domainConfig['config']['story']['enableRelatedVideoStoryInlineImage']==undefined?[]:this.domainConfig['config']['story']['enableRelatedVideoStoryInlineImage']
    this.enableSpeechToTextPara=this.sharedService.isdomainConfig('story','enableSpeechToTextPara');
    this.isImageCaptionHyperlink=this.sharedService.isdomainConfig('story','isImageCaptionHyperlink');
    this.enableVerticalFlag = this.domainConfig['config']['image']['enableVerticalImage'] ? this.domainConfig['config']['image']['enableVerticalImage']:false;
    this.enableContentRecommendation = this.domainConfig['config'] && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['enableContentRecommendation'];
    this.autoBacklinkMaxLinkLimit = this.domainConfig['config'] && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['autoBacklinkMaxLinkLimit']
    this.enableUrlInListicle = this.sharedService.isdomainConfig('story','enableUrlInListicle');
    this.enableRelatedStoryPreview = this.domainConfig['config']['story']['enableRelatedStoryPreview']
    dragulaService.dragend.subscribe(value => {
      this.dragend(value);
    });
    if (dragulaService.find('new-bag1') == undefined) {
      dragulaService.setOptions('new-bag1', {
        moves: function (el, container, handle) {
          return (handle.className === 'handle sortpara1' || handle.className === 'icon-move affiMove');
        }
      });}
      this.showMutualFunds = this.domainConfig['config']['story']['showMutualFunds'];
    this.enableJW = this.domainConfig['config']['story']['enableJW'] ? this.domainConfig['config']['story']['enableJW'] : 'true';
    this.enableYT = this.domainConfig['config']['video']['isYouTube'] ? this.domainConfig['config']['video']['isYouTube'] : false;
    if(this.enableJW === 'true')
    {
      this.showJW = true;
      this.showYT = false;
    }
    else if(this.enableYT)
    {
      this.showJW = false;
      this.showYT = true;
    }
    this.enableBrand=this.domainConfig['config']['story']['enableBrand']?this.domainConfig['config']['story']['enableBrand']:false;
    this.enableModel=this.domainConfig['config']['story']['enableModel']?this.domainConfig['config']['story']['enableModel']:false;
    this.autoSaveInterval = this.domainConfig['config']['story']['elementAutoSaveInterval'] ? +(this.domainConfig['config']['story']['elementAutoSaveInterval']) : this.autoSaveInterval;

    this.sharedService.slugValue.subscribe(val =>{
      if(this.id === "newLiveblogElement"){
      if(this.cardData.title === ''){
        this.cardData.title = val['currentValue'];
      }
      else if(this.cardData.title.indexOf(val['previousValue']) !==-1){
        var titleHasTags = false;
      if(this.cardData.title.includes('<p>')){
        // Define a regular expression to match text between <li> and </li> tags
        var regex = /<p>(.*?)<\/p>/;

        // Use the regular expression to extract the text
        var match = this.cardData.title.match(regex);

        if (match && match.length >= 2) {
          this.cardData.title = match[1].trim();
        }
          titleHasTags = true;
        }
        this.cardData.title = this.cardData.title.substring(0,this.cardData.title.indexOf(val['previousValue'])) +
        val['currentValue']+
        this.cardData.title.substring(this.cardData.title.indexOf(val['previousValue']) + val['previousValue'].length);
        if(titleHasTags)
      this.cardData.title = '<p>'+this.cardData.title+'</p>';
      }
    }
  });
    }

  addOrRemovePlaceholder(editorInstance, model) {
    if(editorInstance) {
      const hasData = this.getFocus(model) || editorInstance.getData();
      if (hasData) {
        this.removePlaceholder(editorInstance);
      } else {
        this.addPlaceholder(editorInstance, model);
      }
    }
  }
  dragend(ev) {
    document.onmousemove = null;
    if(ev[0]=='view-images-bag'){
      this.isDraggedImages=true;
    }
  }
  mouseLeave() {
    this.emitEnableDisableSampleImagePopup.emit(false);
  }
  mouseDown(){
    this.emitEnableDisableSampleImagePopup.emit(true);
  }
  addPlaceholder(editorInstance, model) {
    const editableElement = editorInstance.ui.getEditableElement();
    this.renderer.addClass(editableElement.children[0], 'ck-placeholder');
    this.renderer.setAttribute(editableElement.children[0], 'id', this.getPlaceHolderIds(model));
    this.renderer.setAttribute(editableElement.children[0], 'data-placeholder', this.getPlaceHolder(model));
  }

  removePlaceholder(editorInstance) {
    const editableElement = editorInstance.ui.getEditableElement();
    this.renderer.removeAttribute(editableElement.children[0], 'data-placeholder');
    this.renderer.removeClass(editableElement.children[0], 'ck-placeholder');
  }

  getPlaceHolder(model) {
    switch (model) {
      case 'paragraph':
        return 'Paragraph...';
      case 'caption':
        return 'Add Caption here';
      case 'title':
        return this.cardType === 'listicle' ? 'Point title'
          : (this.cardType === 'liveblog' ? 'Post\'s title' : '');
      case 'desc':
        return this.cardType === 'listicle' ? 'Point description'
          : (this.cardType === 'liveblog' ? 'Post\'s body' : '');
      default:
        return '';
    }
  }

getPlaceHolderIds(model) {
  switch (model) {
    case 'paragraph':
      return 'addParagraphText';
    case 'caption':
      return 'addCaptionText';
    case 'title':
      return this.cardType === 'listicle' ? 'addPointTitle'
        : (this.cardType === 'liveblog' ? 'addPostTitle' : '');
    case 'desc':
      return this.cardType === 'listicle' ? 'addPointDesc'
        : (this.cardType === 'liveblog' ? 'addPostBody' : '');
    default:
      return '';
  }
}

  getFocus(model) {
    switch (model) {
      case 'paragraph':
        return this.focusFlag;
      case 'caption':
        return this.captionFocusFlag;
      case 'title':
        return this.titleFocusFlag;
      case 'desc':
        return this.descFocusFlag;
      default:
        return false;
    }
  }

  openRelatedStoryPreviewPopup(){
    this.openRelatedStoryPreview = true;
  }

  closeRelatedStoryPopup(){
    this.openRelatedStoryPreview = false;
  }

  updateAutoBacklinkData(elementId,autoBacklinkResponse,sendElement) {
    this.restService.http_put(this.config.get('product').utilUrl
    + '/api/cms/autobacklink/element/'+elementId, this.autoBacklinkResponse,
    result => {
       if(result){
        if(sendElement) {
          this.sharedService.autoBacklinkSuggestionList.next(cloneDeep({'recommendedLinkedContent':this.autoBacklinkResponse.recommendedLinkedContent,'addrecommendedContent':true}));
        } else {
          this.sharedService.autoBacklinkSuggestionList.next(cloneDeep({'recommendedLinkedContent':autoBacklinkResponse,'addrecommendedContent':false}));
        }
       } else {
        this.snotify.error('Something bad happened', '', this.sharedService.getConfig(false));
      }
    });
  }

  getAutoBacklinkData() {
      if(this.cardData.type === 'paragraph' && this.cardData.id && this.enableContentRecommendation) {
        this.restService.http_get(
          this.config.get('product').utilUrl
          + '/api/cms/autobacklink/element/'
          + this.cardData.id
        )
          .subscribe(
            res => {
              if(res) {
                this.autoBacklinkResponse = res;
              }
            },error =>{
              this.snotify.error('Something bad happened', '', this.sharedService.getConfig(false));
            })
      }
  }

  getAutoBacklingList(word, linkAdd) {
    // if(!this.sharedService.isdomainConfig('story','autoBacklinking'))
    // return ;
    if(this.enableContentRecommendation && this.cardData.id && (this.cardData.type === 'paragraph' || (this.cardData.type === 'liveblog' && this.liveblogCollabEnabled))) {
      this.restService.http_get(
        this.config.get('product').utilUrl
        + '/api/cms/autobacklink/element/'
        + this.cardData.id
      )
        .subscribe(
          res => {
            if(res) {
              this.autoBacklinkResponse = res;
              if(linkAdd===true) {
                this.addManualBacklingData(word)
              } else {
                this.removeManualBackLinkData(word);
              }
            }
          },error =>{
                this.snotify.error('Something bad happened', '', this.sharedService.getConfig(false));
          });
    }
  }

  removeManualBackLinkData(word){
    if(this.autoBacklinkResponse.recommendedLinkedContent) {
      let objKey = Object.keys(this.autoBacklinkResponse.recommendedLinkedContent);
      objKey.forEach(ele=>{
        if(!word.includes(ele)){
          this.sharedService.autoBacklinkSuggestionList.next(cloneDeep({'recommendedLinkedContent':ele,'addrecommendedContent':false}));
          delete this.autoBacklinkResponse.recommendedLinkedContent[ele];
        }
      })
      if(this.autoBacklinkResponse && this.autoBacklinkResponse.recommendedLinkedContent){
        this.updateAutoBacklinkData(this.cardData.id,this.autoBacklinkResponse,false);
    }
    }
}

  addManualBacklingData(word) {
    if(!this.autoBacklinkResponse['manualBacklinkList'].includes(word)){
      this.autoBacklinkResponse['manualBacklinkList'].push(word);
      this.updateAutoBacklinkData(this.cardData.id,this.autoBacklinkResponse,false);
    }
  }


  autoBacklink(elementId,event?) {

    let timer = this.cardData.id === null? 2000: 0;
    setTimeout(() => {
      if(this.enableContentRecommendation && !this.apiCallHit && this.cardData.id!==null && (this.cardType ==='paragraph' || (this.cardType ==='liveblog' && this.liveblogCollabEnabled))) {
        this.apiCallHit = true;
        this.autoBackLinkList = [];
        this.paraElementId = elementId;
        this.restService.http_get(
          this.config.get('product').utilUrl
          + '/api/cms/autobacklink/element/'
          + this.cardData.id
        )
          .subscribe(
            res => {
              if(res) {
                this.autoBackLinkList = [];
                this.apiCallHit = false
                this.autoBacklinkResponse = res;

                Object.entries(res.recommendedContent).forEach(([key,value])=>{
                    let obj = {
                      key : key,
                      value: value
                    }
                    this.autoBackLinkList.push(obj);
                });
                // this.autoBackLinkList.sort((a, b) => b.key.length - a.key.length);
                if(this.cardType ==='liveblog')
                {
                  this.addAutoBacklink(this.cardData.liveBlog.body,this.autoBackLinkList);
                }else{
                  this.addAutoBacklink(this.cardData.paragraph.body,this.autoBackLinkList);
                }
                this.callRecommendation = false;
              }
            },err=>{
              this.apiCallHit = false
              this.snotify.error('Something bad happened', '', this.sharedService.getConfig(false));
            });
      }
    }, timer);

  }

  ckEditorEnableReadOnlyMode() {
      if(this.paraEditor && !this.editCardFlag ||this.paraEditor && this.disableEditPara){
        this.paraEditor.enableReadOnlyMode('paraElement');
      }else if(this.paraEditor){
        this.paraEditor.disableReadOnlyMode('paraElement');
      }
      if(this.titleEditor && !this.EditMode) {
        this.titleEditor.enableReadOnlyMode('editor');
      } else if(this.titleEditor) {
        this.titleEditor.disableReadOnlyMode('editor');
      }
      if(this.captionEditor && !this.EditMode) {
        this.captionEditor.enableReadOnlyMode('editor');
      } else if(this.captionEditor) {
        this.captionEditor.disableReadOnlyMode('editor');
      }
      if(this.descriptionEditor && !this.EditMode) {
        this.descriptionEditor.enableReadOnlyMode('editor');
      } else if(this.descriptionEditor) {
        this.descriptionEditor.disableReadOnlyMode('editor');
      }
      if(this.paraEditor && !this.EditMode) {
        this.paraEditor.enableReadOnlyMode('editor');
      } else if(this.paraEditor) {
        this.paraEditor.disableReadOnlyMode('editor');
      }
  }

  initilizeEditor(ev, model,type){
    setTimeout(() => {
      if(this.editorPara && type === 'parabody'){
        this.editorPara.editorInstance.setData(this.cardData.paragraph.body);
      }
      if(this.editorCaption && type === 'caption') {
        this.editorCaption.editorInstance.setData(this.tempCardData.caption);
      }
      if(this.editorTitle && type === 'title') {
        this.editorTitle.editorInstance.setData(this.cardData.title);
      }
      if(this.editorVideoCaption && type === 'videoImageCaption') {
        this.editorVideoCaption.editorInstance.setData(this.tempCardData.videoImageCaption);
      }
      if(this.editorListicle && type === 'listiclebody') {
        this.editorListicle.editorInstance.setData(this.cardData.listicle.body);
      }
      if(this.editorListicleTitle && type === 'listicletitle'){
        this.editorListicleTitle.editorInstance.setData(this.cardData.listicle.title);
      }
      if(this.editorLiveBlogBody && type==='liveblogbody'){
        this.editorLiveBlogBody.editorInstance.setData(this.cardData.liveBlog.body);
      }
      if(this.editorShortVerdict && type==='shortVerdict'){
        this.editorShortVerdict.editorInstance.setData(this.tempReviewData.shortVerdict)
      }
      if(this.editorMovieDescription && type==='movieDescription'){
        this.editorMovieDescription.editorInstance.setData(this.tempMovieReviewData.description);
      }
      if(this.editorMovieReview && type==='movieReview'){
        this.editorMovieReview.editorInstance.setData(this.tempMovieReviewData.review);
      }

      if(this.editortable && type==='table'){
        this.editortable.editorInstance.setData(this.tableHTML)
      }
      this.addOrRemovePlaceholder(ev, model);
    }, 200);
  }

  ckchanges(ev, label, model,type,index?) {
    if (label === 'ready') {
      const clipboardPlugin = ev.plugins.get('ClipboardPipeline');
      const editingView = ev.editing.view;
      editingView.document.on('clipboardInput', (evt, data) => {
        if (ev.isReadOnly) {
          return;
        }
        const dataTransfer = data.dataTransfer;
        const plaintext = dataTransfer.getData('text/plain');
        const htmltext = dataTransfer.getData('text/html');
        let text;
        switch (model) {
          case 'desc':
          case 'paragraph':
            text = this.text2HTML(plaintext).replace(/<\p><\/p>/gm, '').replace(/<br ?\/?>/g, '');

            break;
          case 'caption':
          case 'title':
            text = this.htmlToPlainTextExcludingPara(plaintext);
            break;
          case 'table':
            const div = document.createElement('div');
            div.innerHTML = this.htmlToPlainTextExcludingAttributes(htmltext.replace(StaticDataService.regexForComments, ''));
            text = div.innerHTML;
            break;
          case 'step':
              const divStep = document.createElement('div');
              divStep.innerHTML = this.htmlToPlainTextExcludingAttributes(htmltext.replace(StaticDataService.regexForComments, ''));
              text = divStep.innerHTML;
              break;
          case 'recipe':
              const divRecipe = document.createElement('div');
              divRecipe.innerHTML = this.htmlToPlainTextExcludingAttributes(htmltext.replace(StaticDataService.regexForComments, ''));
              text = divRecipe.innerHTML;
              break;
          case 'relatedStoryDescription':
              const divRelatedStoryDesc = document.createElement('div');
              divRelatedStoryDesc.innerHTML = this.htmlToPlainTextExcludingAttributes(htmltext.replace(StaticDataService.regexForComments, ''));
              text = divRelatedStoryDesc.innerHTML;
              break;
          case 'relatedStoryTitle': 
              const divRelatedStoryTitle = document.createElement('div');
              divRelatedStoryTitle.innerHTML = this.htmlToPlainTextExcludingAttributes(htmltext.replace(StaticDataService.regexForComments, ''));
              text = divRelatedStoryTitle.innerHTML;
              break;
          default: break;
        }
        data.content = ev.data.htmlProcessor.toView( text );
      });
      switch (model) {
        case 'paragraph':
          this.paraEditor = ev;
          break;
        case 'caption':
          this.captionEditor = ev;
          break;
        case 'title':
          this.titleEditor = ev;
          break;
        case 'desc':
          this.descriptionEditor = ev;
          break;
        case 'step':
          this.stepEditor = ev;
          this.stepEditorArray.push(this.stepEditor);
        break;
        case 'table':
          this.tableEditor = ev;
        break;
        case 'faq':
          this.faqEditor = ev;
          break;
        case 'recipe':
          this.inlineElementEditor = ev;
          this.recipeEditorArray.push(this.inlineElementEditor);
        break;
        case 'relatedStoryDescription':
          this.relatedStoryDescriptionEditor = ev;
          this.relatedStoryArray.push(this.relatedStoryDescriptionEditor);
          break;
        case 'relatedStoryTitle':
          this.relatedStoryTitleEditor = ev;
          this.relatedStoryTitleArray.push(this.relatedStoryTitleEditor);
          break;
          break;
        default: break;
      }
      if((this.cardData && this.cardData.paragraph && this.cardData.paragraph.body) || (this.tempCardData && this.tempCardData.caption) ||
        (this.cardData && this.cardData.title) || ( this.tempCardData && this.tempCardData.videoImageCaption) ||
        (this.cardData && this.cardData.listicle && this.cardData.listicle.body) ||  (this.cardData && this.cardData.listicle && this.cardData.listicle.title) ||
        (this.cardData && this.cardData.liveBlog && this.cardData.liveBlog.body) || (this.tempReviewData && this.tempReviewData.shortVerdict)
        || (this.tempMovieReviewData && this.tempMovieReviewData.description)
        || (this.tempMovieReviewData && this.tempMovieReviewData.review) || this.tableHTML) {
        this.initilizeEditor(ev, model,type)
      } else {
        this.addOrRemovePlaceholder(ev, model);
      }
    }
    if (label === 'focus') {
      if(ev.editor) {
      if (this.focusTimer === 0 && model !== 'paragraph') {
        this.onelementFocus();
        this.focusTimer += 1;
      }
      const doc = ev.editor.model.document;
      const selection = doc.selection;
      const selrange = selection.getFirstRange();
      const currentSelection = selrange['end']['path'];
      switch (model) {
        case 'paragraph':
          this.focusFlag = true;
          this.currentCardEmit();
          if(this.cardType !== 'listicle' && this.cardType !== 'highlights') {
              this.childKeyDown.emit(true);}
          this.lastSelection.body = currentSelection;
          break;
        case 'caption':
          this.captionFocusFlag = true;
          this.lastSelection.body = currentSelection;
          break;
        case 'title':
          this.titleFocusFlag = true;
          this.lastSelection.title = currentSelection;
          break;
        case 'desc':
          this.descFocusFlag = true;
          this.lastSelection.body = currentSelection;
          break;
        default: break;
      }
      this.addOrRemovePlaceholder(ev.editor, model);
    }
    }
    if (label === 'blur') {
      switch (model) {
        case 'paragraph':
          this.focusFlag = false;
          const el = document.getElementsByClassName('ck-link-form');
          if (!el || el.length === 0) {
            this.onelementBlur();
            this.lastindexfn.emit({
              index: this.ckselection,
              id: this.id,
              cardID: this.cardData.id ? this.cardData.id : null
            });
          }
          this.lastSelection.body = null;
          break;
        case 'caption':
          this.captionFocusFlag = false;
          this.lastSelection.body = null;
          break;
        case 'title':
          this.titleFocusFlag = false;
          this.lastSelection.title = null;
          break;
        case 'desc':
          this.descFocusFlag = false;
          this.lastSelection.body = null;
          break;
        default: break;
      }
      this.addOrRemovePlaceholder(ev.editor, model);
    }
    if (label === 'change') {
    if(this.cardType !== 'highlights') {
      if(type === 'parabody'){
        this.checkingHyperlinkValid(this.paraEditor,type,this.cardData.paragraph.body,this.cardData.id);
      }
      if(type==='liveblogbody'){
        this.checkingHyperlinkValid(this.descriptionEditor,type,this.cardData.liveBlog.body);
      }
      if(type==='caption'){
        this.checkingHyperlinkValid(this.captionEditor,type,this.tempCardData.caption);
      }
      if(type==='title'){
        this.checkingHyperlinkValid(this.titleEditor,type,this.cardData.title);
      }
      if(type==='listiclebody'){
        this.checkingHyperlinkValid(this.descriptionEditor,type,this.cardData.listicle.body);
      }
      if(type==='table'){
        this.checkingHyperlinkValid(this.tableEditor,type,this.tableHTML);
      }
      if(type === 'step'){
        this.checkingHyperlinkValid(this.stepEditorArray[index],model,this.tempHowToStepsData.get('steps')['controls'][index].get('step').value);
      }
      if(type === 'recipe'){
        this.checkingHyperlinkValid(this.recipeEditorArray[index],model,this.tempRecipeData.get('steps')['controls'][index].get('step').value);
      }
      if(model === 'relatedStoryDescription'){
        this.checkingHyperlinkValid(this.relatedStoryArray[index],model,this.tempRelatedStoryForm.get('relatedStoryData')['controls'][index].get('storyDescription').value);
      }
      if(model === 'relatedStoryTitle'){
        this.checkingHyperlinkValid(this.relatedStoryTitleArray[index],model,this.tempRelatedStoryForm.get('relatedStoryData')['controls'][index].get('title').value);
      }
    }

      clearTimeout(this.timer);
      this.timer = setTimeout(e1 => {
        this.doCheck();

      }, (this.id === 'newElement' ? 0 : 500));
    }
    this.ckEditorEnableReadOnlyMode();
    this.ckEditorCheckReadOnlyModeForInlineElement(model,type);
  }


  ckEditorCheckReadOnlyModeForInlineElement(model,type) {
    if(this.faqEditor&&model){
      this.faqEditor.enableReadOnlyMode('disableEditorId')
    }
    if(type ==='disable' && this.inlineElementEditor && model ==='recipe'){
      this.inlineElementEditor.enableReadOnlyMode('disableEditorId')
    }
    if(type ==='disable' && this.stepEditor && model ==='step'){
      this.stepEditor.enableReadOnlyMode('disableEditorId')
    }
  }

  setThisAmazonMeta(elementId,event) {
    this.tempCardData.amazonMeta = event.target.checked;
    this.tempCardData.amazonAds[0].key ='';
    this.tempCardData.amazonAds[0].value = '';
    this.tempCardData.amazonAds[0].isPresent = false;
    this.tempCardData.amazonCheckedItem = false;
    this.tempCardData.amazonTitle = '';
  }

  editAmazonData() {
    this.tempCardData.amazonCheckedItem = false;
  }

  checkItemsAmazonMeta() {
    this.amazonAds = [];
    this.amazonAds.push({ key: this.tempCardData.amazonAds[0].key, value: this.tempCardData.amazonAds[0].value ,isPresent:true});
    this.restService.http_post(this.config.get('product').baseUrl + '/cms/affiliate/checkItems/',
    this.amazonAds, result => {
     if(result.length>0){
      this.tempCardData.amazonAds=result;
      this.tempCardData.amazonCheckedItem = true;
     }})
  }

  findAlltheManualLink(editor, cardData) {
    if(cardData.type === 'paragraph' || (cardData.type === 'liveblog' && this.liveblogCollabEnabled)) {
      let edata = editor.getData();
      let regex = new RegExp(/<a.*?>([^>]*)<\/a>/, 'g');
      let m;
      let words = [];
      do {
        m = regex.exec(edata);
        if (m) {
            words.push(m[1]);
        }
      } while (m);
       this.getAutoBacklingList(words,false);
    }

  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    console.log("charCode",charCode)
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
         return false;
      }
      return true;
  }


  checkingHyperlinkValid(editor,type,data,id?) {
    if(editor && editor.model) {
      const doc = editor.model.document;
      const selection = doc.selection;
      const range = selection.getFirstRange();
      let selectedWord;
      for (const item of range.getItems()) {
        selectedWord = item.data;
    }
      let docStr = (JSON.stringify(doc));
      if(JSON.parse(docStr)['differ']['_cachedChanges'][0]['attributeKey'] === 'linkHref'){
        let hrefUrl = this.sharedService.extractHrefUrl(editor);
          if(hrefUrl !== undefined && hrefUrl !== null) {
            let allLink =  this.sharedService.findInvalidLinkWord(editor);
            let matchLinkObj = allLink.filter(e =>e.href===hrefUrl)
            const validLink = this.checkUrlValidate(hrefUrl,data,type,editor,id);
            if(validLink){
              this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/validate/link/?url='+hrefUrl)
              .subscribe((response) => {
              if(response.statusCode === 200){
              this.getAutoBacklingList(selectedWord,true);
              } else {
              setTimeout(e4 => {
                if(editor) {
                  this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor,id)
                }
              }, 1000);
              this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
            }
          },error=>{
            setTimeout(e4 => {
              if(editor) {
                this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor,id)
              }
            }, 1000);
            this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
            })

          }
          } else {
            if(type==='parabody'){
              this.findAlltheManualLink(this.paraEditor, this.cardData);
              this.manualLinkCountDecr.emit();
              this.paraEditor ? this.paraEditor.setData(this.cardData.paragraph.body): '';
            }
            if(type==='liveblogbody' && this.liveblogCollabEnabled){
              this.findAlltheManualLink(this.descriptionEditor, this.cardData);
              this.manualLinkCountDecr.emit();
              this.descriptionEditor ? this.descriptionEditor.setData(this.cardData.liveBlog.body): '';
            }
          }
      }
    }
     else {
      return true;
    }
  }

  stripHtml(html) {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  checkSplitFeasibility(index, id, callback) {
    this.onelementBlur();
    if (this.isCKEditorEnabled) {
      if (id === 'newElement') {
        if (this.compareSelectionArrays(index.getFirstRange()['end']['path'], [0, 0])) {
          callback('top', null);
        } else {
          callback('bottom', null);
        }
      } else {
        this.paraEditor.model.change(writer => {
          const selection = index;
          const insertPosition = selection.focus;
          writer.insertText('|#+|', {}, insertPosition);
          let text = this.paraEditor.getData();
          text = text.replace(/&nbsp;/gi,'');
          let split = text.split('|#+|');
          split = split.map(st => {
            let checkClosingTag = st;
            checkClosingTag = new DOMParser().parseFromString(checkClosingTag, "text/html").body.innerHTML;
            return checkClosingTag.replace(/|#+|/g, '');
          });
          const plaintext = this.stripHtml(text);
          if (plaintext.indexOf('|#+|') === 0) {
            this.removeExtraChar(text);
            callback('top', null);
          } else if (plaintext.indexOf('|#+|') === (plaintext.length - 4)) {
            this.removeExtraChar(text);
            callback('bottom', null);
          } else if (split.length >= 2) {
            callback('mid', split);
          }
        });
      }
    } else {
      const length = this.paraEditor.getText().length;
      const pretext = this.paraEditor.getText(0, index);
      const posttext = this.paraEditor.getText(index, length);
      if (pretext.trim() === '') {
        callback('top', null);
      } else if (posttext.trim() === '') {
        callback('bottom', null);
      } else {
        callback('mid', null);
      }
    }
  }

  setParagraphData(text) {
    this.paraEditor ? this.paraEditor.setData(text): '';
  }

  removeExtraChar(text) {
    const puretext = text.replace('|#+|', '');
    this.paraEditor ? this.paraEditor.setData(puretext): '';
  }

  setFeedback(result) {
    this.cardData.image.feedback = result;
    this.changeFlag = true;
    this.overrideSave()
  }

  splitParaByIndex(index, arr, callback) {
    if (this.isCKEditorEnabled) {
      callback(arr ? arr[0] : null);
    } else {
      // const length = this.paraEditor.getText().length;
      this.paraEditor.setSelection(0, index);
      const text2: HTMLElement = (this.paraEditor.selection.getRange()[1].native.cloneContents() as HTMLElement);
      const div = document.createElement('div');
      div.appendChild(text2.cloneNode(true));
      const html = div.innerHTML;
      // console.log(html);
      callback(html);
    }
  }

  editorClick(model) {
    if (this.isCKEditorEnabled) {
      let selection;
      if(model === 'paragraph') {
         selection = this.paraEditor.model.document.selection;
      } else if(model === 'desc') {
        selection =  this.descriptionEditor.model.document.selection;
      } else {
        selection = this.paraEditor.model.document.selection;
      }

      this.currentCursorPosition=selection.focus.path[1];
      // console.log('currentCursorPosition',this.currentCursorPosition)
      this.ckselection = selection;
      this.lastindexfn.emit({
        index: this.ckselection,
        id: this.id,
        cardID: this.cardData.id ? this.cardData.id : null
      });
      this.showHyperlinkIcon = false;
      this.currentCardEmit();
      setTimeout(() => {
        this.getSelectedTestForHyperlink();
      }, 10);
      setTimeout(e => {
        this.changeRelativePositionOfHyperlinkIcon();
      },100);

    }
  }
  changeRelativePositionOfHyperlinkIcon() {
    if(this.selectedToRemove && this.selectedToRemove.length !== 0) {
      // console.log(this.selectedToRemove)
      this.showHyperlinkIcon = true;
      setTimeout(() => {
        let range = document.getSelection().getRangeAt(0);
        let rect = range.getBoundingClientRect();
        let scrollPosition = document.documentElement.scrollTop
        let containerTop = scrollPosition + rect.top - 35 + "px";
        let containerLeft = rect.right - rect.width / 2 + "px";
        let backLinkIdData=document.getElementById("backlinkID");
        //only accessible when id present in the dom
        if(!!backLinkIdData){
          document.getElementById("backlinkID").style.top = containerTop;
          document.getElementById("backlinkID").style.left = containerLeft;
        }
        setTimeout(() => {
          this.showHyperlinkIcon = false;
        }, 7000);
      }, 10);
    }
  }
  hyperlinkStoryList(event, model){
    event.stopPropagation();
    this.showHyperlinkIcon = false;
    let editor;
    if(model === 'paragraph') {
      editor = this.paraEditor;
    } else if(model === 'desc') {
      editor = this.descriptionEditor;
    } else {
      editor = this.paraEditor;
    }
    this.chosenEditor = editor;
    if (this.isCKEditorEnabled) {
      const selection = editor.model.document.selection;
      this.isStoryListing = true;
      this.selectedText = editor.getData();
      const range = selection.getFirstRange();
      editor.model.change(writer => {
        const currentAttributes = selection.getAttributes();
        writer.insertText('|#+|', currentAttributes, range.end);
        writer.insertText('|#+|', currentAttributes, range.start);
        this.selectedText = editor.getData();
        const textSplit = this.selectedText.split('|#+|');
        if (textSplit.length > 2) {
          this.topicName = textSplit[1];
          editor ? editor.setData(textSplit.join('')): '';
        }
      });
   } else if(!this.isCKEditorEnabled) {
      this.lenQuill = editor.getSelection();
      const text = editor.getText(this.lenQuill.index, this.lenQuill.length);
      this.topicName = text;
      this.isStoryListing = true;
      this.sharedService.overflowauto();
   }
  }
  getSelectedTestForHyperlink() {
    const selection = this.ckselection['_selection'];
    const selrange = selection['_ranges'][0]
    if (selrange) {
      this.selectedToRemove = {
        index: selrange['start']['path'][1],
        length: selrange['end']['path'][1] - selrange['start']['path'][1],
      }
    } else {
      this.selectedToRemove = {};
      this.showHyperlinkIcon = false;
    }
  }

  compareSelectionArrays(arr1, arr2) {
    return (arr1[0] === arr2[0] && arr1[1] === arr2[1]);
  }

  // @HostListener('window:keyup', ['$event'])
  // public hotkeyup($event) {
  // }

  paragraphKeyUpEvent($event) {
    // console.log('paragraph => keyup');
    const key = $event.keyCode || $event.charCode;
    const doc = this.paraEditor.model.document;
    const selection = doc.selection;
    const selrange = selection.getFirstRange();
    const currentSelection = selrange['end']['path'];

    switch (key) {
      case 40:
      case 39:
        const root = doc.getRoot();
        const totalNodes = root['_children']['length'];
        const lastNode = root['_children']['_nodes'][totalNodes - 1]['_children']['_nodes'];
        const lastNodeLength = lastNode['length'];
        const totalSelection = [
          (totalNodes ? (totalNodes - 1) : 0),
          (lastNodeLength > 0 ? lastNode[lastNodeLength - 1]['offsetSize'] : 0)
        ];
        if (this.compareSelectionArrays(currentSelection, this.lastSelection['body'])
          && this.compareSelectionArrays(currentSelection, totalSelection)) {
          this.focusDown();
          return false;
        }
        break;
      case 38:
      case 37:
        if (this.compareSelectionArrays(currentSelection, this.lastSelection['body'])
          && this.compareSelectionArrays(currentSelection, [0, 0])) {
          this.focusUp();
          return false;
        }
        break;
      case 86:
        this.callRecommendation = true;
        break;
    }
    setTimeout(e => {
      this.lastSelection.body = currentSelection;
    }, 0);
  }

  titleKeyUpEvent($event) {
    // console.log('title => keyup');
    const key = $event.keyCode || $event.charCode;
    const doc = this.titleEditor.model.document;
    const selection = doc.selection;
    const selrange = selection.getFirstRange();
    const currentSelection = selrange['end']['path'];

    switch (key) {
      case 40:
      case 39:
      const root = doc.getRoot();
      const totalNodes = root['_children']['length'];
      const lastNode = root['_children']['_nodes'][totalNodes - 1]['_children']['_nodes'];
      const lastNodeLength = lastNode['length'];
      const totalSelection = [
        (totalNodes ? (totalNodes - 1) : 0),
        (lastNodeLength > 0 ? lastNode[lastNodeLength - 1]['offsetSize'] : 0)
      ];
      if (this.compareSelectionArrays(currentSelection, this.lastSelection['title'])
        && this.compareSelectionArrays(currentSelection, totalSelection)) {
        if (this.cardData['type'] === 'listicle' || this.cardType === 'highlights') {
          this.descriptionEditor.editing.view.focus();
        }
        if (this.cardData['type'] === 'liveblog' || this.cardType === 'newsroom' ||this.cardType === 'mintlite' ) {
          if (this.cardData.liveBlog.inlineElementId) {
            this.liveblogLeadElement['_results'][0].setFocusOnThis(null);
          } else {
            this.descriptionEditor.editing.view.focus();
          }
        }
        return false;
      }
      break;
    case 38:
    case 37:
      if (this.compareSelectionArrays(currentSelection, this.lastSelection['title'])
        && this.compareSelectionArrays(currentSelection, [0, 0])) {
        this.focusUp();
        return false;
      }
      break;
    }
    setTimeout(e => {
      this.lastSelection.title = currentSelection;
    }, 0);
  }

  descriptionKeyUpEvent($event) {
    // console.log('body => keyup');
    const key = $event.keyCode || $event.charCode;
    const doc = this.descriptionEditor.model.document;
    const selection = doc.selection;
    const selrange = selection.getFirstRange();
    const currentSelection = selrange['end']['path'];
    switch (key) {
      case 40:
      case 39:
      const root = doc.getRoot();
      const totalNodes = root['_children']['length'];
      const lastNode = root['_children']['_nodes'][totalNodes - 1]['_children']['_nodes'];
      const lastNodeLength = lastNode['length'];
      const totalSelection = [
        (totalNodes ? (totalNodes - 1) : 0),
        (lastNodeLength > 0 ? lastNode[lastNodeLength - 1]['offsetSize'] : 0)
      ];
      if (this.compareSelectionArrays(currentSelection, this.lastSelection['body'])
        && this.compareSelectionArrays(currentSelection, totalSelection)) {
        this.focusDown();
        return false;
      }
      break;
    case 38:
    case 37:
      if (this.compareSelectionArrays(currentSelection, this.lastSelection['body'])
        && this.compareSelectionArrays(currentSelection, [0, 0])) {
        if (this.cardData['type'] === 'listicle' || this.cardType === 'highlights') {
          if (this.cardData.listicle.inlineElementId) {
            this.listicleLeadElement['_results'][0].setFocusOnThis(null);
          } else if (this.titleEditor) {
            this.titleEditor.editing.view.focus();
          }
          this.focusUp();
        }
        if (this.cardData['type'] === 'liveblog' || this.cardType === 'newsroom') {
          if (this.cardData.liveBlog.inlineElementId) {
            this.liveblogLeadElement['_results'][0].setFocusOnThis(null);
          } else {
            this.titleEditor.editing.view.focus();
          }
        }
      }
      break;
    }
    setTimeout(e => {
      this.lastSelection.body = currentSelection;
    }, 0);
  }

  // @HostListener('keydown', ['$event'])
  public hotkeys($event) {
    // console.log('element common =>  keydown');
    this.onElementChange($event);
    const key = $event.keyCode || $event.charCode;
    if (this.focusFlag || this.captionFocusFlag || this.titleFocusFlag || this.descFocusFlag) {
      clearTimeout(this.timer);
      this.timer = setTimeout(e1 => {
        this.doCheck();
      }, (this.id === 'newElement' ? 0 : 500));
    }
    switch (key) {
      case 27:
      if (this.isLightbox || this.leadMediaImageToggle || this.isPhotopopup) {
        this.disableshowGallery();
        $event.stopPropagation();
      }
      if (this.replaceImagePopup) {
        this.replaceImagePopup = false;
        $event.stopPropagation();
      }
      if (this.showRelatedStoryPopup) {
        if(this.relatedStoryType=='howto'){
          this.closeRelatedStoryModalHowto(null);
          $event.stopPropagation();
        }else{
          this.closeRelatedStoryModal(null);
          $event.stopPropagation();
        }
      }
      if (this.videoUrlPopup) {
        this.cancelChangeVideo();
        $event.stopPropagation();
      }
      if (this.embedPopup) {
        this.closeEmbedPopup();
        this.resetOtherAffiliate();
        $event.stopPropagation();
      }
      if (this.howToStepsInlineImageFlag || this.recipeInlineImageFlag) {
        this.disableStepsInlineImage();
      }
      if (this.showCropper || this.showHowToStepsCropper || this.showRecipeStepsCropper) {
        this.cancelCropping();
        $event.stopPropagation();
      }
      if (this.quotePopup) {
        this.closeQuote();
        $event.stopPropagation();
      }
      break;
    case 40:
    case 39:
      if (this.cursorFocus && this.EditMode && this.typesWithoutEditor.includes(this.cardType)) {
        this.nextFocusEmit.emit({
          current: this.id,
          pos: 'start'
        });
        this.cursorFocus = false;
        this.isCursorHovering = false;
      }
      break;
    case 38:
    case 37:
      if (this.cursorFocus && this.EditMode && this.typesWithoutEditor.includes(this.cardType)) {
        this.previousFocusEmit.emit({
          current: this.id
        });
        this.cursorFocus = false;
        this.isCursorHovering = false;
      }
      break;
    }
    // if (key === 8 && $event.altKey) {
    //   this.nextFocusEmit.emit({
    //     current: this.id,
    //     pos: 'start'
    //   });
    //   this.deleteElement();
    // }
  }

  paragraphKeyDownEventCk($event) { //rohit
    // console.log('paragraph => keydown');
    const key = $event.keyCode || $event.charCode;
    // console.log('paragraph => keydown' + key);
    const ctrl_shift = (($event.ctrlKey || $event.metaKey) && $event.shiftKey);
    const selection = this.paraEditor.model.document.selection;
    this.ckselection = selection;
    const b = this.paragraphElement.nativeElement.getElementsByClassName('ck-toolbar__items');
    const a = b[0].children;
    this.lastindexfn.emit({
      index: this.ckselection,
      id: this.id,
      cardID: this.cardData.id ? this.cardData.id : null
    });
    // console.log('paragraph => keydown' + key);
    this.currentCardEmit();
    switch (key) {
      case 49:
        if (ctrl_shift) {
         // console.log('number point');
          $event.preventDefault();
          if (a.length > 0) {
            a[0].click();
          }
          $event.stopPropagation();
        }
        break;
      case 52:
        if (ctrl_shift) {
          this.paraEditor.model.change(writer => {
            this.paraEditor.model.insertContent(writer.createText('₹'), selection);
          });
        }
        break;
      case 50:
        if (ctrl_shift) {
          console.log('bullet point');
          $event.preventDefault();
          if (a.length > 1) {
            a[1].click();
          }
          $event.stopPropagation();
        }
        break;
      case 72:
        if (ctrl_shift) {
          console.log('hyperlink');
          $event.preventDefault();
          if (a.length > 2) {
            a[2].click();
          }
          $event.stopPropagation();
        }
        break;
      case 188:
        if (ctrl_shift) {
          console.log('H2');
          $event.preventDefault();
          console.log(b)
          this.paraEditor.execute('heading', { value: 'heading2' } )
          $event.stopPropagation();
        }
        break;
      case 190:
        if (ctrl_shift) {
          console.log('H3');
          $event.preventDefault();
          console.log(b)
          this.paraEditor.execute('heading', { value: 'heading3' } )
          $event.stopPropagation();
        }
        break;
      case 77:
          if (ctrl_shift) {
            console.log('P');
            $event.preventDefault();
            console.log(b)
            this.paraEditor.execute('paragraph', { value: 'paragraph' } )
            $event.stopPropagation();
          }
          break;
      case 85:
        if (ctrl_shift && this.sharedService.isdomainConfig('story','isStoryListingEnabled')) {
          $event.preventDefault();
          this.isStoryListing = true;
          this.selectedText = this.paraEditor.getData();
          const range = selection.getFirstRange();
          this.paraEditor.model.change(writer => {
            const currentAttributes = selection.getAttributes();
            writer.insertText('|#+|', currentAttributes, range.end);
            writer.insertText('|#+|', currentAttributes, range.start);
            this.selectedText = this.paraEditor.getData();
            const textSplit = this.selectedText.split('|#+|');
            if (textSplit.length > 2) {
              this.topicName = textSplit[1];
              this.paraEditor ? this.paraEditor.setData(textSplit.join('')):'';
            }
          });
          $event.stopPropagation();
          }
        break;
      case 89:
        if (ctrl_shift && this.showTopicListing()) {
          $event.preventDefault();
          this.isPageListing = true;
          this.selectedText = this.paraEditor.getData();
          const range = selection.getFirstRange();
          this.paraEditor.model.change(writer => {
            const currentAttributes = selection.getAttributes();
            writer.insertText('|#+|', currentAttributes, range.end);
            writer.insertText('|#+|', currentAttributes, range.start);
            this.selectedText = this.paraEditor.getData();
            const textSplit = this.selectedText.split('|#+|');
            if (textSplit.length > 2) {
              this.topicName = textSplit[1];
              this.paraEditor ? this.paraEditor.setData(textSplit.join('')): '';
            }
          });
          $event.stopPropagation();
          }
        break;
      case 114:
        if ($event.shiftKey) {
          $event.preventDefault();
          const range = selection.getFirstRange();
          this.paraEditor.model.change(writer => {
            const currentAttributes = selection.getAttributes();
            writer.insertText('|#+|', currentAttributes, range.end);
            writer.insertText('|#+|', currentAttributes, range.start);
            const text = this.paraEditor.getData();
            const textSplit = text.split('|#+|');
            if (textSplit.length > 2) {
              const content = textSplit[1];
              textSplit[1] = (this.stripHtml(content) === this.stripHtml(content).toUpperCase())
                ? content.toLowerCase() : content.toUpperCase();
              const totalPara = textSplit.join('');
              this.paraEditor ? this.paraEditor.setData(totalPara): '';
              // this.paraEditor.model.modifySelection(selection, { direction: 'bakcward' });
            }
          });
          $event.stopPropagation();
        }
        break;
      case 86:
        this.callRecommendation = true;
        break;
    }
  }


  copySelectedText() {
    const text = this.paraEditor.getSelection();
    this.selectedToRemove = text;
  }

  removeHyperlinkSelection(ev) {
    if(!this.isCKEditorEnabled){
      this.paraEditor.removeFormat(this.selectedToRemove.index, this.selectedToRemove.length);
      setTimeout(e4 => {
        this.changeFlag = true;
      }, 1000);
      this.selectedToRemove.length = 0;
    } else {
      this.paraEditor.model.change(writer => {
        writer.clearAttributes( this.ckselection['_selection']['_ranges'][0] );
      });
      this.selectedToRemove.length = 0;
    }
  }

  captionKeyDownEventCk($event) {
    // console.log('caption => keydown');
    const key = $event.keyCode || $event.charCode;
    const selection = this.captionEditor.model.document.selection;
    this.ckselection = selection;
    const ctrl_shift = (($event.ctrlKey || $event.metaKey) && $event.shiftKey);
    switch (key) {
      case 52:
      if (ctrl_shift) {
        this.captionEditor.model.change(writer => {
          this.captionEditor.model.insertContent(writer.createText('₹'), selection);
        });
      }
      break;
      case 72:
      if (this.sharedService.isdomainConfig('story','captionStripTagDisabled') && ctrl_shift) {
        console.log('hyperlink');
        const b = this.captionElement.nativeElement.getElementsByClassName('ck-toolbar__items');
        const a = b[0].children;
        $event.preventDefault();
        if (a.length > 2) {
          a[2].click();
        }
        $event.stopPropagation();
      }
      break;
      case 114:
      if ($event.shiftKey) {
        $event.preventDefault();
        const range = selection.getFirstRange();
        this.captionEditor.model.change(writer => {
          const currentAttributes = selection.getAttributes();
          writer.insertText('|#+|', currentAttributes, range.end);
          writer.insertText('|#+|', currentAttributes, range.start);
          const text = this.captionEditor.getData();
          const textSplit = text.split('|#+|');
          if (textSplit.length > 2) {
            const content = textSplit[1];
            textSplit[1] = (this.stripHtml(content) === this.stripHtml(content).toUpperCase())
              ? content.toLowerCase() : content.toUpperCase();
            const totalPara = textSplit.join('');
            this.captionEditor ? this.captionEditor.setData(totalPara): '';
          }
        });
        $event.stopPropagation();
      }
      break;
    }
  }

  deleteAutoBacklingAndList(elementId){
    if(this.isCKEditorEnabled === false) {
      if(this.cardData.type === 'paragraph') {
        let hyperlinkWordLIst = [];
        let paraContent = this.paraEditor.getContents();
        for(let i of paraContent['ops']) {
          if(i['attributes'] && i['attributes']['link']) {
            hyperlinkWordLIst.push(i['insert'])
          }
        }
        if(hyperlinkWordLIst.length > 0) {
          this.removeHyperlinkPara(hyperlinkWordLIst ,res => {
                  this.changeFlag = true;
                });
        }
      }
    } else {
      let domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      let cardData = JSON.parse(JSON.stringify(StaticDataService.defaultAutoBackLinkSuggestedList));
        cardData.articleId = elementId
        cardData.domainId = domainId;
    }
      this.sharedService.removeAllFormatLinks(this.paraEditor, this.cardData)
    }

  deleteBacklinking(){
    if(this.isCKEditorEnabled === false) {
      if(this.cardData.type === 'paragraph') {
        let hyperlinkWordLIst = [];
        let paraContent = this.paraEditor.getContents();
        for(let i of paraContent['ops']) {
          if(i['attributes'] && i['attributes']['link']) {
            hyperlinkWordLIst.push(i['insert'])
          }
        }
        if(hyperlinkWordLIst.length > 0) {
          this.removeHyperlinkPara(hyperlinkWordLIst ,res => {
                  this.changeFlag = true;
                });
        }
      }
    } else {
      if(this.enableContentRecommendation && this.autoBacklinkResponse && this.autoBacklinkResponse.recommendedLinkedContent!= null){
        this.autoBacklinkResponse.recommendedLinkedContent = null;
        this.autoBacklinkResponse.manualBacklinkList = [];
      }
      this.sharedService.removeAllFormatLinks(this.paraEditor, this.cardData)
    }
  }
  removeHyperlinkPara(listOfWords, callback) {
    for (let w of listOfWords) {
      if(w) {
      let result =  this.sharedService.findOccurenceInPara(this.paraEditor.getText(), w);
      this.removeHyperLink(result, w);
      }
    }
    setTimeout(e4 => {
      callback();
    }, 1000);
  }
  removeHyperLink(positions, word) {
    for(let i of positions) {
      this.paraEditor.removeFormat(i, word.length);
    }
  }


  titleKeyDownEventCk($event) {
    // console.log('title => keydown');
    const key = $event.keyCode || $event.charCode;
    const selection = this.titleEditor.model.document.selection;
    this.ckselection = selection;
    const ctrl_shift = (($event.ctrlKey || $event.metaKey) && $event.shiftKey);
    switch (key) {
      case 52:
        if (ctrl_shift) {
          this.titleEditor.model.change(writer => {
            this.titleEditor.model.insertContent(writer.createText('₹'), selection);
          });
        }
        break;
      case 114:
        if ($event.shiftKey) {
          $event.preventDefault();
          const range = selection.getFirstRange();
          this.titleEditor.model.change(writer => {
            const currentAttributes = selection.getAttributes();
            writer.insertText('|#+|', currentAttributes, range.end);
            writer.insertText('|#+|', currentAttributes, range.start);
            const text = this.titleEditor.getData();
            const textSplit = text.split('|#+|');
            if (textSplit.length > 2) {
              const content = textSplit[1];
              textSplit[1] = (this.stripHtml(content) === this.stripHtml(content).toUpperCase())
                ? content.toLowerCase() : content.toUpperCase();
              const totalPara = textSplit.join('');
              this.titleEditor ? this.titleEditor.setData(totalPara): '';
            }
          });
          $event.stopPropagation();
        }
        break;
    }
  }



  descriptionKeyDownEventCk($event) {
    // console.log('body => keydown');
    const key = $event.keyCode || $event.charCode;
    const selection = this.descriptionEditor.model.document.selection;
    this.ckselection = selection;
    const b = this.descriptionElement.nativeElement.getElementsByClassName('ck-toolbar__items');
    const a = b[0].children;
    const ctrl_shift = (($event.ctrlKey || $event.metaKey) && $event.shiftKey);
    switch (key) {
      case 49:
        if (ctrl_shift) {
          console.log('number point');
          $event.preventDefault();
          if (a.length > 0) {
            a[0].click();
          }
          $event.stopPropagation();
        }
        break;
      case 52:
        if (ctrl_shift) {
          this.descriptionEditor.model.change(writer => {
            this.descriptionEditor.model.insertContent(writer.createText('₹'), selection);
          });
        }
        break;
      case 50:
        if (ctrl_shift) {
          console.log('bullet point');
          $event.preventDefault();
          if (a.length > 1) {
            a[1].click();
          }
          $event.stopPropagation();
        }
        break;
      case 72:
        if (ctrl_shift) {
          console.log('hyperlink');
          $event.preventDefault();
          if (a.length > 2) {
            a[2].click();
          }
          $event.stopPropagation();
        }
        break;
      case 114:
        if ($event.shiftKey) {
          $event.preventDefault();
          const range = selection.getFirstRange();
          this.descriptionEditor.model.change(writer => {
            const currentAttributes = selection.getAttributes();
            writer.insertText('|#+|', currentAttributes, range.end);
            writer.insertText('|#+|', currentAttributes, range.start);
            const text = this.descriptionEditor.getData();
            const textSplit = text.split('|#+|');
            if (textSplit.length > 2) {
              const content = textSplit[1];
              textSplit[1] = (this.stripHtml(content) === this.stripHtml(content).toUpperCase())
                ? content.toLowerCase() : content.toUpperCase();
              const totalPara = textSplit.join('');
              this.descriptionEditor ? this.descriptionEditor.setData(totalPara): '';
            }
          });
          $event.stopPropagation();
        }
        break;
    }
  }

  ngOnInit() {
    if (this.preLoadedcardData && (this.cardId === this.preLoadedcardData.id)) {
      this.loadView(true);
    } else {
      this.loadView(false);
    }
    this.amazonAdDisplay = this.sharedService.isdomainConfig('story','amazonMeta');
      this.sharedService.sendData('storyEditor|true');
    const Link = Quill.import('formats/link');
    Link.sanitize = function (url) {
      if (url.indexOf('https://') > -1 || url.indexOf('http://') > -1) {
        return url;
      }
      return 'http://' + url;
    };
    this.sharedService.autoMultipleStockUpdates.subscribe(res=>{
      if(this.cardData.type==="market" && this.cardData.metadata.stockType==="auto"){
      this.cardData = res;
      this.overrideSave();
    }
    });
    if(this.storySlug && this.id === "newLiveblogElement")
    {
      this.cardData.title = this.storySlug + this.cardData.title;
    }
  }

  ngOnChanges(changes) {
    if(this.cardData && this.cardData.type === 'paragraph') {
      if(changes.preLoadedcardData) {
        this.paraContentChanged.emit(true);
      }
    }
    this.removeLinkArraySet();
    this.ckEditorEnableReadOnlyMode();
  }

  removeLinkArraySet(){
    if(this.removedBacklinkList && this.removedBacklinkList!==null) {
      this.removedBacklinkList = this.removedBacklinkList
    } else {
      this.removedBacklinkList = [];
    }
  }

  reload()
  {
    this.loadView(false);
  }

  increasePendingCount() {
    this.requestInQueue += 1;
    this.incrementPendingRequest.emit();
  }
  decreasePendingCount() {
    if (this.requestInQueue > 0) {
      this.requestInQueue -= 1;
      this.decrementPendingRequest.emit();
    }
  }
  hoverEnter() { this.isCursorHovering = true; }
  hoverLeave() { this.isCursorHovering = false;}
  onEditorChange(ev) {
    console.log(ev);
  }


  getFullDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      const res = (
        ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours())
        + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes())
        + ', '
        + date.getDate()
        + ' '
        + (this.monthNames[date.getMonth()])
      );
      return res;
    } else {
      return 'not present';
    }
  }

  getNewTypeDate(datestring) {
    const dt = new Date(datestring.replace('+0000', 'Z'));
    return this.getFullDate(Math.round(dt.getTime()));
  }

  triggerFetchUpdate(ev) {
    if (this.cardData && this.cardData !== null && this.cardData.id !== null
      && (!this.cardData.firstPublishedDate || this.cardData.firstPublishedDate === null)) {
      setTimeout(e4 => {
        this.restService.http_get(
          this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, this.get_api)
          + '/'
          + String(this.cardId)
        )
          .subscribe(
            data => {
              this.cardData['metadata']['status'] = data['metadata']['status'];
              this.cardData['firstPublishedDate'] = data['firstPublishedDate'];
              this.cardData['lastModifiedDate'] = data['lastModifiedDate'];
              this.cardData['lastModifiedByUserName'] = data['lastModifiedByUserName'];
              this.cardData['lastModifiedBy'] = data['lastModifiedBy'];
              this.cardData['lastPublishedDate'] = data['lastPublishedDate'];
              this.cardData['lastPublishedBy'] = data['lastPublishedBy'];
              this.cardData['firstPublishedDate'] = data['firstPublishedDate'];
            },
            error => {
              // could not fetch date
            });
      }, 900);
    }
  }



  focusUp() {
    this.previousFocusEmit.emit({current: this.id});
  }
  focusDown() {
    this.nextFocusEmit.emit({current: this.id,pos: 'start'});
  }

  focusOnElement(ev, direction) {
    if (direction === 'up') {
      this.titleEditor.focus();
    }
    if (direction === 'down') {
      this.descriptionEditor.setSelection(0, 0);
    }
  }

  ngAfterViewInit() {
    if (document.getElementsByTagName('ng2-pdfjs-viewer')[0]
      && document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0]
      && document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0]
        .contentDocument.getElementsByClassName('page')[0]) {
      const heightPdf = document.getElementsByTagName('ng2-pdfjs-viewer')[0]
        .getElementsByTagName('iframe')[0].contentDocument.getElementsByClassName('page')[0].clientHeight;
      // console.log("height of pdf.." + height);
      document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0]
        .setAttribute('style', 'height:' + heightPdf + 'px;');
    }
  }

  deleteKeys(cardVar) {
    if (cardVar) {
      delete cardVar['createdDate'];
      delete cardVar['lastModifiedDate'];
      delete cardVar['createdDate'];
      delete cardVar['lastModifiedDate'];
      delete cardVar['lockedByUserId'];
      delete cardVar['lockedByUserName'];
      if (cardVar['metadata'] && cardVar['metadata']['wordCount']) {
        delete cardVar['metadata']['wordCount'];
      }
    }
  }

  ngDoCheck() {
    const self = this;
    let localtempvar = self.cardData ? JSON.parse(JSON.stringify(self.cardData)) : null;
    // let localvar = self.tempCardData ? $.extend(true, {}, self.tempCardData) : null;
    let localvar = self.tempCardData ? Object.assign({}, self.tempCardData) : null;
    this.deleteKeys(localtempvar);
    this.deleteKeys(this.lastCardForChange);

    const cochange = this.getDifference(this.lastCardForChange ? JSON.stringify(this.lastCardForChange) : '',
    localtempvar ? JSON.stringify(localtempvar) : '');
    const cotempchange = this.getDifference(this.lastCardForImageChange ? this.lastCardForImageChange : '',
    localvar ? JSON.stringify(localvar) : '');
    if (this.cardLoaded && (cochange !== '' || cotempchange !== '')) {
      if (cochange !== '') {
        this.lastCardForChange = localtempvar;
      }
      if (cotempchange !== '') {
        this.lastCardForImageChange = JSON.stringify(localvar);
      }
      if (this.firstLoadCheck > 0) {
        this.sendCardDataToStory(this.cardData);
      }
      this.firstLoadCheck++;
    }
  }

  doCheck() {
    const self = this;
    let localtempvar = self.cardData ? JSON.parse(JSON.stringify(self.cardData)) : null;
    // let localvar = self.tempCardData ? $.extend(true, {}, self.tempCardData) : null;
    let localvar = self.tempCardData ? Object.assign({}, self.tempCardData) : null;
    this.deleteKeys(localtempvar);
    this.deleteKeys(this.lastCardData);


    const cochange = this.getDifference(this.lastCardData ? JSON.stringify(this.lastCardData) : '',
      localtempvar ? JSON.stringify(localtempvar) : '');
    const cotempchange = this.getDifference(this.lastCardTempData ? this.lastCardTempData : '', localvar ? JSON.stringify(localvar) : '');

    if (cochange !== '') {
      this.lastCardData = localtempvar;
      this.resgisterDataChangeToParent(this.cardData);
      this.changeFlag = true;
    }

    if (this.cardLoaded && cotempchange !== '') {
      this.temporaryChangesFlag = true;
      this.lastCardTempData = JSON.stringify(localvar);
      this.resgisterDataChangeToParent(this.cardData);
    }

  }

  loadView(flagForData) {
    if (this.cardId === null || this.cardId === '') {
      if (this.cardType && (this.cardType === 'listicle' || this.cardType === 'highlights')) {
        this.cardData = JSON.parse(JSON.stringify(StaticDataService.defaultListicleCardData));
        this.cardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        this.cardData.type = this.cardType;
        this.editCardId = this.cardId;
        this.cardLoaded = true;
        this.focusFlag = true;
      } else if (this.cardType && (this.cardType === 'liveblog' || this.cardType === 'mintlite'|| this.cardType === 'newsroom')) {
        this.cardData = JSON.parse(JSON.stringify(StaticDataService.defaultLiveblogCardData));
        this.cardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        this.cardData.type = this.cardType;
        this.editCardId = this.cardId;
        this.cardLoaded = true;
        this.focusFlag = true;
      } else if (this.cardType && (this.cardType === 'image') && this.storytype === 'photostory') {
        this.cardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
        this.cardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        this.cardData.type = 'image';
        this.editCardId = this.cardId;
        this.cardLoaded = true;
        this.focusFlag = true;
      } else if (this.cardType && (this.cardType === 'gif') && this.storytype === 'story') {
        this.cardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageGifCardData));
        this.cardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        this.cardData.type = 'gif';
        this.editCardId = this.cardId;
        this.cardLoaded = true;
        this.focusFlag = true;
      } else if (this.cardType && this.cardType === 'relatedstory') {
        this.cardData = JSON.parse(JSON.stringify(StaticDataService.defaultRelatedStoryCardData));
        this.cardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        this.editCardId = this.cardId;
        this.cardLoaded = true;
        this.focusFlag = true;

      } else if (this.cardType && this.cardType === 'alsoread') {
        this.cardData = JSON.parse(JSON.stringify(StaticDataService.defaultAlsoReadCardData));
        this.cardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        this.editCardId = this.cardId;
        this.cardLoaded = true;
        this.focusFlag = true;

      } else if (this.cardType && this.cardType === 'relatedstoryhowto') {
        this.cardData = JSON.parse(JSON.stringify(StaticDataService.defaultRelatedHowtoStoryCardData));
        this.cardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        this.editCardId = this.cardId;
        this.cardLoaded = true;
        this.focusFlag = true;
      }
      else {
        this.cardType = 'paragraph';
        this.cardData = JSON.parse(JSON.stringify(StaticDataService.defaultParagraphCardData));
        this.cardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        this.editCardId = this.cardId;
        this.cardLoaded = true;
        this.getAutoBacklinkData();
        this.generateCardAutoSaveInterval();
      }
    } else {
      // console.log(flagForData);
      if (flagForData) {
        this.initializeCard(this.preLoadedcardData);
      } else {
        this.restService.http_get(
          this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, this.get_api)
          + '/'
          + String(this.cardId)
        )
          .subscribe(
            data => {
              //reseting paragraph when we hit backlink first time.
              //while creating paragraph/story.
              //so that autobacklinking paragraph can be upated and shown on CMS screen
              if(data && data.paragraph &&  data.paragraph.body && this.cardData && this.cardData.paragraph && this.cardData.paragraph.body) {
                //console.log( this.cardData)
                this.cardData.paragraph.body=data.paragraph.body;
              }
              this.resgisterDataChangeToParent(data);
              this.initializeCard(data);
              this.updateCardDatafn.emit(data);
            },
            error => {
              // console.log(error);
              this.editCardFlag = false;
              this.ckEditorEnableReadOnlyMode();
            });
      }

    }
  }

  initiateSocket(id) {
  }

  updatePhotoStoryLeadMedia(data){
    this.setPhotoStoryLeadMedia.emit(data);
  }

  resgisterDataChangeToParent(data) {
    if ((data !== null && data.id !== null) && (this.id !== 'newListElement') && (this.id !== 'newLiveblogElement') && (this.id !== 'newPhotoStoryElement')) {
      this.updateContentOnParent.emit(data);
    }
  }

  removeCardDataAfterAutoSave(id) {
    if (id) {
      this.removeSavedCardData.emit(id);
    }
  }

  sendCardDataToStory(data) {
    if (data.id) {
      this.cardDataFromElement.emit(data);
    }
  }

  initializeCard(data) {
    if(this.cardTypeGif !== 'gif')
    {
    this.cardType = data['type'];
    } else
    {
      this.cardType = 'gif';
    }
    //this.cardType = data['type'];
    this.cardLoaded = true;
    this.cardData = data;
    this.getAutoBacklinkData();

    this.calculateElementWordCount({
      id: data.id,
      count: data.metadata.wordCount
    });
    this.temporaryChangesFlag = false;
    this.afterInitializeEmit.emit(this.cardId);
    this.mapLeadMediaObject();
    if (data['type'] === 'video') {
      if(data.video.saranyuEmbedBody){
      this.video_iframe_html = this.makeRenderable(data.video.saranyuEmbedBody);
      }
      else{
      this.video_iframe_html = this.makeRenderable(data.video.body);
      }
       if(data.video.youtubeEmbedBody) {
         this.video_iframe_html = this.makeRenderable(data.video.youtubeEmbedBody);
       }
      if (this.cardData.video.body && !this.cardData.video.embedUrl) {
        if (this.cardData.video.body.indexOf('src="//players.brightcove.net') > -1) {
          if (this.cardData.video.body.split('src="') && this.cardData.video.body.split('src="') !== null
            && this.cardData.video.body.split('src="').length > 1) {
            if (this.cardData.video.body.split('src="')[1].split('"')[0].charAt(0) === '/') {
              this.cardData.video.embedUrl = 'https:' + this.cardData.video.body.split('src="')[1].split('"')[0];
              this.cardData.video.body = this.cardData.video.body.replace('src="', 'src="https:');
            } else {
              this.cardData.video.embedUrl = this.cardData.video.body.split('src="')[1].split('"')[0];
            }
          }
        } else if (this.cardData.video.body.indexOf('src=\'//players.brightcove.net') > -1) {
          if (this.cardData.video.body.split('src=\'') && this.cardData.video.body.split('src=\'') !== null
            && this.cardData.video.body.split('src=\'').length > 1) {
            if (this.cardData.video.body.split('src=\'')[1].split('\'')[0].charAt(0) === '/') {
              this.cardData.video.embedUrl = 'https:' + this.cardData.video.body.split('src=\'')[1].split('\'')[0];
              this.cardData.video.body = this.cardData.video.body.replace('src=\'', 'src=\'https:');
            } else {
              this.cardData.video.embedUrl = this.cardData.video.body.split('src=\'')[1].split('\'')[0];
            }
          }
        } else {
          this.cardData.video.embedUrl = this.cardData.video.body.split('src="')[1].split('"')[0] ?
            this.cardData.video.body.split('src="')[1].split('"')[0] : this.cardData.video.body.split('src=\'')[1].split('\'')[0];
        }
      }
    }

    if (data['type'] === 'paragraph') {
      this.generateCardAutoSaveInterval();
    }

    if (data['type'] === 'embed') {
      this.trustedHTML = this.makeRenderable(this.sharedService.escToText(data.embed.body));
      this.sharedService.runEmbedProcessor(data.embed.body, this.embedElement);
    }

    if(data['type'] === 'listicleElement') {
      if(data.listicleArray.length>0){
        data.listicleArray.forEach((list) => {
          if(list.mediaType === 'embed') {
            this.sharedService.runEmbedProcessor(list.media.embedCode, this.embedElement);
          }
        })
      }
    }

    if (data['type'] === 'quote') {
      this.quoteHTML = this.text2HTMLQuote(data.paragraph.body).replace(/<\p><\/p>/gm, '').replace(/<br ?\/?>/g, '');
    }

    if (this.cardType === 'image' || this.cardType === 'gif') {
      this.editCardFlag = false;
      this.ckEditorEnableReadOnlyMode();
      this.loaded = false;
      if (!this.cardData.image.images['original']) {
        this.cardData.image.images['original'] = this.sharedService.getImageOnPriority(this.cardData['image']['images'], 'original');
      }
      const regex = new RegExp('www.livemint.com', 'g');
      // for (const key of Object.keys(this.cardData.image.images)) {
      //   if (this.cardData.image.images[key] && (this.cardData.image.images[key].indexOf('www.livemint.com') > -1)) {
      //     this.cardData.image.images[key] = this.cardData.image.images[key].replace(regex, 'images.livemint.com');
      //   }
      // }
      if (data.hasOwnProperty('parentElementId')) {
        if (data['parentElementId'] === 0) {
          this.emitParentImageId.emit(data['id']);
        } else {
          this.emitParentImageId.emit(data['parentElementId']);
        }
      } else {
        this.emitParentImageId.emit(data['id']);
      }
      this.viewImage = (this.cardData.image !== null && this.cardData.image.images !== null) ? this.sharedService.getImageOnPriority(this.cardData.image.images, '960x540') : null
    }
    if (data['type'] === 'listicle' || data['type'] === 'liveblog' || data['type'] === 'highlights' || data['type'] === 'newsroom') {
      this.onelementFocus();
      this.generateCardAutoSaveInterval();
    }
    if(this.storytype === 'photostory' && data['type'] === 'image') {
      this.onelementFocus();
      this.generateCardAutoSaveInterval();
    }
    if(data['type'] === 'alsoread') {
      console.log("Also Read Element");
      // if(Object.keys(this.cardData.alsoReadStories).length !== this.cardData.alsoReadStoryIdList.length) {
        let alsoRead = {};
        let alsoReadUrl = {};
        for(let story_id of this.cardData.alsoReadStoryIdList) {
          if(!this.cardData.alsoReadStories[story_id]) {
            this.restService.http_get(this.config.get('product').baseUrl
                + this.config.getEndPoint(this.config.get('views'), StaticDataService.story_page_id,  StaticDataService.story_get_api)
                + '/' + story_id)
                .subscribe(
                  data => {
                    if(!alsoRead[story_id]) {
                      alsoRead[story_id] = data.mobileHeadline;
                      alsoReadUrl[story_id] = data.metadata.url;
                    }
                  },
                  error => {
                    // console.log(error);
                  });
          } else {
            alsoRead[story_id] = this.cardData.alsoReadStories[story_id];
            alsoReadUrl[story_id] = this.cardData.alsoReadStoriesUrl[story_id];
          }
        }
        setTimeout(() => {
          // console.log(alsoRead)
          this.cardData.alsoReadStories = {};
          this.cardData.alsoReadStoriesUrl = {};
          this.cardData.alsoReadStories = alsoRead;
          this.cardData.alsoReadStoriesUrl = alsoReadUrl;
          this.changeFlag = true;
          this.overrideSave()
        }, 3000);

    }
    this.changeRelated.emit(this.cardData.relatedStories);
    this.changeRelatedHowto.emit(this.cardData.relatedStoriesHowTo);
    this.lastCardData = JSON.parse(JSON.stringify(this.cardData));
    this.lastCardForChange = JSON.parse(JSON.stringify(this.cardData));
  }

  refreshImage() {
    this.viewImage = (this.cardData && this.cardData.image !== null && this.cardData.image.images !== null) ? this.sharedService.getImageOnPriority(this.cardData.image.images, '960x540') + "?" + new Date().getTime() : null
  }

  lockRelease(card_id, callback) {
    if (this.isLocked === true) {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockRelease_api)
        + '?articleId='
        + String(card_id)
      )
        .subscribe(
          data => {
            this.isLocked = false;
            callback(data);
          },
          error => {
            callback(false);
          });
    } else {
      callback(true);
    }
  }

  lockAcquire(card_id, callback) {
    if (this.isLocked === false && card_id !== null) {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockAcquire_api)
        + '?articleId='
        + String(card_id)
      )
        .subscribe(
          data => {
            if (data) {
              // console.log('acquired element => ' + data);
              this.isLocked = true;
              this.cardData['lockedByUserId'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['email'];
              this.cardData['lockedByUserName'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['name'];
            }
            callback(data);
          },
          error => {
            // console.log(error);
            callback(false);
          });
    } else {
      callback(true);
      // console.log('lock alreay acquired');
    }
  }

  detectChange(ev) {
    this.changeFlag = true;
  }


  drag(ev) {
    this.dragfn.emit(ev);
  }

  editCard(id) {
    // this.editCardFlag = true;
    this.editCardId = id;
    this.editCardfn.emit(id);
  }

  checkChanges() {
    if (this.changeFlag) {

    } else {
      this.cancelEdit();
    }
  }

  cancelEdit() {
    this.changeFlag = false;

    this.editCardId = null;

    if (this.cardData.id === null || this.cardData.id === '') {
      this.cardData = null;
      // this.elementWordCount = 0;
    }
    this.loadView(false);
    this.cancelCardfn.emit();
  }

  resetlisticleElement() {
    this.cardData.title = '';
    this.cardData.listicle.inlineElementId = null;
    this.cardData.listicle.body = '';
    this.cardData.id = null;
    this.cardData = null;
    this.cardData = JSON.parse(JSON.stringify(StaticDataService.defaultListicleCardData));
    this.cardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    // this.elementWordCount = 0;
    this.cardId = null;
    // this.focusFlag = null;
    this.changeFlag = false;
    this.lastCardData = null;
    this.lastCardForChange = null;
    this.cardLoaded = false;
    this.firstLoadCheck = 0;
    this.loadView(false);
  }
  resetphotoStoryElement() {
    this.cardData = null;
    // this.elementWordCount = 0;
    this.cardId = null;
    this.cardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    this.cardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    if(localStorage.getItem('tempImage')) {
      localStorage.removeItem('tempImage')
    }
    this.cardData.paragraph.body = '';
    this.cardData.id = null;
    this.tempImage = null;
    this.changeFlag = false;
    this.lastCardData = null;
    this.lastCardForChange = null;
    this.cardLoaded = false;
    this.firstLoadCheck = 0;
    this.disableshowGallery();
    this.loadView(false);
  }


  resetliveblogElement() {
    this.cardData = null;
    // this.elementWordCount = 0;
    this.cardId = null;
    this.cardData = JSON.parse(JSON.stringify(StaticDataService.defaultLiveblogCardData));
    this.cardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    // this.focusFlag = null;
    this.cardData.liveBlog.body = '';
    this.cardData.title = '';
    this.changeFlag = false;
    this.lastCardData = null;
    this.lastCardForChange = null;
    this.cardLoaded = false;
    this.firstLoadCheck = 0;
    this.disableshowGallery();
    this.loadView(false);
  }

  resetParaElement() {
    this.cardData.paragraph.body = '';
    this.cardData.id = null;
    this.cardData = null;
    // this.elementWordCount = 0;
    this.cardId = null;
    // this.focusFlag = null;
    this.changeFlag = false;
    this.lastCardData = null;
    this.lastCardForChange = null;
    this.cardLoaded = false;
    this.firstLoadCheck = 0;
    this.destroyViewComponents();
    this.loadView(false);
  }

  @HostListener('window:click', ['$event'])
  onElementChange(event) {
    // console.log('element common =>  click');
    const clickedComponent = event.target;
    switch (this.cardType) {
      case 'paragraph':
        if (!this.isCKEditorEnabled) {
          const quillToolbarElement = this.paragraphElement ?
          this.paragraphElement.nativeElement.getElementsByClassName('ql-toolbar') : null;
          console.log(quillToolbarElement);
          if (event && event.target && this.extra.nativeElement.contains(event.target)) {

            console.log('csssss');
            console.log(event.target['className']);
            if (event.target['className'] === 'ql-action' || event.target['className'] === 'ql-remove') {
              this.changeFlag = true;
              this.overrideSave();
              this.range = new Range();
              this.onelementBlur();
            }
          }
          if (event && event.target && event.target.nextSibling && this.extra.nativeElement.contains(event.target)) {
            if (((event.target.nextSibling['className'] === 'ql-action' || event.target.nextSibling['className'] === 'ql-remove')
              && event.key === 'Enter')) {
              this.changeFlag = true;
              this.overrideSave();
              this.range = new Range();
              this.onelementBlur();
            }
          }

          // console.log(quillToolbarElement);

          if (quillToolbarElement && quillToolbarElement[0] && quillToolbarElement[0].contains(clickedComponent)) {
            clearTimeout(this.timer);
            this.timer = setTimeout(e1 => {
              this.doCheck();
            }, 20);
          }

          if (this.paragraphElement && !this.paragraphElement.nativeElement.contains(clickedComponent)) {
            if (this.id && this.paraEditor && (this.paraEditor.getText().trim() !== '')) {
              this.range = new Range();
            }
          }
        }
        break;
      case 'image':
        if (this.imageElement && !this.imageElement.nativeElement.contains(clickedComponent)) {
          this.cursorFocus = false;
        }
        break;
      case 'embed':
        if (this.showOptions && this.nestedOptionDropdown
          && !this.nestedOptionDropdown.nativeElement.contains(clickedComponent)) {
          this.showOptions = false;
        }
        break;
      case 'table':
      if (this.showOptions && this.nestedOptionDropdown
        && !this.nestedOptionDropdown.nativeElement.contains(clickedComponent)) {
        this.showOptions = false;
      }
        break;
      case 'liveblog':
        if (this.leadMediaImageToggle && !this.leadEl.nativeElement.contains(clickedComponent)) {
          this.disableshowGallery();
        }
        break;
      case 'photostory':
      if (this.leadMediaImageToggle && !this.leadEl.nativeElement.contains(clickedComponent)) {
        this.disableshowGallery();
      }
      break;
    }
  }

  @HostListener('document:click', ['$event'])
  handleClick(event) {
    const clickedComponent = event.target;
    if (this.brandEleField['_results'][0] && clickedComponent === this.brandEleField['_results'][0].nativeElement) {
      this.insideBrandEle = true;
      this.insideModelEle = false;
      this.insideCategoryEle = false;
      if (this.brandEleQuery === '') {
        this.filteredBrandSuggestion = this.brandSuggestion;
      }
    } else if (this.modelEleField['_results'][0] && clickedComponent === this.modelEleField['_results'][0].nativeElement) {
      this.insideModelEle = true;
      this.insideBrandEle = false;
      this.insideCategoryEle = false;
      if (this.modelEleQuery === '') {
        if(this.productElement['brand'] && this.productElement['brand'] !== '') {
          this.filteredModelSuggestion = this.modelSuggestion[this.productElement['brand']] ? this.modelSuggestion[this.productElement['brand']] : [];
          if(this.domainConfig['elementsDisabled'].indexOf('categoryProductElement') === -1) {
            this.modelSuggestion = Object.keys(this.modelSuggestion[this.productElement['brand']]);
            this.filteredModelSuggestion = this.modelSuggestion ? this.modelSuggestion : [];
          }
        }
      }
    }
    else if (this.categoryEleField['_results'][0] && clickedComponent === this.categoryEleField['_results'][0].nativeElement) {
      this.insideCategoryEle = true;
      if (this.categoryEleQuery === '') {
        this.filteredCategorySuggestion = this.categorySuggestion;
      }
      this.insideModelEle = false;
      this.insideBrandEle = false;
    }
     else {
      this.insideBrandEle = false;
      this.insideCategoryEle = false;
      this.insideModelEle = false;
    }

  }

  copyVideoIframe() {
    if (this.cardData.video.body !== null && this.cardData.video.body.trim() !== '') {
      let selBox = document.createElement('textarea');
      selBox.value = this.cardData.video.body;
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.snotify.info('Video Embed copied to Clipboard', '', this.sharedService.getConfig(false));
    } else {
      this.snotify.error('Video Embed not present', '', this.sharedService.getConfig(false));
    }
  }

  // @HostListener('window:paste', ['$event'])
  public pastefunc(e) {
    if (!this.isCKEditorEnabled) {
      const plaintext = (e.originalEvent || e).clipboardData.getData('text/plain');
      const htmltext = (e.originalEvent || e).clipboardData.getData('text/html');

      if (this.titleFocusFlag || this.captionFocusFlag) {
        e.stopImmediatePropagation();
        e.preventDefault();
        const text = this.htmlToPlainTextExcludingPara(plaintext);
        if (this.titleFocusFlag) {
          this.pasteOnEditor(this.titleEditor, text);
        }
        if (this.captionFocusFlag) {
          this.pasteOnEditor(this.captionEditor, text);
        }
        clearTimeout(this.timer);
        this.timer = setTimeout(e1 => {
          this.doCheck();
        }, 20);
        return false;
      } else if ((this.focusFlag && this.cardType !== null && this.cardType === 'paragraph') || (this.descFocusFlag)) {
        e.stopImmediatePropagation();
        e.preventDefault();
        const text = this.text2HTML(plaintext).replace(/<\p><\/p>/gm, '').replace(/<br ?\/?>/g, '');
        // document.execCommand('insertHTML', false, text);
        if (this.focusFlag && this.cardType !== null && this.cardType === 'paragraph') {
          this.pasteOnEditor(this.paraEditor, text);
        }
        if (this.descFocusFlag) {
          this.pasteOnEditor(this.descriptionEditor, text);
        }
        clearTimeout(this.timer);
        this.timer = setTimeout(e1 => {
          this.doCheck();
        }, 20);
        return false;
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(e1 => {
        this.doCheck();
      }, 20);
    }
  }

  pasteOnEditor(editor, text) {
    const len = ((editor.getSelection() !== null) ? (editor.getSelection()) : (editor.selection.savedRange));
    const oldh = editor.getBounds(len.index);
    if (len.length > 0) {
      editor.deleteText(len.index, len.length);
      editor.clipboard.dangerouslyPasteHTML(len.index, text);
    } else {
      editor.clipboard.dangerouslyPasteHTML(len.index, text);
    }
    setTimeout(e => {
      const l = ((editor.getSelection() !== null) ? (editor.getSelection()) : (editor.selection.savedRange));
      const newh = editor.getBounds(l.index);
      const diff = newh.top - oldh.top;
      if (diff > 0) {
        this.scrollOut.emit(diff);
      }
    }, 5);
  }

  text2HTML(inputText) {
    let text = inputText.replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    text = text.replace(/\r\n?|\n/g, '<br>');
    text = text.replace(/<br ?\/?>/g, '</p><p>');
    text = '<p>' + text + '</p>';
    return text;
  }

  htmlToPlainTextExcludingPara(text) {
    if (typeof text === 'string') {
      return this.htmlSpecialCharToText(text);
    } else {
      return text;
    }
  }

  htmlToPlainTextExcludingAttributes(text) {
    if (typeof text === 'string') {
      return this.htmlSpecialCharToText(
        (text)
          .replace(new RegExp('style="[^"]*"', 'g'), '')
          .replace(new RegExp('style=\'[^\']*\'', 'g'), '')
          .replace(new RegExp('class="[^"]*"', 'g'), '')
          .replace(new RegExp('class=\'[^\']*\'', 'g'), '')
          .replace(new RegExp('href="[^"]*"', 'g'), '')
          .replace(new RegExp('href=\'[^\']*\'', 'g'), '')
          .replace(new RegExp('src="[^"]*"', 'g'), '')
          .replace(new RegExp('src=\'[^\']*\'', 'g'), '')
      );
    } else {
      return text;
    }
  }

  htmlSpecialCharToText(text) {
    // const tevbrgvr = '&nbsp;&amp;&quot;&lt;&gt;';
    const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
    const translate = {
      'nbsp': ' ',
      'amp': '&',
      'quot': '\'',
      'lt': '<',
      'gt': '>'
    };
    return (text.replace(translate_re,
      (match, entity) => {
        return translate[entity];
      })
    );
  }

  checkIfELementIsInView() {
    // console.log(el);
    const el = this.extra;
    if (el && el !== null && el.nativeElement != null) {
      const rect = el.nativeElement.getBoundingClientRect();

      return (
        (rect.top >= 0) &&
        (rect.left >= 0) &&
        (rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) && /*or $(window).height() */
        (rect.right <= (window.innerWidth || document.documentElement.clientWidth)) /*or $(window).width() */
      );
    } else {
      return false;
    }
  }

  quillGetHTML(inputDelta) {
    const tempQuill = new Quill(document.createElement('div'));
    tempQuill.setContents(inputDelta);
    return tempQuill.root.innerHTML;
  }

  saveCard(flagforQueue, callback) {
    let cardData = this.cardData;
    // tslint:disable-next-line:no-debugger
    // console.log(this.changeFlag, this.disableElement('save-flag'), this.isLocked, this.cardData.id, this.saveInQueue);
    // console.log('carddata is'+cardData.id +","+flagforQueue+","+this.saveInQueue)
    if (cardData && (flagforQueue ? (this.saveInQueue === 0) : true)) {
      // console.log('inside if condition');
      if (this.disableElement('save-flag')) {
      //  console.log('Disabled Element')
        cardData = this.sharedService.checkhrefandreplace(this.cardData);
        if (cardData.id !== null) {
          if (this.isLocked) {
            const token = localStorage.getItem(StaticDataService.tokenLiteral) ?
            JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))
            : null;
            if (flagforQueue) {
              this.saveInQueue += 1;
            }
            cardData['lockedByUserId'] = token.email;
            cardData['lockedByUserName'] = token.name;
            this.cardData.lastModifiedBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
            this.increasePendingCount();
            // console.log('calling save api');
            this.restService.http_put(this.config.get('product').baseUrl
              + this.config.getEndPoint(this.config.get('views'), this.page_id, this.save_api)
              + '/' + String(cardData.id) + '?autoSave=true',
              this.sharedService.checkhrefandreplace(cardData),
              result => {
                if(result && result.status === 404 && this.domainConfig['config']['story']['onStoryRefresh']) {
                  this.destroyCardAutoSaveInterval();
                  this.emitRefereshStory.emit(true);
                  this.snotify.info('Story content has been updated by print', '', this.sharedService.getConfig(false));
                } else {
                this.decreasePendingCount();
                if (flagforQueue) {
                  this.saveInQueue -= 1;
                }
                if (!result || result.hasOwnProperty('error')) {
                    console.log('lock error');
                    this.isLocked = false;
                    this.changeFlag = true;
                    this.overrideSave();
                }
                if (result) {
                  // console.log('  '+result);
                  this.storySave.emit(result);
                  this.updateCardDatafn.emit(result);
                  this.resgisterDataChangeToParent(result);
                  // console.log(this.cardData ? this.cardData.metadata.status : '');
                  if (result.metadata && result.metadata.wordCount) {
                    // console.log(result.metadata.wordCount);
                    this.calculateElementWordCount({
                      id: result.id,
                      count: result.metadata.wordCount
                    });
                    this.cardData.metadata.wordCount = result.metadata.wordCount;
                  }
                  this.cardData['firstPublishedDate'] = result['firstPublishedDate'];
                  this.changeFlag = false;
                  this.removeCardDataAfterAutoSave(cardData['id']);
                }
                callback(result);
              }
              })
          } else {
            // console.log('change detected but lock is not acquired');
            this.overrideSave();
            callback(false);
          }
        } else {
          // console.log(this.cardData ? this.cardData.metadata.status : '');
          if (this.cardType !== 'listicle' && this.cardType !== 'liveblog' && this.cardType !== 'photostory' && this.cardType !== 'highlights'
            && this.cardType !== 'newsroom') {
            this.cardData.id = null;
            if (flagforQueue) {
              this.saveInQueue += 1;
            }
            this.cardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
            if (this.cardType === 'paragraph' && this.id === 'newElement') {
              this.increasePendingCount();
            }
            this.restService.http_post(this.config.get('product').baseUrl
              + this.config.getEndPoint(this.config.get('views'), this.page_id, this.save_api),
              this.sharedService.checkhrefandreplace(cardData), result => {
                if (this.cardType === 'paragraph' && this.id === 'newElement') {
                  this.decreasePendingCount();
                }
                // console.log(this.cardData ? this.cardData.metadata.status : '');
                if (result) {

                  this.resgisterDataChangeToParent(result);
                  if (flagforQueue) {
                    this.saveInQueue -= 1;
                  }
                  this.calculateElementWordCount({
                    id: result.id,
                    count: result.metadata.wordCount
                  });
                }
                this.cardData.id = result.id;
                this.cardData.metadata.wordCount = result.metadata.wordCount;
                if (result.id !== null) {
                  if(this.cardData.reusable) {
                    this.lockAcquire(result.id, e => {});
                  }
                  this.tempParaSaveEmit.emit(result);
                }
                this.changeFlag = false;
                callback(result);

                if(this.callRecommendation && this.cardData && this.cardData.id){
                    this.autoBacklink(this.cardData.id);
                }
              });
          }
        }
      }
    }
  }

  setCardType(type) {

  }

  resetCard(obj) {
    // console.log('resetr emot');
    if (obj) {
      // this.saveCardfn.emit(obj);
    }

  }

  mapLeadMediaObject() {
    // const tag = this.cardData.metadata.tags ? $.extend(true, [], this.cardData.metadata.tags) : [];
    const tag = this.cardData.metadata.tags ? Object.assign([], this.cardData.metadata.tags) : [];
    // console.log(tag);
    this.tempCardData.name = this.cardData.image ? this.cardData.image.name : '';
    this.tempCardData.caption = this.cardData.image ? this.cardData.image.caption : '';
    this.tempCardData.tags = tag;
    this.tempCardData.title = this.cardData.title ? this.cardData.title : '';
    this.tempCardData.imageUrl = this.cardData.image ? this.cardData.image.imageUrl : '';
    this.tempCardData.source = this.cardData.image && this.cardData.image.imageCredit ? this.cardData.image.imageCredit : '';
    this.tempCardData.link = this.cardData.image && this.cardData.image.anchorTag ? this.cardData.image.anchorTag : '';
    this.tempCardData.verticalImage = this.cardData.image && this.cardData.image.verticalImage;
    this.tempCardData.amazonAds = this.cardData.amazonAds ? this.cardData.amazonAds : '';
    this.tempCardData.amazonTitle = this.cardData.amazonTitle ? this.cardData.amazonTitle: '';
    this.tempCardData.amazonMeta = this.cardData.amazonMeta ? this.cardData.amazonMeta: false;
    this.tempCardData.amazonCheckedItem = this.cardData.amazonCheckedItem ? this.cardData.amazonCheckedItem: false;
    this.tempCardData.overImage = this.cardData.image && this.cardData.image.overImage ? this.cardData.image.overImage : false;
  }

  setChangesMeta() {
    // console.log(this.temporaryChangesFlag);
    // this.doCheck();
    if (this.temporaryChangesFlag) {
      this.cardData.image.name = this.tempCardData.name;
      // console.log(this.tempCardData.caption);
      this.cardData.image.caption = (this.tempCardData.caption && this.tempCardData.caption.trim() !== '')
        ? (this.sharedService.isdomainConfig('story','captionStripTagDisabled') ? this.tempCardData.caption : this.tempCardData.caption) : '';
      this.cardData.metadata.tags = this.tempCardData.tags;
      this.cardData.title = this.tempCardData.title;
      this.cardData.image.title = this.tempCardData.title;
      this.cardData.image.imageUrl = this.tempCardData.imageUrl;
      this.cardData.image.imageCredit = this.tempCardData.source;
      this.cardData.image.overImage = this.tempCardData.overImage;
      this.cardData.image.anchorTag = (this.tempCardData.link.trim() && !this.tempCardData.link.startsWith('http')) ?
      ('http://' + this.tempCardData.link.trim()) : this.tempCardData.link.trim();
      this.cardData.image.verticalImage = this.tempCardData.verticalImage;
      if(this.enableAmazonMeta) {
        this.cardData.amazonMeta = this.tempCardData.amazonMeta;
        this.cardData.amazonTitle = this.tempCardData.amazonTitle;
        if(this.tempCardData.amazonAds == null || this.tempCardData.amazonAds.length == 0)
        {
          this.cardData.amazonAds = null;
        }else{
          this.cardData.amazonAds = this.tempCardData.amazonAds;
        }

        this.cardData.amazonCheckedItem = this.tempCardData.amazonCheckedItem;
      }
      // console.log(this.cardData.metadata);
      this.changeFlag = true;
      this.overrideSave();
      setTimeout(e1 => {
        this.temporaryChangesFlag = false;
        this.onelementBlur();
      }, 700);
    } else {
      this.discardMetaChanges(false);
      // this.editCardFlag = false;
      this.onelementBlur();

      this.lockRelease(this.cardId, e => { });
    }
  }
  setChangesImageCaption() {
    // console.log(this.temporaryChangesFlag);
    // this.doCheck();
    //fucntion is used for photo gallery image caption to make hyperlink
   this.temporaryChangesFlag=true;
   this.setChangesMeta()
  }

  toggleSwitch(button) {
    if(button === 'amazonMeta') {
      this.showAmazonMeta = !this.showAmazonMeta;
    } if(button === 'snapdealMeta') {
      this.showSnapdealMeta = !this.showSnapdealMeta;
    }
    if(button === 'cromaMeta'){
      this.showCromaMeta = !this.showCromaMeta;
    }
    if(button === 'flipkartMeta'){
      this.showFlipkartMeta = !this.showFlipkartMeta;
    }
    if (button === 'highlight') {
      this.cardData.metadata.highlight = !this.cardData.metadata.highlight;
    }
  }


  discardMetaChanges(displayFlag) {
    this.mapLeadMediaObject();
    this.temporaryChangesFlag = false;
    // this.editCardFlag = false;
    this.lastCardTempData = JSON.stringify(this.tempCardData);
    this.lastCardForImageChange = JSON.stringify(this.tempCardData);
  }
  deleteAmazonAd(ev)
  {
    this.amazonAds.splice(ev,1);
  }
  deleteSnapdealAd(ev)
  {
    this.snapdealAds.splice(ev,1);
  }
  deleteCromaAd(ev){
    this.cromaAds.splice(ev,1);
  }
  deleteFlipkartAd(ev){
    this.flipkartAds.splice(ev,1);
  }

  saveAmazonEmbed()
  {
    if(this.newAmazonAdName && this.cardData.embed.title) {
      this.amazonAds.push({key:this.newAmazonAdName,value:this.newAmazonAdEmbed});
    } else {
      this.snotify.error('Enter Ad Name and Title', '', this.sharedService.getConfig(false));
    }
    this.amazonNewAd = false;
  }
  saveSnapdealEmbed() {
    if(this.newSnapdealAdName && this.cardData.embed.title) {
      this.snapdealAds.push({key:this.newSnapdealAdName,value:this.newSnapdealAdEmbed});
    } else {
      this.snotify.error('Enter Ad Name and Title', '', this.sharedService.getConfig(false));
    }
    this.snapdealNewAd = false;
  }
  saveCromaEmbed(){
    if(this.newCromaAdName && this.cardData && this.cardData.embed && this.cardData.embed.title) {
      this.cromaAds.push({key:this.newCromaAdName,value:this.newCromaAdEmbed});
    } else {
      this.snotify.error('Enter Ad Name and Title', '', this.sharedService.getConfig(false));
    }
    this.cromaNewAd = false;
  }

  saveFlipkartEmbed(){
    if(this.newFlipkartAdName && this.cardData && this.cardData.embed && this.cardData.embed.title) {
      this.flipkartAds.push({key:this.newFlipkartAdName,value:this.newFlipkartAdEmbed});
    } else {
      this.snotify.error('Enter Ad Name and Title', '', this.sharedService.getConfig(false));
    }
    this.flipkartNewAd = false;
  }

  addAmazonMeta()
  {
    this.newAmazonAdName="";
    this.newAmazonAdEmbed="";
    //this.adTitle="";
    this.amazonNewAd = true;
  }

  addSnapdealMeta() {
    this.newSnapdealAdName = "";
    this.newSnapdealAdEmbed = "";
    this.snapdealNewAd = true;
  }
  addCromaMeta() {
    this.newCromaAdName = "";
    this.newCromaAdEmbed = "";
    this.cromaNewAd = true;
  }
  addFlipkartMeta(){
    this.newFlipkartAdName = "";
    this.newFlipkartAdEmbed = "";
    this.flipkartNewAd = true;
  }

  updateCardData() {
    this.updateCardDatafn.emit(this.cardData);
  }

  addContentInPara(content) {
    const len = this.paraEditor.getText().length;
    this.cardData.paragraph.body = this.cardData.paragraph.body + content;
    clearTimeout(this.timer);
    this.timer = setTimeout(e1 => {
      this.doCheck();
    }, 20);

    if (!this.isCKEditorEnabled) {
      setTimeout(e => {
        this.paraEditor.setSelection(len, 0);
      }, 200);
    }
  }

  focusElementFromStory(pos) {
    this.setFocusOnThis(pos);
    if (this.cardData && this.cardData['type'] && (this.cardData['type'] === 'image')) {
      this.onelementFocus();
    }
  }

  setFocusOnThis(pos,storySlug?: any) {
    this.currentCardEmit();
    if (this.cardData && this.cardData.type === 'paragraph') {
      if (this.isCKEditorEnabled) {
        this.paraEditor.editing.view.focus();
      } else {
        if (pos && this.paraEditor && (pos === 'start')) {
          this.paraEditor.focus();
          setTimeout(e => {
            this.paraEditor.setSelection(0, 0);
          }, 40);
        } else {
          this.paraEditor.focus();
          setTimeout(e => {
            this.paraEditor.setSelection(this.paraEditor.getText().length, 0);
          }, 40);
        }
      }
    }

    if (this.cardData && (this.cardData.type === 'image' || this.cardData.type === 'gif')) {
      this.cursorFocus = true;
      this.isCursorHovering = true;
      // this.onelementFocus();
      // console.log('focus on =: ' + this.id);
      this.imageElement.nativeElement.focus();
    }


    if (this.cardData && this.cardData.type === 'video') {
      this.cursorFocus = true;
      this.isCursorHovering = true;
      // this.onelementFocus();
      // console.log('focus on =: ' + this.id);
      this.videoElement.nativeElement.focus();
    }

    if (this.cardData && (this.cardData.type === 'embed' || this.cardData.type === 'relatedstory')) {
      if (this.cardData.type === 'embed') {
        this.embedElement.nativeElement.focus();
        // this.embedElement.nativeElement.select();
      }
      if (this.cardData.type === 'relatedstory') {
        this.relatedElement.nativeElement.focus();
        // this.relatedElement.nativeElement.select();
      }
      if (this.cardData.type ==='relatedstoryhowto') {
        this.relatedElementhowto.nativeElement.focus();
        // this.relatedElement.nativeElement.select();
      }
      this.cursorFocus = true;
      this.isCursorHovering = true;
    }
    // console.log(pos, this.cardData.type);
    if (this.cardData && (this.cardData.type === 'listicle' || this.cardType === 'highlights')) {
      this.cursorFocus = true;
      if (this.isCKEditorEnabled) {
        this.descriptionEditor.editing.view.focus();
      } else {
        this.descriptionEditor.focus();
        if (pos === 'start') {
          this.descriptionEditor.setSelection(0, 0);
        } else {
          this.descriptionEditor.setSelection(this.cardData.listicle.body.length, 0);
        }
      }
    }
    if (this.cardData && (this.cardData.type === 'liveblog' || this.cardType === 'newsroom')) {
      this.cursorFocus = true;
      // this.isCursorHovering = true;
      // this.onelementFocus();
      // console.log('focus on =: ' + this.id);
      if (this.isCKEditorEnabled) {
        if (pos === 'start') {
          this.titleEditor.editing.view.focus();
          if(storySlug){
          this.titleEditor.setData(storySlug);
        }
        } else {
          this.descriptionEditor.editing.view.focus();
        }
      } else {
        if (pos === 'start') {
          this.titleEditor.focus();
        } else {
          this.descriptionEditor.focus();
        }
      }
    }
    if (this.cardData && this.cardData.type === 'table') {
      this.cursorFocus = true;
      this.isCursorHovering = true;
      this.tableElement.nativeElement.focus();
    }
    if (this.cardData && this.cardData.type === 'cricket') {
      this.cursorFocus = true;
      this.isCursorHovering = true;
      this.tableElement.nativeElement.focus();
    }
    if (this.cardData && this.cardData.type === 'market') {
      this.cursorFocus = true;
      this.isCursorHovering = true;
    }
    if (this.cardData && this.cardData.type === 'quote') {
      this.cursorFocus = true;
      this.isCursorHovering = true;
      this.quoteElement.nativeElement.focus();
    }
  }

  makeRenderable(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  deleteTempImage() {
    localStorage.removeItem('tempImage');
    this.tempImage = null;
  }

  deleteSample(sample) {
    this.cardData.sampleImagesIdList.splice(this.cardData.sampleImagesIdList.indexOf(sample), 1);
    this.changeFlag = true;
    if(this.cardData.sampleImagesIdList.length === 0) {
      this.deleteElement()
    }
    this.overrideSave();
  }

  startSampleCropping(index){
    // console.log(this.sampleImageEle)
    this.sampleImageEle['_results'][index].startCropping();
  }


  showViewImages() {
    this.disableshowGallery();
    this.getViewImageList();
  }

  cancelViewImages(){
    if(this.isDraggedImages){
      const { timeout, closeOnClick, ...config } = this.sharedService.getConfig(true); // Omit props what i don't need
      this.snotify.confirm('Changes are not saved. Do you still want to proceed?', '', {
        ...config,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.snotify.remove(toast.id);
              this.disableshowGallery();
              this.emitEnableDisableSampleImagePopup.emit(false);
              this.googleAnalytics("Skippable Alerts","Changes are not saved. Do you still want to proceed?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' ,null);
            }, bold: false
          },
          {
            text: 'No', action: (toast) => {
              this.snotify.remove(toast.id);
              this.googleAnalytics("Skippable Alerts","Changes are not saved. Do you still want to proceed?",sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' ,null);
            }
          }
        ]
      });
    }else{
      this.emitEnableDisableSampleImagePopup.emit(false);
      this.disableshowGallery();
    }

  }

  getViewImageList(){
    this.viewImagesData=[];
    if(!!this.cardData && this.cardData.sampleImagesIdList.length>0){
    this.restService.http_post(this.config.get('product').baseUrl
    + '/api/cms/element/get-all-by-ids/',
    this.cardData.sampleImagesIdList, result => {
      this.emitEnableDisableSampleImagePopup.emit(true);
      this.isLightbox = true;
      this.showViewImagePopup =  true;
      this.viewImagesData= result;
    }),
    err => {
      this.snotify.error('Image fetching failed', '', this.sharedService.getConfig(false));
    }
  }
}

returnAlertsForImages() {
  let text = '';
  if(!this.cardData.title) {
    text += '*Title should not be Empty ';
  }
  if(this.cardData.title === this.cardData.image.caption) {
    text += '*Title should not be same as caption ';
  }
  if(!this.cardData.image.caption) {
    text += '*Caption should not be blank ';
  }
  return text.length > 0 ? text : 'No Alert';
}

getImageFileName(img) {
// console.log(img);
let key = Object.keys(img.image.images)[0];
if(!img.image.images[key]) {
  return "Img not found"
}
return img.image.images[key].substring(img.image.images[key].lastIndexOf("/")+1,img.image.images[key].lastIndexOf("_")>img.image.images[key].lastIndexOf("/")?img.image.images[key].lastIndexOf("_"):img.image.images[key].lastIndexOf("."));
// return "filj.jpg";
}

updateDragViewImages(){
  let data=[];
  for(let obj of this.viewImagesData){
     data.push(obj.id);
  }
  this.cardData.sampleImagesIdList=[...data];
  this.cardData['lockedByUserId'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['email'];
  this.cardData['lockedByUserName'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['name'];
  this.restService.http_put(
    this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), this.page_id, this.get_api)
    + '/'
    + String(this.cardId),this.cardData, res=> {
      this.showViewImagePopup=false;
      this.emitEnableDisableSampleImagePopup.emit(false);
      this.isLightbox=false;
    }),
    (error) => {
      this.snotify.error('Something bad happened', 'Updation failed', this.sharedService.getConfig(false));
    };
  }

  deleteElement() {
    this.showOptions = false;
    if(this.cardData.type === 'paywall') {
      this.emitParentPaywallIdDelete.emit(true);
    }
    if (this.cardData.type === 'image') {
      if (this.cardData.hasOwnProperty('parentElementId') && (this.cardData['parentElementId'] !== 0)) {
        this.emitParentImageIdDelete.emit(this.cardData['parentElementId']);
      } else {
        this.emitParentImageIdDelete.emit(this.cardData['id']);
      }
    }
    if (this.cardData.type === 'gif') {
      if (this.cardData.hasOwnProperty('parentElementId') && (this.cardData['parentElementId'] !== 0)) {
        this.emitParentImageIdDelete.emit(this.cardData['parentElementId']);
      } else {
        this.emitParentImageIdDelete.emit(this.cardData['id']);
      }
    }
    // this.emitParentImageIdDelete.emit();
    // console.log(this.cardData);
    if (this.cardData['type'] === 'relatedstory') {
      this.changeRelated.emit([]);
    }
    if (this.cardData.type ==='relatedstoryhowto') {
      this.changeRelatedHowto.emit([]);
    }
    if (this.cardData.type ==='alsoread') {
      this.getAlsoReadEmit.emit([]);
    }
    if(this.cardData.type === 'market'){
      this.emitStockWidgetDelete.emit(this.cardData['metadata']['stockType']);
    }
    setTimeout(e2 => {
      this.deleteCardfn.emit(this.cardData.id);
    }, 150);
  }

  deletePinElement() {
    this.showOptions = false;
    setTimeout(e2 => {
      this.deletePinCardfn.emit(this.cardData.id);
    }, 150);
  }

  pinLiveBlogPost() {
    this.showOptions = false;
    setTimeout(e2 => {
      this.pinCardfn.emit(this.cardData.id);
    }, 150);

  }
  unPinLiveBlogPost() {
    this.showOptions = false;
    setTimeout(e2 => {
      this.unPinCardfn.emit(this.cardData.id);
    }, 150);
  }

  changeVideoUrl() {
    this.videoUrl = '';
    this.videoDuration = 0;
    this.videoUrlPopup = true;
  }

  openVideoOptions() {
    this.videoOptions = !this.videoOptions;
  }

  cancelChangeVideo() {
    this.videoUrlPopup = false;
    this.videoUrl = '';
    this.videoDuration = 0;
    this.videoOptions = false;
  }

  checkVideoUrl(url) {
    // var m = url.match(/^.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/);

    const reg = new RegExp('(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|dailymotion.com)\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?');
    const reg2 = new RegExp('(http:|https:|)\/\/(dai.)?(ly)?([A-Za-z0-9._%-]*)(\&\S+)?');
    // 'https://dai.ly/x6tqrg5'
    const m = reg.exec(url);
    if (m !== null) {
      if (m[3] !== undefined && m[1] !== undefined) {
        // return m[3];
        if ((m[3] === 'youtu.be' || m[3] === 'youtube.com' || m[3] === 'dailymotion.com') && (m[1] === 'https:' || m[1] === 'http:')) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      const n = reg2.exec(url);
      if (n !== null) {
        // console.log(n);
        if ((n[2] !== undefined && n[3] !== undefined) && (n[2] === 'dai.' && n[3] === 'ly') && (n[1] === 'https:' || n[1] === 'http:')) {
          return true;
        } else {
          return false;
        }
      } else {
        return null;
      }
    }
  }

  finishChangeVideo() {
    if (this.videoUrl && this.videoUrl !== null && this.videoUrl.trim() !== '') {
      if (this.videoUrl.indexOf('src="//players.brightcove.net') > -1) {
        if (this.videoUrl.split('src="') && this.videoUrl.split('src="') !== null && this.videoUrl.split('src="').length > 1) {
          if (this.videoUrl.split('src="')[1].split('"')[0].charAt(0) === '/') {
            this.cardData.video.embedUrl = 'https:' + this.videoUrl.split('src="')[1].split('"')[0];
            this.cardData.video.body = this.videoUrl.replace('src="', 'src="https:');
            this.video_iframe_html = this.makeRenderable(this.videoUrl.replace('src="', 'src="https:'));
          } else {
            this.cardData.video.embedUrl = this.videoUrl.split('src="')[1].split('"')[0];
            this.cardData.video.body = this.videoUrl;
            this.video_iframe_html = this.makeRenderable(this.videoUrl);
          }
        }
      } else if (this.videoUrl.indexOf('src=\'//players.brightcove.net') > -1) {
        if (this.videoUrl.split('src=\'') && this.videoUrl.split('src=\'') !== null && this.videoUrl.split('src=\'').length > 1) {
          if (this.videoUrl.split('src=\'')[1].split('\'')[0].charAt(0) === '/') {
            this.cardData.video.embedUrl = 'https:' + this.videoUrl.split('src=\'')[1].split('\'')[0];
            this.cardData.video.body = this.videoUrl.replace('src=\'', 'src=\'https:');
            this.video_iframe_html = this.makeRenderable(this.videoUrl.replace('src=\'', 'src=\'https:'));
          } else {
            this.cardData.video.embedUrl = this.videoUrl.split('src=\'')[1].split('\'')[0];
            this.cardData.video.body = this.videoUrl;
            this.video_iframe_html = this.makeRenderable(this.videoUrl);
          }
        }
      } else if (this.sharedService.isEmbedStripEnabled() && this.videoUrl.indexOf('cdn.jwplayer.com') > -1) {
        const duration = this.sharedService.checkForMetadataDuration(this.videoUrl);
        if (duration !== false) {
          if (!this.cardData.metadata.hasOwnProperty('videoMetadata') || !this.cardData.metadata.videoMetadata) {
            this.cardData.metadata.videoMetadata = {};
          }
          this.cardData.metadata.videoMetadata.duration = duration;
        }
        if (this.videoUrl.indexOf('src="') > -1) {
          const url = this.videoUrl.split('iframe src="')[1].split('"')[0];
          this.cardData.video.embedUrl = url;
          this.cardData.video.body = this.sharedService.checkEmbed(this.videoUrl);
          this.video_iframe_html = this.makeRenderable('<iframe src="' + url + '"></iframe>');
        } else if (this.videoUrl.indexOf('src=\'') > -1) {
          const url = this.videoUrl.split('iframe src=\'')[1].split('\'')[0];
          this.cardData.video.embedUrl = url;
          this.cardData.video.body = this.sharedService.checkEmbed(this.videoUrl);
          this.video_iframe_html = this.makeRenderable('<iframe src="' + url + '"></iframe>');
        }
      } else {
        if (this.videoUrl.indexOf('src="') > -1) {
          this.cardData.video.embedUrl = this.videoUrl.split('src="')[1].split('"')[0];
          this.cardData.video.body = this.videoUrl;
          this.video_iframe_html = this.makeRenderable(this.videoUrl);
        } else if (this.videoUrl.indexOf('src=\'') > -1) {
          this.cardData.video.embedUrl = this.videoUrl.split('src=\'')[1].split('\'')[0];
          this.cardData.video.body = this.videoUrl;
          this.video_iframe_html = this.makeRenderable(this.videoUrl);
        } else {
          this.snotify.error('Enter a valid embed', '', this.sharedService.getConfig(false));
          return false;
        }
      }
      this.cardData.metadata.videoMetadata.duration = this.videoDuration;
      this.changeFlag = true;
      this.overrideSave();
      this.videoUrlPopup = false;
      this.disableshowVideoGallery();
    } else {
      this.snotify.error('Enter a valid embed', '', this.sharedService.getConfig(false));
    }
  }

  destroyViewComponents() {
    this.destroyCardAutoSaveInterval();
  }

  generateCardAutoSaveInterval() {
    this.autosave = setInterval(() => {
      // if (this.cardType === 'listicle') {
      // console.log('card saving');
      // }
     this.saveCard(true, res => {
      });
    }, this.autoSaveInterval);
  }

  destroyCardAutoSaveInterval() {
    if (this.autosave) {
      clearInterval(this.autosave);
    }
  }

  ngOnDestroy() {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.disconnect();
    }
    this.destroyViewComponents();
    this.decrementPendingRequest.emit(this.requestInQueue);
    console.log("Card Id is "+this.cardId);
    if (this.dragulaService.find('new-bag1')) {
      this.dragulaService.destroy('new-bag1');
    }
  }
  imgLoaded(load) {
    // console.log(load, this.isLocked, this.editCardFlag);
    this.loaded = true;
  }
  disableElement(elementName): boolean {
    if (this.cardData) {
      if (this.cardData.metadata) {
        if (elementName === 'cm-tags') {
          return (this.cardData.metadata.tags.length < 1);
        }
        if (elementName === 'cm-title') {
          return (this.cardData.title.trim() === '' || !this.cardData.title);
        }
      }
      if (elementName === 'card-name') {
        return (this.cardData.name.trim() === '' || !this.cardData.name);
      }
    }

    if (elementName === 'save-flag') {
      if (this.cardType === 'paragraph') {
        return (
          (this.cardData.id !== null ? true : (this.cardData.paragraph.body && this.cardData.paragraph.body.trim() !== ''))
          && this.changeFlag);
      } else if (this.cardType === 'image' || this.cardType === 'gif') {
        // console.log(this.temporaryChangesFlag);
        if(this.storytype === 'photostory'){
          return this.changeFlag;
        } else if(this.storytype === 'story'){
          return this.changeFlag;
        }
        return this.temporaryChangesFlag;
      } else if (this.cardType === 'faq') {
        return !deepEqual(this.cardData,this.tempnewFAQData.getRawValue());
      }else if (this.cardType === 'label') {
        return !deepEqual(this.cardData,this.label);
      }else if (this.cardType === 'separator') {
        return !deepEqual(this.cardData,this.separator);
      } else if (this.cardType === 'poll') {
        return !deepEqual(this.cardData,this.tempnewFAQData.getRawValue());
      } else if(this.cardType === 'listicleElement') {
        return !deepEqual(this.cardData,this.tempListicleData.getRawValue());
      } else {
        return this.changeFlag;
      }
    }
    if (elementName === 'display-bar') {
      if (this.cardType === 'paragraph') {
        return (this.focusFlag || this.isCursorHovering);
      } else if (this.cardType === 'image' || this.cardType === 'gif') {
        if (!this.editCardFlag) {
          return (!this.nestedElement && (this.isCursorHovering || this.editCardFlag));
        } else {
          return !this.nestedElement;
        }
      } else if (this.cardType === 'listicle' || this.cardType === 'highlights') {
        return (this.EditMode && (this.id !== 'newListElement') && (this.focusFlag || this.isCursorHovering));
      } else if (this.cardType === 'liveblog' || this.cardType === 'newsroom') {
        return (this.EditMode && (this.id !== 'newLiveblogElement') && (this.focusFlag || this.isCursorHovering));
      } else if (this.cardType === 'photostory') {
        return (this.EditMode && (this.id !== 'newPhotostoryElement') && (this.focusFlag || this.isCursorHovering));
      } else if (this.cardType === 'relatedstory' || this.cardType ==='relatedstoryhowto') {
        return (this.EditMode && (this.isCursorHovering));
      }

      else if (this.cardType === 'video') {
        return this.isCursorHovering;
      } else if (this.cardType === 'embed' || this.cardType === 'market' || this.cardType === 'cricket') {
        return (this.EditMode && (this.isCursorHovering));
      } else {
        return false;
      }
    }
  }

  getDifference(a, b) {
    let i = 0;
    let j = 0;
    let result = '';

    while (j < b.length) {
      if (a[i] !== b[j] || i === a.length) {
        result += b[j];
      } else {
        i++;
      }
      j++;
    }
    return result;
  }

  getMutualFundList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/market/indices?type=mf&size=10000')
    .subscribe(
      data => {
        this.mutualFundSuggestion = data;
      }
    );
  }
  getMarketList() {
    this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/story/market/indices?type=!mf&size=10000')
      .subscribe(
        data => {
          this.marketSuggestion = data.filter((item) => {
            return item['indicesType'] !== "NEW";
          });
          this.newMarketSuggestion = data.filter((item) => {
            return item['indicesType'] === "NEW";
          });
        }
      );
  }

  setMarketIndex(event) {
    this.marketList = event;
    if(this.marketList.length === 0) {
      this.deactivateMarketSuggestion = false;
      this.deactivateNewMarketSuggestion = false;
    }
    else{
      this.deactivateMarketSuggestion = true;
      this.deactivateNewMarketSuggestion = true;
    }
  }
  setMutualFunds(event) {
    this.mutualFundList = event;
    if(this.mutualFundList.length === 0) {
      this.deactivateNewMarketSuggestion = false;
      this.deactivateMarketSuggestion = false;
    }
    else{
      this.deactivateMarketSuggestion = true;
      this.deactivateNewMarketSuggestion = true;
    }
  }
  setNewMarket(event) {
    this.newMarketList = event;
    if (this.newMarketList.length === 0) {
      this.deactivateMarketSuggestion = false;
    }
    else{
      this.deactivateMarketSuggestion = true;
    }
  }
  customFunc(ev) {
  }
  catchTagFocus($event) {
    this.focusedCard = null;
    this.lastindex = null;
  }



  getEmbedSourceUrl(obj) {
    this.cardData.jsonSourceUrl = obj;
    this.embedChangeOutput.emit(null);
  }
  onelementFocus() {
    this.currentCardEmit();
    console.log(this.cardType);
    //case when pick image as in liveblog & photostory for edit case we got storyType undefined
      //set in showGallery Function
      if(!this.storytype){
         this.storytype=sessionStorage.getItem('storyType');
      }
    if (this.cardType === 'paragraph' || this.cardType === 'listicle'
      || this.cardType === 'liveblog' || this.cardType === 'photostory'  || this.cardType === 'highlights' || this.cardType === 'newsroom') {
      this.focusFlag = true;
    }

    this.showOptions = false;
    if (this.cardType === 'image' || this.cardType === 'gif') {
      // this.loaded = false;
      this.lastCardTempData = JSON.stringify(this.tempCardData);
      this.lastCardForImageChange = JSON.stringify(this.tempCardData);
      setTimeout(e4 => {
        this.editCardFlag = true;
        this.ckEditorEnableReadOnlyMode();
        setTimeout(e => {
          // console.log(this.imgCaptionInput);
          if (this.captionEditor) {
            if (this.isCKEditorEnabled) {
              this.captionEditor.editing.view.focus();
            } else {
              this.captionEditor.focus();
            }
          }
        }, 300);
      }, 300);
    }

    if (this.cardType === 'embed') {
      if(this.cardData.affiliateMeta) {
        this.openAffiliatePopup()
      } else {
        var showJsonEmbed = true;
        this.showAmazonMeta = true;
        this.showSnapdealMeta = true;
        this.showCromaMeta = true;
        this.showFlipkartMeta = true;
        if(this.cardData.amazonAds && this.cardData.amazonAds.length > 0 ) {
          this.adTitle = this.cardData.embed.title;
          this.amazonAds=this.cardData.amazonAds;
          this.embedCode = "";
          this.embedSourceUrl = "";
          showJsonEmbed = false;
          //this.outputEmbedSourceUrl.emit(this.embedSourceUrl);
        }
        if(this.cardData.snapdealAds && this.cardData.snapdealAds.length > 0) {
          this.adTitle = this.cardData.embed.title;
          this.snapdealAds=this.cardData.snapdealAds;
          this.embedCode = "";
          this.embedSourceUrl = "";
          showJsonEmbed = false;
        }
        if(this.cardData.cromaAds && this.cardData.cromaAds.length > 0) {
          this.adTitle = this.cardData.embed.title;
          this.cromaAds=this.cardData.cromaAds;
          this.embedCode = "";
          this.embedSourceUrl = "";
          showJsonEmbed = false;
        }
        if(this.cardData.flipkartAds && this.cardData.flipkartAds.length > 0) {
          this.adTitle = this.cardData.embed.title;
          this.flipkartAds=this.cardData.flipkartAds;
          this.embedCode = "";
          this.embedSourceUrl = "";
          showJsonEmbed = false;
        }
        if(showJsonEmbed) {
          this.embedCode = this.cardData.embed.body;
          this.embedSourceUrl = this.cardData.jsonSourceUrl;
          this.showAmazonMeta = false;
          this.showSnapdealMeta = false;
          this.showCromaMeta = false;
          this.showFlipkartMeta = false;
          this.adTitle= "";
          this.amazonAds= [];
          this.snapdealAds = [];
          this.cromaAds = [];
          this.flipkartAds = [];
        }
      }

      this.outputEmbedSourceUrl.emit(this.embedSourceUrl);

      this.embedSubType = this.cardData.subType;
      this.embedPopup = true;
      this.sharedService.overflowhidden();
    }

    // pranav
    if(this.cardType === 'faq') {
      // this.openFaqPopup();
      this.openNewFaqPopup()
    }

    if(this.cardType === 'poll') {
      this.openNewPollPopup()
    }
    if(this.cardType === 'label'){
      this.openLabelPopup();
    }
    if(this.cardType === 'separator'){
      this.openSeparatorPopup();
    }

    if(this.cardType === 'listicleElement'){
      this.openlisticlePopup();
    }

    if(this.cardType === 'howToSteps') {
      this.openStepPopup();
    }
    if(this.cardType === 'recipe') {
      this.openRecipePopup();
    }
    if(this.cardType === 'podcast') {
      this.openPodcastPopup();
    }

    if (this.cardType === 'market') {
      this.getMutualFundList();
      this.getMarketList();
      if(this.cardData.indice && this.cardData.indice.type && this.cardData.indice.type !== 'MF') {
        this.marketList[0] = this.cardData.indice;
      }
      if(this.cardData.indice && this.cardData.indice.type && this.cardData.indice.type === 'MF') {
        this.mutualFundList[0] = this.cardData.indice;
      }
      if(this.cardData.indicesNew && this.cardData.indicesNew.type) {
        this.newMarketList[0] = this.cardData.indicesNew;
      }
      if(this.cardData.indicesList && this.cardData.indicesList.length>0) {
        this.newMarketList = this.cardData.indicesList;
      }
      this.marketCode = this.cardData.indice.code;
      this.marketText = this.cardData.indice.name;
      this.deactivateMarketSuggestion = false;
      this.deactivateNewMarketSuggestion = false;
      this.marketPopup = true;
      this.sharedService.overflowhidden();
    }
    if (this.cardType === 'productElement') {
      this.brandEleQuery = this.cardData.product.brandName;
      this.modelEleQuery = this.cardData.product.modelName;
      this.productElement = {
        'brand' : this.cardData.product.brandName,
        'model' : this.cardData.product.modelName,
      }
      if(this.domainConfig['elementsDisabled'].indexOf('categoryProductElement') === -1) {
        this.categoryEleQuery = this.cardData.product.categoryName;
        this.productElement['category'] = this.cardData.product.categoryName;
        this.productElement['modelId'] = this.cardData.product.modelId;
        this.productElement['url'] = this.cardData.product.productUrl;
        this.productElement['categoryId'] = this.cardData.product.categoryId;
        this.showCategoryProductPopup = true;
        this.restService.http_get(
          this.config.get('product').baseUrl + '/api/cms/story/productcategories'
            ).subscribe(res => {
              this.filteredCategorySuggestion = res;
              this.categorySuggestion = res;
              this.brandSuggestion = [];
              this.modelSuggestion = [];
            });
      } else {
        this.showProductPopup = true;
        this.loadBrands(false);
      }

      this.sharedService.overflowhidden();
    }

    if (this.cardType === 'cricket') {
        this.matchPopup = true;
        this.sharedService.overflowhidden();
    }

    if (this.cardData && this.cardData.id && this.EditMode && this.cardData.reusable) {
      this.focusFlag = true;
      this.lockAcquire(this.cardData.id, flag => {
        if (flag) {
          if (this.cardType !== 'listicle' && this.cardType !== 'highlights') {
            this.childKeyDown.emit(true);
          }
        }
      });
    } else {
      this.focusFlag = true;
      this.childKeyDown.emit(true);
    }
  }

  onelementBlur() {
    if (this.cardType === 'paragraph' || this.cardType === 'listicle'
      || this.cardType === 'liveblog' || this.cardType === 'photostory' || this.cardType === 'highlights' || this.cardType === 'newsroom') {
      this.focusFlag = false;
      this.temporaryView = null;
      this.tempViewData = null;
    }

    if (this.cardType === 'paragraph' && this.id !== 'newElement' && !this.cardData.paragraph.body) {
      this.deleteElement();
    }

    // console.log('on blur ==== >  ' + this.cardData.id, this.id, this.cardType, this.cardData);
    if (this.cardType === 'paragraph' && this.id === 'newElement' && this.cardData.id !== null) {
      // console.log(this.range);
      if (this.range || this.isCKEditorEnabled) {
        this.deleteTempViewOfPara.emit({
          id: this.id,
          cardId: this.cardData.id
        });
      }
    }

    const focusedElement = document.activeElement;

    if (this.cardType === 'image' || this.cardType === 'gif') {
      this.editCardFlag = false;
      this.ckEditorEnableReadOnlyMode();
      this.nextFocusEmit.emit({
        current: this.id,
        pos: 'start'
      });
      if (this.captionFocusFlag) {
        this.captionFocusFlag = false;
        this.captionEditor.blur();
      }
      this.cursorFocus = false;
    }

    // console.log(this.cardId);

    if (this.cardId) {
      if (this.cardType !== 'image' && this.cardType !== 'embed' && this.cardType !== 'market' && this.cardType !== 'cricket'
      && this.cardType !== 'relatedstory' && this.cardType !== 'relatedstoryhowto' && this.cardType !== 'highlights' && this.cardType !== 'listicle'
      && this.cardType !== 'liveblog' && this.cardType !== 'photostory' && this.cardType !== 'paragraph') {
        if (this.changeFlag) {
          this.overrideSave();
        } else {

          this.lockRelease(this.cardId, res => {
            if (res) {
              // console.log('blurred' + this.cardId);
              if (this.cardType !== 'listicle' && this.cardType !== 'highlights') {
                this.childKeyDown.emit(false);
              }
            } else {
              // console.log('lock not Released');
            }
          });
        }
      } else {
        this.childKeyDown.emit(false);
      }
    }
  }

  currentCardEmit() {
    this.currentcardfn.emit(this.id);
  }

  setCardBody(content) {
    this.cardData.paragraph.body = content;
    this.changeFlag = true;
  }

  public listClick(event, selectedValue1) {
    this.selectedValue = selectedValue1;
    if (selectedValue1 === 1) {
      this.leadMediaImageToggle = !this.leadMediaImageToggle;
    } else {
      this.leadMediaImageToggle = false;
    }
  }

  toggleNewLiveblog(){
    this.cardData.liveBlog.newLiveBlogDesign = !this.cardData.liveBlog.newLiveBlogDesign;
    this.changeFlag = true;
    this.overrideSave();
  }

  public videoImageChange(event, selectedValue1) {
    console.log('VIDEO IMAGE CHANGE', event, selectedValue1)
    this.selectedValue = selectedValue1;
    if (selectedValue1 === 1) {
      this.leadMediaImageToggle = !this.leadMediaImageToggle;
    } else {
      this.leadMediaImageToggle = false;
    }
  }
  showGallery() {
    console.log('storyType',this.storytype)
    if(this.storytype=='liveblog'){
     sessionStorage.setItem('storyType',this.storytype)
    }
    this.isLightbox = true;
    this.isPhotopopup = true;
    this.leadMediaImageToggle = true;
    this.sharedService.overflowhidden();

  }
  disableshowGallery() {
    // console.log('disable show called');
    this.isLightbox = false;
    this.isPhotopopup = false;
    this.leadMediaImageToggle = false;
    this.sharedService.overflowauto();
    this.isDraggedImages=false;
  }

  checkTempImage() {
    if(localStorage.getItem('tempImage')) {
      this.tempImage = localStorage.getItem('tempImage');
      return true;
    }
    else {
      return false;
    }
  }


  getLeadMediaId(ev, temp = false) {
    if (ev.type === 'wire') {
      this.uploadImageInProgress = true;
      this.saveCardNewImage(ev, fn => {
        this.uploadImageInProgress = false;
        if (fn !== false) {
          if (this.cardType === 'listicle' || this.cardType === 'highlights') {
            this.deleteImageCardEmit(null);
            setTimeout(e => {
              this.cardData.listicle.inlineElementId = fn.id;
              this.changeFlag = true;
              this.overrideSave();
            }, 100);
          } else if (this.cardType === 'liveblog' ||  this.cardType === 'newsroom'||this.cardType === 'mintlite') {
            this.deleteImageCardEmit(null);
            setTimeout(e => {
              if(!this.multipleElementLiveblog) {
                this.cardData.liveBlog.inlineElementId = fn.id;
              } else {
                this.cardData.liveBlog.inlineElementIdList? this.cardData.liveBlog.inlineElementIdList.push(fn.id) : this.cardData.liveBlog.inlineElementIdList = [fn.id];
              }
              this.changeFlag = true;
              this.overrideSave();
            }, 100);
          } else if (this.storytype === 'photostory' && temp === true) {
            localStorage.setItem('tempImage',fn.id);
            this.changeFlag = true;
            this.overrideSave();
            setTimeout(() => {
              this.photoStoryImg['_results'][0].startCropping();
            }, 1200);
          } else if (this.replaceImagePopupPhotoStory === true) {
            //for photostory
            this.cardData.image = fn.image;
            this.temporaryChangesFlag = true;
            this.replaceImagePopupPhotoStory = false;
            this.overrideSave();
            setTimeout(() => {
              this.startCropping();
            }, 1200);
          }
        } else {
          console.log('couldn\'nt create element');
        }
      });
    } else {
        this.deleteImageCardEmit(null);
        this.uploadImageInProgress = true;
        this.createDuplicateImageChild(ev.id, fn => {
          this.uploadImageInProgress = false;
          if (fn !== false) {
            if (this.cardType === 'liveblog' || this.cardType === 'newsroom'|| this.cardType === 'mintlite' ) {
              if(!this.multipleElementLiveblog) {
              this.cardData.liveBlog.inlineElementId = fn.id;
            } else {
              this.cardData.liveBlog.inlineElementIdList? this.cardData.liveBlog.inlineElementIdList.push(fn.id) : this.cardData.liveBlog.inlineElementIdList = [fn.id];
            }
              this.changeFlag = true;
              this.overrideSave();
            } else if (this.cardType === 'listicle' || this.cardType === 'highlights') {
              this.cardData.listicle.inlineElementId = fn.id;
              this.changeFlag = true;
              this.overrideSave();
            } else if (this.storytype === 'photostory' && temp === true) {
              localStorage.setItem('tempImage',fn.id);
              this.changeFlag = true;
              this.overrideSave();
              setTimeout(() => {
                this.photoStoryImg['_results'][0].startCropping();
              }, 1200);
            } else if (this.replaceImagePopupPhotoStory === true) {
              //for photostory
              this.cardData.image = fn.image;
              this.temporaryChangesFlag = true;
              this.overrideSave();
              this.replaceImagePopupPhotoStory = false;
              setTimeout(() => {
                this.startCropping();
              }, 1200);
            }
          } else {
            // console.log('couldn\'nt create duplicate child');
          }
        });
    }
    // this.disableshowGallery();
    this.replaceImagePopup = false;
  }

  setCheckForErrorIndication(id) {
    if(id ==='slideTitle' && this.cardData.title && this.cardData.title.length>200){
      return true;
    }
    return false;
  }

  saveCardNewImage(imagePath, callback) {
    // console.log(imagePath);
    const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    const fd2 = new FormData();
    fd2.set('file', imagePath.id);
    this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadByUrlEndPoint, fd2).
      subscribe(res => {
        if (defaultImagecardData) {
          defaultImagecardData.id = null;
          defaultImagecardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
          defaultImagecardData.image.images['original'] = res['images']['original'];
          defaultImagecardData.image.caption = imagePath.data.caption ? imagePath.data.caption : '';
          defaultImagecardData.image.imageCredit = imagePath.data.credit ? imagePath.data.credit : '';
          defaultImagecardData.metadata.authors = imagePath.data.byLine ? [imagePath.data.byLine] : [];
          defaultImagecardData.metadata.agency = imagePath.data.agency ? imagePath.data.agency : '';
          // defaultImagecardData.image.images['382x214'] = imagePath.replace(/"/gi, '');
          // defaultImagecardData.image.images['250x250'] = imagePath.replace(/"/gi, '');
          // defaultImagecardData.image.images['90x60'] = imagePath.replace(/"/gi, '');
          this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
            defaultImagecardData, result => {
              if (!result.hasOwnProperty('error')) {
                callback(result);
              } else {
                callback(false);
              }
            });
        }
      });
  }

  onFileChange(event, model) {
    const fd = new FormData();
    this.selectedFile = <File>event.target.files[0];
    if (event.target.files && event.target.files.length > 0) {
      if ((this.selectedFile.size / 1000000) <= 11) {
        fd.append('file', this.selectedFile, this.selectedFile.name);
        this.increasePendingCount();
        this.uploadImageInProgress = true;
        this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
          subscribe(res => {
            this.uploadImageInProgress = false;
            this.decreasePendingCount();
            if (res['name'].includes('pdf')) {
              this.snotify.success('Pdf file Uploaded Successfully', '', this.sharedService.getConfig(false));
              this.previewPdf(res);
            } else {
              this.saveCardOnFly(res['images'].original, model);
            }
            // console.log(model);
            // console.log(res);
          //  this.saveCardOnFly(res['images'].original, model);
          },
          err => {
            this.uploadImageInProgress = false;
            if(err.error.errorMessage && err.error.errorMessage.indexOf('low')!=-1){
            this.snotify.error('Upload Failed', '', this.sharedService.getConfig(false));
            this.failedImageUploadCatcher();}
            else{
              this.snotify.error(err.error.errorMessage, '', this.sharedService.getConfig(false));
            }
          });
      } else {
        this.selectedFile = null;
        this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
      }
    }
  }

  failedImageUploadCatcher()
  {
    this.failedImageUploadEmit.emit(true);
  }

    getRelatedStoryData(ev){
      console.log('receivedRelatedStoryData',ev)
     if(this.relatedStoryType == 'video')
     {
      this.cardData.relatedVideoStories=[ev.id];
     } else{
      this.cardData.relatedStories=[ev.id];
     }
     this.tempCardData.relatedStoryHeadline=ev.headline
     this.temporaryChangesFlag=true;
     console.log('cardData',this.cardData)
     console.log('cardType',this.cardType);
     console.log('storyType',this.storytype);
      this.closeRelatedStoryModal(null);
    }
    receivedRelatedStoryHeadline(ev){
      this.tempCardData.relatedStoryHeadline=ev;
    }

    openRelatedStoryForImageTypeModal(ev) {
      this.relatedStoryTempList = this.cardData.relatedStories ? JSON.parse(JSON.stringify(this.cardData.relatedStories)) : [];
      if (ev === 'multiple') {
        this.relatedStoryMultipleSelectFlag = true;
      } else {
        this.relatedStoryMultipleSelectFlag = false;
      }
      this.relatedStoryType='gallery';
      this.showRelatedStoryPopup = true;
      this.sharedService.overflowhidden();
    }

    openRelatedStoryForVideoTypeModal(ev) {
      this.relatedStoryTempList = this.cardData.relatedVideoStories ? JSON.parse(JSON.stringify(this.cardData.relatedStories)) : [];
      if (ev === 'multiple') {
        this.relatedStoryMultipleSelectFlag = true;
      } else {
        this.relatedStoryMultipleSelectFlag = false;
      }
      this.relatedStoryType='video';
      this.showRelatedStoryPopup = true;
      this.sharedService.overflowhidden();
    }

  saveCardOnFly(imagePath, model) {
    // console.log(imagePath);
    const imageCardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    imageCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    if (imageCardData) {
      imageCardData.id = null;
      imageCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
      imageCardData.image.images['original'] = imagePath.replace(/"/gi, '');
      // imageCardData.image.images['382x214'] = imagePath.replace(/"/gi, '');
      // imageCardData.image.images['250x250'] = imagePath.replace(/"/gi, '');
      this.increasePendingCount();
      this.uploadImageInProgress = true;
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        imageCardData, result => {
          this.uploadImageInProgress = false;
          this.decreasePendingCount();
          if (this.cardType === 'listicle' || this.cardType === 'highlights') {
            this.cardData.listicle.inlineElementId = result.id;
          }
          if (this.cardType === 'liveblog' || this.cardType === 'newsroom'|| this.cardType === 'mintlite') {
            if(!this.multipleElementLiveblog) {
              this.cardData.liveBlog.inlineElementId = result.id;
              console.log(this.cardData.liveBlog)
            } else {
              this.cardData.liveBlog.inlineElementIdList? this.cardData.liveBlog.inlineElementIdList.push(result.id) : this.cardData.liveBlog.inlineElementIdList = [result.id];
            }
          }
          if(this.cardType === 'image' && this.storytype ==='photostory') {
            localStorage.setItem('tempImage',result.id)
            setTimeout(() => {
                this.photoStoryImg['_results'][0].startCropping();
            }, 1200);
          }
          this.changeFlag = true;
          this.overrideSave();
        });
    }
  }

  setImageUrl(ampValidated, verticalFlag, imagemap) {
    if (this.cardType === 'image' || this.cardType === 'gif') {
      this.cardData.imageAmpValidated = ampValidated;
      this.cardData.image.verticalImage = verticalFlag;
      this.cardData.image.images = imagemap;
      if(this.cardType === 'image')
      {
        this.cardData.imageMeta = false;
      }
      if(!this.cardData.reusable) {
        this.temporaryChangesFlag = true;
        this.changeFlag = true;
        this.saveCard(true, flag2 => {});
      } else {
        this.lockAcquire(this.cardId, flag => {
          this.temporaryChangesFlag = true;
          this.changeFlag = true;
          this.saveCard(true, flag2 => {
            this.lockRelease(this.cardId, e => {
            });
          });
        });
      }
    }
  }

  deleteImageCardEmit(ev) {
    if (this.cardType === 'listicle' || this.cardType === 'highlights') {
      this.cardData.listicle.inlineElementId = null;
      this.leadMediaImageToggle = false;
    } else if (this.cardType === 'liveblog' || this.cardType === 'newsroom'|| this.cardType === 'mintlite') {
      if(!this.multipleElementLiveblog) {
        this.cardData.liveBlog.inlineElementId = null;
      } else {
        if(this.cardData.liveBlog.inlineElementId === ev) {
          this.cardData.liveBlog.inlineElementId = null;
        } else {
          this.cardData.liveBlog.inlineElementIdList.splice(this.cardData.liveBlog.inlineElementIdList.indexOf(ev),1)
        }
      }
      this.liveblogDelete.emit(ev);
      this.leadMediaImageToggle = false;
      this.getEmbedSourceUrl(null);
    } else if (this.cardType === 'photostory') {
      // this.cardData.photoStory.inlineElementId = null;
      this.leadMediaImageToggle = false;
      this.getEmbedSourceUrl(null);
    }
    this.changeFlag = true;
    this.overrideSave();
  }
  updateAlsoReadHeadline(ev) {
    this.cardData.alsoReadStories[ev.id] = ev.newHeading;
    this.changeFlag = true;
    this.overrideSave();
  }
  replaceAlsoReadStory(ev) {
    console.log(ev);

  }
  deleteAlsoReadStory(ev) {
    this.cardData.alsoReadStoryIdList.splice(ev.index, 1);
    delete this.cardData.alsoReadStories[ev.id];
    delete this.cardData.alsoReadStoriesUrl[ev.id];
    this.changeFlag = true;
    this.overrideSave();
    if (this.cardData && this.cardData !== null && this.cardData.alsoReadStoryIdList.length === 0) {
      this.deleteElement();
    }
  }


  deleteRelatedStory(ev) {
    // console.log(this.cardData.relatedStories.indexOf(ev));
    this.cardData.relatedStories.splice(ev.index, 1);
    this.changeRelated.emit(this.cardData.relatedStories);
    this.changeFlag = true;
    this.overrideSave();

    if (this.cardData && this.cardData !== null && this.cardData.relatedStories.length === 0) {
      this.deleteElement();
    }
  }
  deleteRelatedStoryHowto(ev) {
    // console.log(this.cardData.relatedStories.indexOf(ev));
    this.cardData.relatedStoriesHowTo.splice(ev.index, 1);
    this.changeRelatedHowto.emit(this.cardData.relatedStoriesHowTo);
    this.changeFlag = true;
    this.overrideSave();

    if (this.cardData && this.cardData !== null && this.cardData.relatedStoriesHowTo.length === 0) {
      this.deleteElement();
    }
  }

  replaceRelatedStory(ev) {
      this.tempRelatedStoryId = ev.id;
      this.openRelatedStoryModal('single');
   }
   //for related stort howto type
  replaceRelatedStoryhowto(ev) {
      this.tempRelatedStoryIdhowto = ev.id;
      this.openRelatedHowtoStoryModal('single');
   }

   updateRelatedStory(){
    console.log("this.tempRelatedStoryForm",this.tempRelatedStoryForm)
    this.changeFlag = true;
    this.tempRelatedStoryForm.value.relatedStoryData.forEach(data=>{
      if (!data.storyDescription.includes('<a') && !data.title.includes('<a')) {
        data.title = `<a href='${data.url+'?src=bp_related'}' target='_blank'>${data.title}</a>`
      }
      })
    this.cardData.relatedStoryMainTitle = this.tempRelatedStoryForm.value.heading;
    this.cardData.relatedStoryMainDescription = this.tempRelatedStoryForm.value.description;
    this.cardData.relatedStoryData = this.tempRelatedStoryForm.value.relatedStoryData;
    this.cardData.relatedStories = this.storyList;
    this.cardData.relatedStoryHtml = this.generateHTML();
    this.changeRelated.emit(this.cardData.relatedStories);
    this.overrideSave();
    this.showEditRelatedStoryPopup = false;
    let preview = this.generateHTML();
   }

   generateHTML() {
    const appendedValue = '?src=bp_related';
    this.cardData.relatedStoryData =  this.cardData.relatedStoryData.map(content => {
      const urlRegex = /(https:\/\/[^\s]+)(?=">)/g;
      const matches = content.storyDescription.match(urlRegex);
      if(matches && matches.length>0){
        matches.forEach(ele=>{
        if(!ele.includes(appendedValue)){
          const originalUrl = ele;
          const updatedUrl = originalUrl  + appendedValue;
          content.storyDescription = content.storyDescription.replace(originalUrl, updatedUrl);
        }
      })
      }
      return content;
    });
    console.log("this.cardData.relatedStoryData", this.cardData.relatedStoryData);
    const dynamicHtml =  this.cardData.relatedStoryData.map(data => `<li class='relatedStoryListView'><h5 class='relatedStoryListHeadline'>${data.title}</h5><p>${this.getPlainText(data.storyDescription)}</p></li>`).join('');
    let staticHtml = `<div class='mainContainer spacing'><div class='subContainer'><h4 class='relatedStoryHeadline'>${this.cardData.relatedStoryMainTitle}</h4><p>${this.cardData.relatedStoryMainDescription}</p><ul class='relatedStoryList'>${dynamicHtml}</ul></div></div><style>.mainContainer{display:block; padding: 30px;  font-size: 16px; color: #333; font-family: "Lato",sans-serif;}.mainContainer.spacing{padding:0px; margin: 20px 0px 20px -10px; min-height:auto;}.mainContainer.spacing p{font-size:16px; line-height:22px;}.subContainer{display: block;  padding: 20px; border: 1px solid #ccc;}.subContainer a{color: #007bff;text-decoration:underline;font-weight:400;}.subContainer a:visited {color: #007bff;text-decoration: underline;}.subContainer a:hover{color: #007bff;text-decoration: underline;}.subContainer a:active{color: #007bff;text-decoration: underline;}.relatedStoryHeadline{font-weight: 700;font-size: 16px;line-height: 22px;padding: 0px 0px 10px 0px; margin: 0;}.relatedStoryList{margin:20px 0 0 0 !important;border-top: 1px solid #ccc;padding: 20px 0 0px 15px;}.relatedStoryListView{margin: 0 0 5px 0; padding: 0; list-style: circle;}.relatedStoryListHeadline{display: inline-block;font-size: 16px;padding:0  10px 0 0 ; margin: 0;font-weight: bold}p{display:inline}</style>`
    const parser = new DOMParser();
    const doc = parser.parseFromString(staticHtml, 'text/html');
    const anchorTag = doc.querySelector('a');
    staticHtml = staticHtml.replace(/"/g, "'");
    return staticHtml.toString();
  }

  getPlainText(htmlString: string): string {
    const plainText = htmlString.replace(/<[^>]*>/g, '');
    return plainText;
  }

   backEditRelatedStoryModel(){
    this.showRelatedStoryPopup = true;
    this.relatedStoryTempList = this.storyList;
    if(this.showEditRelatedStoryPopup){
    this.showEditRelatedStoryPopup = false;
    }
  }

  backPostEditRelatedStoryModel(){
    this.showPostRelatedStoryPopup = true;
    this.relatedStoryTempList = this.storyList;
    if(this.showPostEditRelatedStoryPopup){
    this.showPostEditRelatedStoryPopup = false;
    }
  }

  closeEditRelatedStoryModal(){
    this.showEditRelatedStoryPopup = false;
  }

  closePostEditRelatedStoryModal()
  {
    this.showPostEditRelatedStoryPopup = false;
  }

  getRelatedStoryIds(ev) {
    if ((typeof ev) !== 'number') {
      this.cardData['relatedStories'] = ev;
      this.changeFlag = true;
      this.overrideSave();
      this.closeRelatedStoryModal(null);
    } else {
      const index = this.cardData.relatedStories.indexOf(this.tempRelatedStoryId);
      this.cardData.relatedStories[index] = ev;
      this.changeRelated.emit(this.cardData.relatedStories);
      // this.relatedStoryElements['_results'][index].closeOptions();
      this.changeFlag = true;
      this.overrideSave();
      this.closeRelatedStoryModal(null);
    }
  }

  getPostRelatedStoryIds(ev) {
    const card = JSON.parse(JSON.stringify(StaticDataService.defaultRelatedStoryCardData));
    card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    card['relatedStories'] = ev;
    if(this.enableRelatedStoryPreview){
      card['relatedStoryData'] = this.tempRelatedStoryForm.value.relatedStoryData
      card['relatedStoryMainTitle'] = this.tempRelatedStoryForm.value.heading
      card['relatedStoryMainDescription'] = this.tempRelatedStoryForm.value.description;
      // card['relatedStoryHtml'] = this.generatePostHTML(this.tempRelatedStoryForm.value);
    }
    this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      card, result => {
        this.decreasePendingCount();
        this.closePostRelatedStoryModal(null);
        this.showPostEditRelatedStoryPopup = false;
        if(!this.multipleElementLiveblog) {
          this.cardData.liveBlog.inlineElementId = result.id;
        } else {
          this.cardData.liveBlog.inlineElementIdList? this.cardData.liveBlog.inlineElementIdList.push(result.id) : this.cardData.liveBlog.inlineElementIdList = [result.id];
        }
        this.changeFlag = true;
      });
  }

  generatePostHTML(relatedStory) {
    console.log("related",relatedStory);
    const dynamicHtml = relatedStory.relatedStoryData.map(data => `
      <li style=" margin: 0 0 20px 0; padding: 0; list-style: disc;">
                    <h5 style="display: inline-block;
                    font-size: 16px;
                    padding:0  10px 0 0 ; margin: 0;
                    font-weight: bold; ">${data.title}:</h5>
                    ${data.storyDescription}
                </li>
    `).join('');
    const staticHtml = `
    <!DOCTYPE html>
    <html>
    <head>
    <title>Preview Pop Up</title>
    </head>
    <body>
    <div style="display: block; padding: 30px; font-size: 16px; color: #333; font-family: Arial, Helvetica, sans-serif;">
        <div style="display: block;  padding: 20px; border: 1px solid #ccc;">
            <h4 style="font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        padding: 0px 0px 10px 0px; margin: 0;">${relatedStory.heading}</h4>
            <p>${relatedStory.description}</p>
            <ul style="margin:20px 0 0 0;border-top: 1px solid #ccc;
        padding: 20px 0 15px 15px;">
        ${dynamicHtml}
            </ul>
        </div>
    </div>
</body>
</html>
    `;
    return staticHtml;
  }

  getAlsoReadIds(ev) {
    this.cardData['alsoReadStoryIdList'] = ev;
    this.changeFlag = true;
    this.overrideSave();
    setTimeout(() => {
      this.reload();
    }, 1000);
    this.closeRelatedStoryModal(null);
  }

  getRelatedStoryHowtoIds(ev) {
    // console.log(ev);
    console.log('In Edit Case')
    if ((typeof ev) !== 'number') {
      this.cardData['relatedStoriesHowTo'] = ev;
      this.changeFlag = true;
      this.overrideSave();
      this.closeRelatedStoryModalHowto(null);
    } else {
      const index = this.cardData.relatedStoriesHowTo.indexOf(this.tempRelatedStoryIdhowto);
      this.cardData.relatedStoriesHowTo[index] = ev;
      this.changeRelatedHowto.emit(this.cardData.relatedStoriesHowTo);
      // this.relatedStoryElements['_results'][index].closeOptions();
      this.changeFlag = true;
      this.overrideSave();
      this.closeRelatedStoryModalHowto(null);
    }
  }

  openAlsoReadStoryModal(ev) {
    this.relatedStoryTempList = this.cardData.alsoReadStoryIdList ? JSON.parse(JSON.stringify(this.cardData.alsoReadStoryIdList)) : [];
    if (ev === 'multiple') {
      this.relatedStoryMultipleSelectFlag = true;
    } else {
      this.relatedStoryMultipleSelectFlag = false;
    }
    this.relatedStoryType='alsoread';
    this.showAlsoReadStoryPopup = true;
    this.sharedService.overflowhidden();
  }

  openEditRelatedStoryPopupData(event){
      this.relatedStoryArray=[];
      this.relatedStoryTitleArray=[];
      this.showEditRelatedStoryPopup = true;
      this.storyList = event;
      this.resetRelationStoryForm();
      const filteredData = this.storyList.filter(id => !this.cardData.relatedStoryData.some(obj => obj.id === id));
      (<FormArray>this.tempRelatedStoryForm.controls['relatedStoryData']).removeAt(0);
        this.cardData.relatedStoryData.forEach((ele)=>{
          if(this.storyList.includes(ele.id)){
            const group = this.formBuilder.group({
              id: new FormControl(ele.id, [Validators.required]),
              title: new FormControl(ele.title, [Validators.required]),
              storyDescription: new FormControl(ele.storyDescription, [Validators.required]),
              url: new FormControl(ele.url)
            });
            (<FormArray>this.tempRelatedStoryForm.get('relatedStoryData')).push(group);
          }
          })
          if(filteredData.length>0){
            filteredData.forEach((ele,index)=>{
              this.restService.http_get(this.config.get('product').baseUrl
              + this.config.getEndPoint(this.config.get('views'), StaticDataService.story_page_id, StaticDataService.story_get_api)
              + '/' + ele)
              .subscribe(
                data => {
                    const group = this.formBuilder.group({
                    id: new FormControl(data.id, [Validators.required]),
                    title: new FormControl(data.title, [Validators.required]),
                    storyDescription: new FormControl(data.summary, [Validators.required]),
                    url: new FormControl(data.metadata.url)
                  });
                  (<FormArray>this.tempRelatedStoryForm.get('relatedStoryData')).push(group);
                })
            })
          }
  }

  openPostEditRelatedStoryPopupData(event){
    this.relatedStoryArray=[];
    this.relatedStoryTitleArray=[];
     this.showPostEditRelatedStoryPopup = true;
     this.storyList = event;
     console.log("storyList",this.storyList);
     //this.resetRelationStoryForm();
     (<FormArray>this.tempRelatedStoryForm.controls['relatedStoryData']).removeAt(0);
     this.storyList.forEach((ele,index)=>{
       this.restService.http_get(this.config.get('product').baseUrl
       + this.config.getEndPoint(this.config.get('views'), this.story_page_id, this.story_get_api)
       + '/' + ele)
       .subscribe(
         data => {
             const group = this.formBuilder.group({
             id: new FormControl(data.id, [Validators.required]),
             title: new FormControl(data.title, [Validators.required]),
             storyDescription: new FormControl(data.summary, [Validators.required]),
           });
           (<FormArray>this.tempRelatedStoryForm.get('relatedStoryData')).push(group);
         })
     })
 }

  resetRelationStoryForm(){
    this.tempRelatedStoryForm = this.formBuilder.group({
      heading: new FormControl(this.cardData.relatedStoryMainTitle),
      description: new FormControl(this.cardData.relatedStoryMainDescription),
      relatedStoryData: this.formBuilder.array([ this.relatedStoryItem() ])
    });

  }

  relatedStoryItem(): FormGroup {
    return this.formBuilder.group({
      id: new FormControl(''),
      title: new FormControl(''),
      storyDescription: new FormControl(null),
      url: new FormControl(null)
    });
  }

  openRelatedStoryModal(ev) {
    this.relatedStoryTempList = this.cardData.relatedStories ? JSON.parse(JSON.stringify(this.cardData.relatedStories)) : [];
    if (ev === 'multiple') {
      this.relatedStoryMultipleSelectFlag = true;
    } else {
      this.relatedStoryMultipleSelectFlag = false;
    }
    this.relatedStoryType='';
    this.showRelatedStoryPopup = true;
    this.sharedService.overflowhidden();
  }

  openPostRelatedStoryModal(ev)
  {
    if (ev === 'multiple') {
      this.relatedStoryMultipleSelectFlag = true;
    } else {
      this.relatedStoryMultipleSelectFlag = false;
    }
    this.relatedStoryType='';
    this.showPostRelatedStoryPopup = true;
    this.resetRelationStoryForm();
    this.sharedService.overflowhidden();
  }

  openRelatedHowtoStoryModal(ev) {
    this.relatedStoryTempList = this.cardData.relatedStories ? JSON.parse(JSON.stringify(this.cardData.relatedStoriesHowTo)) : [];
    if (ev === 'multiple') {
      this.relatedStoryMultipleSelectFlag = true;
    } else {
      this.relatedStoryMultipleSelectFlag = false;
    }
    this.relatedStoryType='howto';
    this.showRelatedStoryPopup = true;
    this.sharedService.overflowhidden();

  }

  closeRelatedStoryModal(ev) {
    if(this.relatedStoryType=='howto'){
      this.closeRelatedStoryModalHowto(null);
    } else if(this.cardData.type === 'alsoread'){
      this.showAlsoReadStoryPopup = false;
      this.tempRelatedStoryId = null;
      this.relatedStoryTempList = [];
      this.sharedService.overflowauto();
      if (this.cardData && this.cardData !== null && this.cardData.alsoReadStoryIdList.length === 0 ) {
        this.deleteElement();
      }
    } else{
      this.showRelatedStoryPopup = false;
      this.tempRelatedStoryId = null;
      this.relatedStoryTempList = [];
      this.sharedService.overflowauto();
      if (this.cardData && this.cardData !== null && this.cardData.relatedStories.length === 0 ) {
        this.deleteElement();
      }
    }

  }

  closePostRelatedStoryModal(ev) {
      this.showPostRelatedStoryPopup = false;
      this.tempRelatedStoryId = null;
      this.relatedStoryTempList = [];
      this.sharedService.overflowauto();
  }

  closeRelatedStoryModalHowto(ev) {
    this.showRelatedStoryPopup = false;
    this.tempRelatedStoryIdhowto = null;
    this.relatedStoryTempList = [];
    this.sharedService.overflowauto();
    if (this.cardData && this.cardData !== null && this.cardData.relatedStoriesHowTo.length === 0 ) {
      this.deleteElement();
    }
  }

  imageNotLoaded(ev) {
    // console.log(ev);
  }

  overrideSave() {

    if (this.cardData !== null && this.cardData.id !== null) {
      if(!this.cardData.reusable) {
        this.isLocked = true;
        this.cardData['lockedByUserId'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['email'];
        this.cardData['lockedByUserName'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['name'];
        this.saveCard(true, flag2 => {});
    } else {
      this.lockAcquire(this.cardData.id, flag => {
        if (flag) {
          this.saveCard(true, flag2 => {
            this.lockRelease(this.cardData.id, flag3 => {
              if (!flag3) {
                // console.log('lock not released');
              }
            });
          });
        } else {
          console.log('lock not acquired');
        }
      });
    }

    } else {
      console.log('override cancelled');
    }
  }

  calculateElementWordCount(ev) {
    this.sendWordCountToStory.emit(ev ? ev : {
      id: this.cardId
    });
  }

  getWordCount(ev) {
    //   const ev2 = {
    //     id: this.cardId,
    //     count: ev.count
    //   };
    //   this.sendWordCountToStory.emit(ev2);
  }

  htmlToPlaintext(text) {
    if (typeof text === 'string') {
      return text ? String(text).replace(/<[^>]+>/gm, '') : '';
    } else {
      return text;
    }
  }

  zoomSlider(x, img) {
    // console.log(x);
    if (this.angularCropper11 || this.angularCropper169) {
      if (img === '16:9') {
        // console.log(x, this.initZoom169);
        // console.log(x > this.initZoom169);
        if (x > this.initZoom169) {
          this.angularCropper169.cropper.zoom(0.1);
          this.initZoom169 = x;
          // console.log('zoom in');
        } else {
          this.angularCropper169.cropper.zoom(-0.1);
          this.initZoom169 = x;
          // console.log('zoom out');
        }
      } else if (img === '1:1') {
        // console.log(this.initZoom11);
        if (x > this.initZoom11) {
          this.angularCropper11.cropper.zoom(0.1);
          this.initZoom11 = x;
          // console.log('zoom in');
        } else {
          this.angularCropper11.cropper.zoom(-0.1);
          this.initZoom11 = x;
          // console.log('zoom out');
        }
      } else if (img === '2:3') {
        // console.log(this.initZoom11);
        if (x > this.initZoom23) {
          this.angularCropper23.cropper.zoom(0.1);
          this.initZoom23 = x;
          // console.log('zoom in');
        } else {
          this.angularCropper23.cropper.zoom(-0.1);
          this.initZoom23 = x;
          // console.log('zoom out');
        }
      }
    }
  }

  finishProductCropping(event, model) {
    console.log('finishCropping  Prodcut called');
    const requests = event.cropRequests;
    const verticalFlag = event.verticalFlag;
    const differentLeadFlag = event.differentImage;
    this.cancelCropping();
    this.increasePendingCount();
    this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
      if (!data.hasOwnProperty('error')) {
        const { ampFlag, imagemap } = data;
        let obj = { images: data.imagemap}
        this.tempOtherAffiliateProductImage = [obj.images["90x90"], obj.images["1600x900"] ]
        console.log(this.tempOtherAffiliateProductImage)
      } else {
        this.snotify.error('Image cropping failed', '', this.sharedService.getConfig(false));
      }
    });
  }

  cancelCropping() {
    this.showCropper = false;
    this.showLBcropper = false;
    this.showHowToStepsCropper = false;
    this.showLBcropper = false;
    this.addVideoThumbnail=false;
    this.showListicleCropper = false;
    this.showProductImageCropper = false;
    this.showRecipeStepsCropper = false;
    this.cropperImageUrl = {
      url: null,
      data: null,
      blobData: null
    };
    this.cropForLeadMedia = false;

    this.cropCompletedEvent.emit('Cropping completed');
    // this.sharedService.overflowauto();
  }

  finishCropping(event) {
    const requests = event.cropRequests;
    const verticalFlag = event.verticalFlag;
    const differentLeadFlag = event.differentImage;
    if (this.cropForLeadMedia) {
      if(this.photoStoryType) {
        this.updatePhotoStoryLeadMedia(this.id)
      }
      this.setAsLeadMediafn.emit(this.id);
    }
    this.cancelCropping();

    this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
      if (!data.hasOwnProperty('error')) {
        const { ampFlag, imagemap } = data;
        if(this.ogImage == true)
        {
          delete imagemap['ampImage'];
          this.cardData.imageMeta = false;
        }
        this.ampValidationOutput.emit(ampFlag);
        this.cardData.imageAmpValidated = ampFlag;
        this.cardData.image.verticalImage = verticalFlag;
        this.cardData.image.images = imagemap;

        setTimeout(e => {
          this.temporaryChangesFlag = true;
          this.changeFlag = true;
          this.overrideSave();
        }, 0);
      } else {
        console.log(data);
      }
    });
  }

  finishCroppingStepsImage(event, model) {
    console.log('finishCroppingHowToStepsImage called');
    const requests = event.cropRequests;
    const verticalFlag = event.verticalFlag;
    const differentLeadFlag = event.differentImage;
    this.cancelCropping();
    this.increasePendingCount();
    this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
      this.decreasePendingCount();
      if (!data.hasOwnProperty('error')) {
        const { ampFlag, imagemap } = data;
        console.log('data', data);
        let obj = { images: data.imagemap}
        this.attachStepImage(obj, model);
        this.SingleselectedFile = null;
        this.increasePendingCount();
      } else {
        this.snotify.error('Image cropping failed', '', this.sharedService.getConfig(false));
      }
    });
  }
  finishCroppingVideoThumbnail(event) {
    const requests = event.cropRequests;
    const verticalFlag = event.verticalFlag;
    const differentLeadFlag = event.differentImage;
    if (this.cropForLeadMedia) {
      if(this.photoStoryType) {
        this.updatePhotoStoryLeadMedia(this.id)
      }
      this.setAsLeadMediafn.emit(this.id);
    }
    this.cancelCropping();
    this.increasePendingCount();
    this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
      this.decreasePendingCount();
      console.log(' this.cardData.image.images', data)
      console.log(' this.cardData', this.cardData)
      this.cardData.video.image.images={};
      this.cardData.video.image.images={...data.imagemap};
      this.saveCard(true, flag2 => {});

      this.sendReplaceVideoImage.emit(data)
      if (!data.hasOwnProperty('error')) {
        // const { ampFlag, imagemap } = data;
        // this.ampValidationOutput.emit(ampFlag);
        // this.cardData.imageAmpValidated = ampFlag;
        // this.cardData.image.verticalImage = verticalFlag;
        // this.cardData.image.images = imagemap;
        // console.log(' this.cardData.image.images', imagemap)
        setTimeout(e => {
          this.temporaryChangesFlag = true;
          this.changeFlag = true;
          this.overrideSave();
        }, 0);
      } else {
        console.log(data);
      }
    });
  }

  addStepsInlineImageEmit(ev, model) {
    // console.log(model, 'image event :: ');
    // console.log(ev);
    this.disableStepsInlineImage()
    if (ev.type === 'wire') {
      console.log(ev);
      this.saveImageCard(ev, model);
      // this.disableInlineImage();
    } else {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
        + '/' + ev.id
      )
        .subscribe(result => {
          console.log('addStepsInlineImageEmit, result :: ');
          console.log(result);
          if(result && result['image']) {
            if(model === 'listicleUploadImage') {
              this.addListicleImageMedia(result.image.images.original);
            }
            if(model === 'FAQUploadImage') {
              this.addFAQImageMedia(result.image.images.original,result.id);
            }
            if(model === 'quesFAQUploadImage') {
              this.addQuesFAQImageMedia(result.image.images.original,result.id);
            }
            if(model === 'pollUploadImage') {
              this.addPollImageMedia(result.image.images.original,result.id);
            }
            const elementImageURL = this.sharedService.getImageOnPriority(result['image']['images'], 'original');
            const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL;
            this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
              if (data !== false) {
                console.log("image data : 1 :: ", data, model);
                this.openStepsCropper(false, data, model);
              } else {
                this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
              }
            });
          }
          // this.attachStepImage(result.image);

        },
          err => {
            this.snotify.error('Image could not be added', '', this.sharedService.getConfig(false));
          });
    }
  }

  addListicleImageMedia(result) {
    const ImageCardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    ImageCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    ImageCardData.id = null;
    ImageCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
    ImageCardData.image.images = {};
    ImageCardData.image.images['original'] = result;
    ImageCardData.image['infographicImage'] = true;
    this.SingleselectedFile = null;
    this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      ImageCardData, image => {
        let obj = { image: image.image}
        this.decreasePendingCount();
        this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaId').setValue(image.id);
        this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('media').setValue(obj);
        this.videoIndex = ''
        this.imageLoaderShow = false;
      });
    this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaType').setValue('image');
    this.SingleselectedFile = null;
  }

  addFAQImageMedia(result,parentElementId) {
    const ImageCardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    ImageCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    ImageCardData.id = null;
    ImageCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
    ImageCardData.image.images = {};
    ImageCardData.image.images['original'] = result;
    ImageCardData.parentElementId = parentElementId
    ImageCardData.image['infographicImage'] = true;
    ImageCardData['removeLowQualityRestriction'] = true;
    this.SingleselectedFile = null;
    this.increasePendingCount();
    console.log("FAQ Media being uploaded")
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      ImageCardData, image => {
        let obj = { image: image.image}
        this.decreasePendingCount();
        this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaIdValue').setValue(image.id);
        this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaValue').setValue(obj);
        this.videoIndex = ''
      });
    this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaTypeValue').setValue('image');
    this.SingleselectedFile = null;
  }
  addQuesFAQImageMedia(result,parentElementId) {
    const ImageCardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    ImageCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    ImageCardData.id = null;
    ImageCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
    ImageCardData.image.images = {};
    ImageCardData.image.images['original'] = result;
    ImageCardData.parentElementId = parentElementId
    ImageCardData.image['infographicImage'] = true;
    ImageCardData['removeLowQualityRestriction'] = true;
    this.SingleselectedFile = null;
    this.increasePendingCount();
    console.log("FAQ Media being uploaded")
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      ImageCardData, image => {
        let obj = { image: image.image}
        this.decreasePendingCount();
        this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaIdKey').setValue(image.id);
        this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaKey').setValue(obj);
        this.videoIndex = ''
      });
    this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaTypeKey').setValue('image');
    this.SingleselectedFile = null;
  }

  addPollImageMedia(result,parentElementId) {
    const ImageCardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    ImageCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    ImageCardData.id = null;
    ImageCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
    ImageCardData.image.images = {};
    ImageCardData.image.images['original'] = result;
    ImageCardData.parentElementId = parentElementId
    ImageCardData.image['infographicImage'] = true;
    ImageCardData['removeLowQualityRestriction'] = true;
    this.SingleselectedFile = null;
    this.increasePendingCount();
    console.log("FAQ Media being uploaded")
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      ImageCardData, image => {
        let obj = { image: image.image}
        this.decreasePendingCount();
        if(typeof(this.videoIndex) == 'string')
        {
          this.tempnewFAQData.get('mediaIdKey').setValue(image.id);
          this.tempnewFAQData.get('mediaKey').setValue(obj);
          this.tempnewFAQData.get('mediaTypeKey').setValue('image');
        } else {
          this.tempnewFAQData.get('ansArray')['controls'][this.videoIndex].get('mediaIdValue').setValue(image.id);
          this.tempnewFAQData.get('ansArray')['controls'][this.videoIndex].get('mediaValue').setValue(obj);
          this.tempnewFAQData.get('ansArray')['controls'][this.videoIndex].get('mediaTypeValue').setValue('image');
        }
        this.videoIndex = ''
        this.imageLoaderShow = false;
      });

    this.SingleselectedFile = null;
  }

 addWireImageForReplaceVideoThumbnail(ev){
  if (ev.type === 'wire') {
    console.log(ev);
    this.saveImageCard(ev, 'videoThumbnailReplace');
  }
  else {
    this.restService.http_get(
     this.config.get('product').baseUrl
     + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
     + '/' + ev.id
   )
     .subscribe(result => {
       console.log('videoThumbnailReplace, result :: ');
       console.log(result);
       if(result && result['image']) {
        const elementImageURL = this.sharedService.getImageOnPriority(result['image']['images'], 'original');
        const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL;
        this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
          if (data !== false) {
            console.log("image data : 1 :: ", data);
            this.changeDetection.detectChanges();
            this.openVideoThumbnailReplaceFromLibraryCropper(false, data);
          } else {
            this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
          }
        });
       }
     },
       err => {
         this.snotify.error('Image could not be added', '', this.sharedService.getConfig(false));
       });
 }
 this.isLightbox=false;
 this.leadMediaImageToggle = false;
 this.inlineImageToggle = false;
 }

 attachStepImage(image, model) {
  if(model === 'howToSteps') {
    this.steps = this.tempHowToStepsData.get('steps') as FormArray;
  } else if(model === 'recipe') {
    this.steps = this.tempRecipeData.get('steps') as FormArray;
  }
  this.steps.at(this.currentStep).patchValue({stepImage: image});
  // console.log(this.tempHowToStepsData.getRawValue());
  this.disableStepsInlineImage();
}

disableStepsInlineImage() {
  this.listicleInlineImageFlag = false;
  this.howToStepsInlineImageFlag = false;
  this.FAQInlineImageFlag = false;
  this.quesFAQInlineImageFlag = false;
  this.recipeInlineImageFlag = false;
  this.logoGalleryFlag = false;
  this.addProductImageGalleryFlag = false;
  this.pollInlineImageFlag = false;
  // this.inlineImageToggle = false; // TBC
  this.sharedService.overflowauto();
}

  saveImageCard(imagePath, model) {
    const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
    defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    const fd = new FormData();
    fd.set('file', imagePath.id);
    this.increasePendingCount();

    this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadByUrlEndPoint, fd).
      subscribe(res => {
        this.decreasePendingCount();
        // console.log(res);
        if (defaultImagecardData && res && !res.hasOwnProperty('error')) {
          defaultImagecardData.id = null;
          defaultImagecardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
          defaultImagecardData.image.images['original'] = res['images']['original'];
          defaultImagecardData.image.caption = imagePath.data.caption ? imagePath.data.caption : '';
          defaultImagecardData.image.imageCredit = imagePath.data.credit ? imagePath.data.credit : '';
          defaultImagecardData.metadata.authors = imagePath.data.byLine ? [imagePath.data.byLine] : [];
          defaultImagecardData.metadata.agency = imagePath.data.agency ? imagePath.data.agency : '';

          this.increasePendingCount();
          this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
            defaultImagecardData, result => {
              console.log('result -- > ', result);
              this.decreasePendingCount();
              if(result && result['image']){
                if (model === 'howToSteps') {
                  const elementImageURL = this.sharedService.getImageOnPriority(result['image']['images'], 'original');
                  const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL;
                  this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
                    if (data !== false) {
                      console.log("image data : 1 :: ", data);
                      this.openStepsCropper(false, data, model);
                    } else {
                      this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
                    }
                  });
                  // this.attachStepImage(result.image);
                }
                if(model==='videoThumbnailReplace'){
                  if(result && result['image']) {
                    const elementImageURL = this.sharedService.getImageOnPriority(result['image']['images'], 'original');
                    const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL;
                    this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
                      if (data !== false) {
                        console.log("image data : 1 :: ", data);
                        this.openVideoThumbnailReplaceFromLibraryCropper(false, data);
                      } else {
                        this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
                      }
                    });
                  }
                } if(model === 'pollUploadImage') {
                  this.addPollImageMedia(result.image.images.original,result.id);
                }
              }
            });
        }
      },
        err => {
          this.imageUploadInProgress = false;
        });
  }

  captionPosition(event) {
    this.tempCardData.overImage = event;
  }

  setThisAsLeadMedia() {
    if (this.id === this.leadMediaId) {
      if(this.photoStoryType) {
        this.updatePhotoStoryLeadMedia(this.id)
      }
      this.setAsLeadMediafn.emit(this.id);
    } else {
      // const imageUrl = this.sharedService.getImageOnPriority(this.cardData['image']['images'], 'original');
      const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage +
      this.sharedService.getImageOnPriority(this.cardData['image']['images'], 'original');
      this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
        // console.log(data);
        if (data !== false) {
          if (this.cardData.hasOwnProperty('imageAmpValidated') && this.cardData.imageAmpValidated) {
            this.showCropper = true;

            this.openCropper(true, data);
          } else {
            this.sharedService.checkImageForAMP(reader, flag => {
              if (flag) {
                this.showCropper = true;
                this.openCropper(true, data);
              } else {
                this.sharedService.showAMPConfirmPopup(() => { // yes
                  this.showCropper = true;
                  this.openCropper(true, data);
                },
                  () => { // no
                    this.cancelCropping();
                  }
                );
              }
            });
          }
        } else {
          this.cancelCropping();
          this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
        }
      });
    }
  }
  closeMarketPopup() {
    this.marketPopup = false;
    this.marketCode = '';
    this.marketText = '';
    this.deactivateMarketSuggestion = false;
    this.deactivateNewMarketSuggestion = false;
    this.listicleProductPopup =false;
  }
  closeEmbedPopup() {
    this.showAmazonMeta=false;
    this.showSnapdealMeta = false;
    this.showCromaMeta = false;
    this.showFlipkartMeta = false;
    this.embedPopup = false;
    this.embedCode = '';
    this.embedSourceUrl = '';
    this.embedSubType = '';
    if (this.cardType !== 'liveblog' && this.cardType !== 'newsroom' && this.cardType !== 'mintlite') {
      this.onelementBlur();
      this.lockRelease(this.cardId, null);
    }
    this.sharedService.overflowauto();
  }


  getSelectedOptionText(obj) {
    this.marketCode = obj.target.value;
    this.marketText = obj.target.options[obj.target.selectedIndex].text;
  }

  saveMarketEmbed() {
    if (this.marketCode || this.mutualFundList || this.marketList || this.newMarketList) {
      this.changeFlag = true;
      if (this.marketCode) {
        this.cardData.indice = {
          code: this.marketCode,
          name: this.marketText
          };
      }
      if (this.mutualFundList.length > 0) {
        this.cardData.indicesNew = {};
        this.cardData.indicesList = null;
        this.cardData.indice = {
          code: this.mutualFundList[0].code,
          name: this.mutualFundList[0].name,
          marketName: this.mutualFundList[0].marketName,
          type: this.mutualFundList[0].type
        };
      }
      if ( this.marketList.length > 0) {
        this.cardData.indicesNew = {};
        this.cardData.indicesList = null;
        this.cardData.indice = {
          code: this.marketList[0].code,
          name: this.marketList[0].name,
          marketName: this.marketList[0].marketName,
          type: this.marketList[0].type
        };
      }
      if (this.newMarketList.length > 0) {
        this.cardData.indice = {};
        this.cardData.indicesList = [];
        this.cardData.indicesNew = {};
        if(this.newMarketList.length==1){
        this.cardData.indicesNew = {
          code: this.newMarketList[0].code,
          name: this.newMarketList[0].name,
          marketName: this.newMarketList[0].marketName,
          type: this.newMarketList[0].type
        };
      }
      else{
        this.newMarketList.forEach(element => {
          var indice = {
          code: element.code,
          name: element.name,
          marketName: element.marketName,
          type: element.type
          };
          this.indicesNewMarketList.push(indice);
        });
        this.cardData.indicesList = this.indicesNewMarketList;
        this.cardData.indicesNew = this.indicesNewMarketList[0];
      }
      }
      this.deactivateMarketSuggestion = false;
      this.deactivateNewMarketSuggestion = false;
      this.overrideSave();
      setTimeout(e => {
        this.onelementBlur();
      }, 700);
      this.marketPopup = false;
    } else {
      this.snotify.error('Select a Option', '', this.sharedService.getConfig(false));
    }

  }

  newLiveBlogMarketEmbed() {
    if (this.marketCode || this.mutualFundList || this.marketList) {
      const marketCard = JSON.parse(JSON.stringify(StaticDataService.defaultMarketCardData));
      marketCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      if (this.marketCode) {
        marketCard.indice = {
          code: this.marketCode,
          name: this.marketText
        };
      }
      if (this.mutualFundList.length > 0) {
        marketCard.indice = {
          code: this.mutualFundList[0].code,
          name: this.mutualFundList[0].name,
          marketName: this.mutualFundList[0].marketName,
          type: this.mutualFundList[0].type
        };
      }
      if (this.newMarketList.length > 0) {
        marketCard.indicesNew = {
          code: this.newMarketList[0].code,
          name: this.newMarketList[0].name,
          marketName: this.newMarketList[0].marketName,
          type: this.newMarketList[0].type
        };
      }
      this.deactivateMarketSuggestion = false;
      this.deactivateNewMarketSuggestion = false;

      if (marketCard.indice.name || marketCard.indicesNew.name) {
        this.marketPopup = false;
        this.increasePendingCount();
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          marketCard, result => {
            this.decreasePendingCount();
            if(!this.multipleElementLiveblog) {
              this.cardData.liveBlog.inlineElementId = result.id;
            } else {
              this.cardData.liveBlog.inlineElementIdList? this.cardData.liveBlog.inlineElementIdList.push(result.id) : this.cardData.liveBlog.inlineElementIdList = [result.id];
            }
            this.changeFlag = true;
          });
        this.marketCode = '';
        this.marketText = '';
        this.newMarketPopup = false;
      } else {
        this.snotify.error('Please enter Company Name or Mutual Fund', '', this.sharedService.getConfig(false));
      }
    } else {
      this.snotify.error('Select a Option', '', this.sharedService.getConfig(false));
    }

  }

  openMarketPopup() {
    this.deactivateMarketSuggestion = false;
    this.deactivateNewMarketSuggestion = false;
    this.getMutualFundList();
    this.getMarketList();
    this.marketPopup = true;
    this.mutualFundList = [];
    this.marketList = [];
    this.newMarketList = [];
    this.marketCode = '';
    this.marketText = '';
    this.newMarketPopup = true;
  }

  createMatchCardLiveBlog(obj) {
    const cricketCard = JSON.parse(JSON.stringify(StaticDataService.defaultCricketCardData));
    cricketCard.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    cricketCard.match = obj;
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      cricketCard, result => {
        this.decreasePendingCount();
        if(!this.multipleElementLiveblog) {
          this.cardData.liveBlog.inlineElementId = result.id;
        } else {
          this.cardData.liveBlog.inlineElementIdList? this.cardData.liveBlog.inlineElementIdList.push(result.id) : this.cardData.liveBlog.inlineElementIdList = [result.id];
        }
        this.changeFlag = true;
        setTimeout(e => {
          this.matchPopupLiveBLog = false;
        }, 300);
      });
  }

  getMatchDetailsToParentfn (obj) {
    if (obj) {
      this.changeFlag = true;
      this.cardData.match.seriesId = obj.seriesId;
      this.cardData.match.seriesName = obj.seriesName;
      this.cardData.match.matchId = obj.matchId;
      this.cardData.match.matchNameWithDate = obj.matchNameWithDate;
      this.overrideSave();
      setTimeout(e => {
        this.onelementBlur();
      }, 700);
      this.matchPopup = false;
    } else {
      this.snotify.error('Select a Option', '', this.sharedService.getConfig(false));
    }
  }
  getPopupValueToParentfn(obj) {
    this.matchPopup = obj;
    this.matchPopupLiveBLog = obj;
  }


  saveEmbed() {
    var noAffiliateAds = true;
    if (((this.embedCode === null) || (this.embedCode === '')) && (this.amazonAds && this.amazonAds.length > 0)) {
      noAffiliateAds = false;
      this.showAmazonMeta = false;
      this.showSnapdealMeta = false;
      this.showCromaMeta = false;
      this.showFlipkartMeta = false;
      this.cardData.amazonMeta = true;
      console.log('saveEmbed',this.cardData.amazonAds)

      this.restService.http_post(this.config.get('product').baseUrl + '/cms/affiliate/checkItems/',
      this.amazonAds, result => {
      console.log('==============',result);
      if(result.length>0){
        this.amazonAds=result;
        this.cardData.amazonAds = result;
        console.log(' this.cardData.amazonAds', this.cardData.amazonAds)
        for(let i in result){
          if(result[i]['isPresent']==false){
          this.snotify.error('Product Id does not exist',result[i]['value'],this.sharedService.getConfig(false))
          }else{}
        }
      }
      this.changeEmbed();
      });
    }
    if(((this.embedCode === null) || (this.embedCode === '')) && (this.snapdealAds && this.snapdealAds.length > 0)){
      noAffiliateAds = false;
      this.cardData.snapdealMeta = true;
      this.cardData.snapdealAds = this.snapdealAds;
      this.changeEmbed()
    }
    if(((this.embedCode === null) || (this.embedCode === '')) && (this.cromaAds && this.cromaAds.length > 0)){
      noAffiliateAds = false;
      this.cardData.cromaMeta = true;
      this.cardData.cromaAds = this.cromaAds;
      this.changeEmbed();
    }
    if(((this.embedCode === null) || (this.embedCode === '')) && (this.flipkartAds && this.flipkartAds.length > 0)){
      noAffiliateAds = false;
      this.cardData.flipkartMeta = true;
      this.cardData.flipkartAds = this.flipkartAds;
      this.changeEmbed();
    }
    if(noAffiliateAds && (this.embedCode && this.embedCode !== null && this.embedCode.trim() !== '')) {
      if (this.sharedService.isdomainConfig('story','autoEmbed')) {
        this.sharedService.checkAndGetEmbed(this.embedCode, (embed) => {
          if (embed !== null) {
            this.embedCode = embed;
          }
          setTimeout(e => {
            this.changeEmbed();
          }, 20);
        });
      } else {
        this.changeEmbed();
      }
    }
   if(noAffiliateAds && (this.embedCode===null || this.embedCode.trim() === '')) {
      this.snotify.error('Enter a valid embed', '', this.sharedService.getConfig(false));
    }
  }


  changeEmbed() {
    if (this.cardType !== 'liveblog' && this.cardType !== 'photostory' &&  this.cardType !== 'newsroom' && this.cardType !== 'mintlite') {
      const duration = this.sharedService.checkForMetadataDuration(this.embedCode);
      if (duration !== false) {
        if (!this.cardData.metadata.hasOwnProperty('videoMetadata') || !this.cardData.metadata.videoMetadata) {
          this.cardData.metadata.videoMetadata = {};
        }
        this.cardData.metadata.videoMetadata.duration = duration;
      }
      this.cardData.embed.body = this.sharedService.checkEmbed(this.embedCode);
      if(this.embedSourceUrl) {
        this.cardData.jsonSourceUrl = this.embedSourceUrl.trim();
      }
      this.outputEmbedSourceUrl.emit(this.embedSourceUrl);
      if(this.embedSubType) {
        this.cardData.subType = this.embedSubType.trim();
      }
      this.trustedHTML = this.makeRenderable(this.sharedService.escToText(this.embedCode));
      this.sharedService.runEmbedProcessor(this.embedCode, this.embedElement);
      this.embedPopup = false;
      this.sharedService.overflowauto();
      this.changeFlag = true;
      this.overrideSave();
      setTimeout(e => {
        this.embedChangeOutput.emit(null);
        this.embedCode = '';
        this.embedSourceUrl = '';
        this.embedSubType = '';
        this.onelementBlur();
      }, 700);
    } else {
      const embedElement = JSON.parse(JSON.stringify(StaticDataService.defaultEmbedCardData));
      embedElement.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      // console.log(embedElement);
      embedElement.embed.body = this.sharedService.checkEmbed(this.embedCode);
      embedElement.jsonSourceUrl = this.embedSourceUrl.trim();
      this.embedPopup = false;
      embedElement.subType = this.embedSubType.trim();
      this.cardData.liveBlog.inlineElementId = null;
      this.increasePendingCount();
      this.uploadImageInProgress = true;
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        embedElement, result => {
          this.decreasePendingCount();
          this.embedCode = '';
          this.embedSourceUrl = '';
          this.embedSubType = '';
          this.uploadImageInProgress = false;
          this.getEmbedSourceUrl(result.jsonSourceUrl);
          this.sharedService.overflowauto();
          // this.outputEmbedSourceUrl.emit(this.embedSourceUrl);
          if(!this.multipleElementLiveblog) {
            this.cardData.liveBlog.inlineElementId = result.id;
          } else {
            this.cardData.liveBlog.inlineElementIdList? this.cardData.liveBlog.inlineElementIdList.push(result.id) : this.cardData.liveBlog.inlineElementIdList = [result.id];
          }

          this.changeFlag = true;
          this.overrideSave();
        });
    }
  }

  openMatchPopup() {
    this.matchPopupLiveBLog = true;
  }

  createNewTable() {
    this.tablePopup = true;
    this.createTable = true;
    this.tableHTML = '';
  }

  getMarketSuggestion() {
    if (this.marketList && this.marketList.length === 0) {
      return this.marketSuggestion;
    }
    this.deactivateMarketSuggestion = true;
    this.deactivateNewMarketSuggestion = true;
    return [];
  }
  getMFSuggestion() {
    if (this.mutualFundList && this.mutualFundList.length === 0) {
      return this.mutualFundSuggestion;
    }
    this.deactivateMarketSuggestion = true;
    this.deactivateNewMarketSuggestion = true;
    return [];
  }
  getNewMarketSuggestion() {
    if (this.newMarketList.length > 0) {
    this.deactivateMarketSuggestion = true;
  }
    return this.newMarketSuggestion;
  }


  addTable() {
    const tableElement = JSON.parse(JSON.stringify(StaticDataService.defaultTableCardData));
    tableElement.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    tableElement.paragraph.body = ('' + this.tableHTML).replace('<figure class="table">', '').replace('</figure>', '');
    this.increasePendingCount();
    this.closeTable();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      tableElement, result => {
        this.decreasePendingCount();
        if(!this.multipleElementLiveblog) {
          this.cardData.liveBlog.inlineElementId = result.id;
        } else {
          this.cardData.liveBlog.inlineElementIdList? this.cardData.liveBlog.inlineElementIdList.push(result.id) : this.cardData.liveBlog.inlineElementIdList = [result.id];
        }
        this.changeFlag = true;
      });
      this.createTable = false;
  }

  triggerReplace() {
    this.showOptions = false;
    this.replaceImageEmit.emit();
  }

  innerReplace() {
    this.replaceImagePopup = true;
  }
  triggerReplacePhotoStory() {
    this.replaceImagePopupPhotoStory = true;
  }

  ifCroppedDomain() {
    this.cropAllGallery = this.sharedService.isdomainConfig('image','cropAll');
    if(this.cropAllGallery === true && this.storytype === 'gallery') {
      if(this.cardData &&  this.cardData['image'] && this.cardData['image']['images'] && this.cardData['image']['images']['1600x900']) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  startCropping(type='') {
    // console.log('open crop', this.cropperToShow);
    if(this.cardData) {
      console.log(this.cardType);
      if(this.cardType === 'image')
      {
          this.leadMediaImageGif = false;
      } else
      {
        this.leadMediaImageGif = true;
      }
      const elementImageURL = this.sharedService.getImageOnPriority(this.cardData['image']['images'], 'original');
      if (elementImageURL.indexOf('popper.ai/') === -1) {
        // const imageUrl = elementImageURL;
        const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL;
        if(this.liveblogPostImage && this.sharedService.isdomainConfig('story','isLiveblogCrop')) {
          this.showLBcropper = true;
        } else {
          this.showCropper = true;
        }
        this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
          if (data !== false) {
            this.openCropper(false, data);
          } else {
            this.cancelCropping();
            this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
          }
        });
      } else {
        this.cancelCropping();
        this.snotify.error('This image cannot be cropped.', '', this.sharedService.getConfig(false));
      }
    } else {
      return false;
    }

  }

  openStepsCropper(isCropForLeadMedia, data, model) {
    this.cropperImageUrl.data = data.data;
    this.cropperImageUrl.url = data.url;
    if(model === 'howToSteps') {
      this.showHowToStepsCropper = true;
    } else if(model === 'recipe') {
      this.showRecipeStepsCropper = true;
    }

  }

  openVideoThumbnailReplaceFromLibraryCropper(isCropForLeadMedia, data) {
    this.cropperImageUrl.data = data.data;
    this.cropperImageUrl.url = data.url;
    this.addVideoThumbnail = true;
  }
  openCropper(isCropForLeadMedia, data) {
    const imageUrl2 = this.isSecondImagePresent();
    if (imageUrl2) {
      this.sharedService.createObjectFromImageUrl(imageUrl2, (data2, reader2) => {
        if (data2 !== false) {
          this.setCroppingData(isCropForLeadMedia, {
            data: data.data,
            url: data.url,
            data2: data2.data,
            url2: data2.url
          });
        } else {
          this.cancelCropping();
          this.snotify.error('Image path does not exist for second image.', '', this.sharedService.getConfig(false));
        }
      });
    } else {
      this.setCroppingData(isCropForLeadMedia, data);
    }
  }

  setCroppingData(isCropForLeadMedia, data) {
    this.cropForLeadMedia = isCropForLeadMedia;
    this.sharedService.overflowhidden();
    this.cropperImageUrl = data;
  }

  createDuplicateImageChild(id, callback) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
      + '/' + id
    )
      .subscribe(result => {
        // let defaultImagecardData = $.extend(true, {}, result);
        const defaultImagecardData = Object.assign({}, result);
        defaultImagecardData['id'] = null;
        defaultImagecardData['parentElementId'] = id;
        defaultImagecardData['relatedStories'] = null;
        defaultImagecardData['relatedVideoStories'] = null;
        if(defaultImagecardData['removeLowQualityRestriction']){
          delete defaultImagecardData['removeLowQualityRestriction']
        }
        this.increasePendingCount();
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          defaultImagecardData, result2 => {
            this.decreasePendingCount();
            if (!result2.hasOwnProperty('error')) {
              callback(result2);
              this.disableshowGallery();
            } else {
              this.snotify.error(result2.error.errorMessage ?result2.error.errorMessage : 'Could not upload image' , '', this.sharedService.getConfig(false));
              if(this.storytype=='liveblog'){
                this.showGallery();
              }
              callback(false);
            }
          });
      },
        err => {
          // console.log(err);
          callback(false);
        });
  }

  updateCardOnSocket(data) {
    // console.log(data);
    if (data['type']) {
      this.cardData = data;
      this.changeFlag = false;
    }
  }

  addEmbedAsLead(ev) {
    // console.log(ev);
    this.listClick(ev, 2);
    this.embedCode = '';
    this.embedSourceUrl = '';
    this.embedSubType = '';
    this.embedPopup = true;
    this.sharedService.overflowhidden();
  }

  @HostListener('cut', ['$event'])
  public cutfunc(e) {
    setTimeout(e4 => {
      this.doCheck();
    }, 20);
  }

  nextPdfPage() {
    this.page = this.page + 1;
  }

  previousPdfPage() {
    this.page = this.page - 1;
  }

  pageRendered($event) {
    this.totalNumberOfPages = $event.source.renderingQueue.pdfViewer._pages.length;
  }

  pdfDocumentLoaded(event) {
    if (document.getElementsByTagName('ng2-pdfjs-viewer')) {
      for (let j = 0; j < document.getElementsByTagName('ng2-pdfjs-viewer').length; j++) {
        if (document.getElementsByTagName('ng2-pdfjs-viewer')[j].getElementsByTagName('iframe')[0] &&
          document.getElementsByTagName('ng2-pdfjs-viewer')[j].getElementsByTagName('iframe')[0].contentDocument &&
          document.getElementsByTagName('ng2-pdfjs-viewer')[j]
            .getElementsByTagName('iframe')[0].contentDocument.getElementsByClassName('page')[0]) {
          const height = document.getElementsByTagName('ng2-pdfjs-viewer')[j]
            .getElementsByTagName('iframe')[0].contentDocument.getElementsByClassName('page')[0].clientHeight;
          for (let i = 0; i < document.getElementsByClassName('container')[0].children.length; i++) {
            if (document.getElementsByClassName('container')[0] && document.getElementsByClassName('container')[0].children[i]
              && document.getElementsByClassName('container')[0].children[i].getElementsByClassName('dataField')[0]
              && document.getElementsByClassName('container')[0].children[i].getElementsByClassName('dataField')[0].id === 'pdfHight') {
              document.getElementsByClassName('container')[0].children[i]
                .getElementsByClassName('dataField')[0].setAttribute('style', 'height:' + height + 'px;');
            }
          }
          break;
        }

      }
    }
      const heightPdf = document.getElementsByTagName('ng2-pdfjs-viewer')[0]
        .getElementsByTagName('iframe')[0].contentDocument.getElementsByClassName('page')[0].clientHeight;
      document.getElementsByTagName('ng2-pdfjs-viewer')[0].getElementsByTagName('iframe')[0]
        .setAttribute('style', 'height:' + heightPdf + 'px;');
  }


  renderpdf(url: string) {
    if (url) {
      this.openPdf = true;
      this.pdfSrc = url;
      this.pdfDocumentLoaded(null);
    }
  }

  editTable() {
    this.tableHTML = '<figure class="table">' + this.cardData.paragraph.body + '</figure>';
    setTimeout(() => {
      this.tablePopup = true;
    }, 100);
  }
  getEditorConfig() {
    if (this.isCKEditorEnabled) {
      if(window.innerWidth > 640)
      {
      return this.isAlignmentEnabled() ? this.ckconfigwithalignment : this.ckconfig;
      } else {
        return this.isAlignmentEnabled() ? this.ckconfigwithalignmentMobile : this.ckconfig;
      }
    } else {
      return this.isAlignmentEnabled() ? this.toolbarConfig : this.toolbarConfigWithoutAlignment;
    }
  }

  closeTable() {
    this.tablePopup = false;
    this.tableHTML = '';
  }

  changeTable() {
    this.cardData.paragraph.body = this.tableHTML.toString().replace('<figure class="table">', '').replace('</figure>', '');
    this.changeFlag = true;
    this.overrideSave();
    this.closeTable();
  }

  getEmbedPopupTitle() {
    if (this.sharedService.isdomainConfig('story','autoEmbed')) {
      return 'Add Embed code for the video, tweet, etc';
    } else {
      return 'Add Embed code/URL (youtube, dailymotion, & vimeo only) for the video, tweet, etc';
    }
  }

  updateRelatedStories(stories) {
    if (this.cardData && this.cardData.type === 'relatedstory') {
      this.cardData.relatedStories = stories;
      this.changeFlag = true;
      this.overrideSave();
    }
    if (this.cardData && this.cardData.type === 'relatedstoryhowto') {
      this.cardData.relatedStories = stories;
      this.changeFlag = true;
      this.overrideSave();
    }
  }
  isAlignmentEnabled() {
    return (this.domainConfig && this.domainConfig.paragraphToolsDisabled
      && this.domainConfig.paragraphToolsDisabled.indexOf('alignment') === -1);
  }
  clearParagraph() {
    this.cardData.paragraph.body = '';
    this.changeFlag = true;
    this.deleteTempParafn.emit(true);
  }
  editQuote() {
    this.quoteText = this.cardData.paragraph.body;
    this.showQuotes = this.cardData.showQuotes;
    this.quotePopup = true;
    this.sharedService.overflowhidden();
  }
  onQuoteItemChange(event){
    this.showQuotes = event;
  }
  closeQuote() {
    this.quotePopup = false;
    this.quoteText = '';
    this.sharedService.overflowauto();
  }
  saveQuote() {
    this.cardData.paragraph.body = this.quoteText;
    this.cardData.showQuotes = this.showQuotes;
    this.quoteHTML = this.text2HTMLQuote(this.quoteText).replace(/<\p><\/p>/gm, '').replace(/<br ?\/?>/g, '');
    this.changeFlag = true;
    this.overrideSave();
    this.closeQuote();
  }

  text2HTMLQuote(inputText) {
    const text = inputText;
    const lines = text.split('\n');
    let t = '';
    lines.forEach(element => {
      if (element === '') {
        t += '<p>&nbsp;</p>';
      } else if (element.startsWith(' ')) {
        const e = /[a-z]/i.exec(element).index;
        t += '<p>' + element.slice(0, e).replace(/ /g, '&nbsp;') + element.slice(e, element.length) + '</p>';
      } else {
        t += '<p>' + element + '</p>';
      }
    });
    return t;
  }

  editReview() {
    this.tempReviewData = this.cardData.review;
    this.lockAcquire(this.cardData.id, (flag) => {
      if (flag) {
        this.isReviewEditable = true;
      } else {
        this.cancelReviewEditing();
      }
    });
  }

  editMovieReview() {
    this.tempMovieReviewData = this.cardData.movieReview;
    this.lockAcquire(this.cardData.id, (flag) => {
      if (flag) {
        this.isReviewEditable = true;
      } else {
        this.cancelReviewEditing();
      }
    });
  }
  cancelReviewEditing() {
    this.isReviewEditable = false;
    this.tempReviewData = null;
  }

  cancelMovieReviewEditing(){
      this.isReviewEditable = false;
      this.tempMovieReviewData = null;
  }

  finishReviewEditing() {
    this.cardData.review = this.tempReviewData;
    this.cardData.title = this.tempReviewData.productName;
    this.doCheck();
    setTimeout(e => {
      this.overrideSave();
      this.cancelReviewEditing();
    }, 1);
  }

  finishMovieReviewEditing(){
    this.cardData.movieReview = this.tempMovieReviewData;
    this.cardData.title = this.tempMovieReviewData.name;
    this.doCheck();
    setTimeout(e => {
      this.overrideSave();
      this.cancelMovieReviewEditing();
    }, 1);
  }

  addProductReviewDetails (reviewType: string) {
    if (reviewType === 'pros' && this.reviewPros) {
      this.tempReviewData.pros.push(this.reviewPros);
      this.reviewPros = null;
    } else if (reviewType === 'cons' && this.reviewCons) {
      this.tempReviewData.cons.push(this.reviewCons);
      this.reviewCons = null;
    } else if (reviewType === 'spec' && this.specHeading && this.specDescription) {
      const obj = {'key': this.specHeading, 'value': this.specDescription};
      this.tempReviewData.specification.push(obj);
      this.specHeading = null;
      this.specDescription = null;
    } else {
      this.snotify.error('Please enter review data', '', this.sharedService.getConfig(false));
    }
  }
  applyStyles(obj,type?: string) {
    if (type ==='rating' && this.cardData.review) {
      if (this.cardData.review.rating <= 5 && this.cardData.review.rating >= 1) {
        const val = (obj  * 31) - 5;
        const str = val + 'px';
        return str;
      } else {
        this.cardData.review.rating = '';
        return '0px';
      }
    }
    if(type==="movieReview" && this.cardData.movieReview){
      if (this.cardData.movieReview.rating <= 5 && this.cardData.movieReview.rating >= 1) {
        const val = (obj  * 31) - 5;
        const str = val + 'px';
        return str;
      } else {
        this.cardData.movieReview.rating = '';
        return '0px';
      }
    }
    if(type==="carPerformance" && this.cardData.review){
      if (this.cardData.review.carPerformance <= 5 && this.cardData.review.carPerformance >= 1) {
        const val = (obj  * 31) - 5;
        const str = val + 'px';
        return str;
      } else {
        this.cardData.review.carPerformance = '';
        return '0px';
      }
    }
    if(type==="bikeStyling" && this.cardData.review){
      if (this.cardData.review.bikeStyling <= 5 && this.cardData.review.bikeStyling >= 1) {
        const val = (obj  * 31) - 5;
        const str = val + 'px';
        return str;
      } else {
        this.cardData.review.bikeStyling = '';
        return '0px';
      }
    }
    if(type==="carSafety" && this.cardData.review){
      if (this.cardData.review.carSafety <= 5 && this.cardData.review.carSafety >= 1) {
        const val = (obj  * 31) - 5;
        const str = val + 'px';
        return str;
      } else {
        this.cardData.review.carSafety = '';
        return '0px';
      }
    }
    if(type==="bikeRide" && this.cardData.review){
      if (this.cardData.review.bikeRide <= 5 && this.cardData.review.bikeRide >= 1) {
        const val = (obj  * 31) - 5;
        const str = val + 'px';
        return str;
      } else {
        this.cardData.review.bikeRide = '';
        return '0px';
      }
    }
    if(type==="carDesign" && this.cardData.review){
      if (this.cardData.review.carDesign <= 5 && this.cardData.review.carDesign >= 1) {
        const val = (obj  * 31) - 5;
        const str = val + 'px';
        return str;
      } else {
        this.cardData.review.carDesign = '';
        return '0px';
      }
    }
    if(type==="bikeCost" && this.cardData.review){
      if (this.cardData.review.bikeCost <= 5 && this.cardData.review.bikeCost >= 1) {
        const val = (obj  * 31) - 5;
        const str = val + 'px';
        return str;
      } else {
        this.cardData.review.bikeCost = '';
        return '0px';
      }
    }
    if(type==="carFeature" && this.cardData.review){
      if (this.cardData.review.carFeature <= 5 && this.cardData.review.carFeature >= 1) {
        const val = (obj  * 31) - 5;
        const str = val + 'px';
        return str;
      } else {
        this.cardData.review.carFeature = '';
        return '0px';
      }
    }
    if(type==="carComfort" && this.cardData.review){
      if (this.cardData.review.carComfort <= 5 && this.cardData.review.carComfort >= 1) {
        const val = (obj  * 31) - 5;
        const str = val + 'px';
        return str;
      } else {
        this.cardData.review.carComfort = '';
        return '0px';
      }
    }
    if(type==="bikeMileage" && this.cardData.review){
      if (this.cardData.review.bikeMileage <= 5 && this.cardData.review.bikeMileage >= 1) {
        const val = (obj  * 31) - 5;
        const str = val + 'px';
        return str;
      } else {
        this.cardData.review.bikeMileage = '';
        return '0px';
      }
    }
  }

  deleteProsCons(item,type) {
    if (type === 'pros') {
      this.tempReviewData.pros.splice(item, 1);
    } else if (type === 'cons') {
      this.tempReviewData.cons.splice(item, 1);
    } else if (type === 'spec') {
      this.tempReviewData.specification.splice(item, 1);
    }
  }
  trackByFn(index: any, item: any) {
    return index;
  }
  isSecondImagePresent() {
    const elementImageURL2 = this.isMultipleLeadImageAllowed && this.cardData['image']['images'].hasOwnProperty('original2')
    ? this.cardData['image']['images']['original2'] : false;
    const imageUrl2 = elementImageURL2 ?
    (this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL2) : false;
    return imageUrl2;
  }

  showVideoGallery(destination?,index?) {
    index||index===0 ? this.videoIndex = index : this.videoIndex = '';
    this.isLightboxVideo = true;
    this.enableFAQImageOption = false;
    this.enableQuesFAQImageOption = false;
    this.sharedService.overflowhidden();
    this.elementDestination = destination
  }
  disableshowVideoGallery() {
    this.elementDestination = null;
    this.isLightboxVideo = false;
    this.videoOptions = false;
    if(this.enableJW === 'true')
    {
      this.showJW = true;
      this.showYT = false;
    }
    else if(this.enableYT)
    {
      this.showJW = false;
      this.showYT = true;
    }
    this.sharedService.overflowauto();
  }
  disableshowPageListing() {
    this.isPageListing =false;
    this.sharedService.overflowauto();
  }
  disableshowStoryListing() {
    this.isStoryListing =false;
    this.sharedService.overflowauto();
  }
  getVideo(obj) {
    this.videoUrl = obj.standardEmbedCode != null || obj.standardEmbedCode !== undefined ? obj.standardEmbedCode : null;
    if(this.elementDestination === 'listicleMedia'){
      this.disableshowVideoGallery();
        const videoCardData = JSON.parse(JSON.stringify(StaticDataService.defaultVideoCardData));
        videoCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        videoCardData.id = null;
        videoCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
        videoCardData.video.body = obj.standardEmbedCode;
        videoCardData.video.description = obj.description;
        videoCardData.video.uploadDate = obj.created_at;
        videoCardData.video.embedUrl = obj.videoPath;
        videoCardData.metadata.videoMetadata = {};
        videoCardData.metadata.videoMetadata.duration = obj.duration;
        this.increasePendingCount();
          this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          videoCardData, result => {
            this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaId').setValue(result.id)
          })
        this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('media').setValue({'video':videoCardData.video})
        this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaType').setValue('video')
    } else if(this.elementDestination === 'FAQMedia'){
      this.FAQvideo = obj;
     this.disableshowVideoGallery();
       const videoCardData = JSON.parse(JSON.stringify(StaticDataService.defaultVideoCardData));
       videoCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
       videoCardData.id = null;
       videoCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
       videoCardData.video.body =this.FAQvideo.standardEmbedCode;
       videoCardData.video.description =this.FAQvideo.description;
       videoCardData.video.uploadDate =this.FAQvideo.created_at;
       videoCardData.video.embedUrl = this.FAQvideo.videoPath;
       videoCardData.metadata.videoMetadata = {};
       videoCardData.metadata.videoMetadata.duration = this.FAQvideo.duration;
         this.restService.http_post(this.config.get('product').baseUrl
         + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
         videoCardData, result => {
           this.decreasePendingCount();
           this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaIdValue').setValue(result.id)
         })
       this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaValue').setValue({'video':videoCardData.video})
       this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaTypeValue').setValue('video')
 }
 else if(this.elementDestination === 'quesFAQMedia'){
   this.FAQvideo = obj;
  this.disableshowVideoGallery();
    const videoCardData = JSON.parse(JSON.stringify(StaticDataService.defaultVideoCardData));
    videoCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    videoCardData.id = null;
    videoCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
    videoCardData.video.body =this.FAQvideo.standardEmbedCode;
    videoCardData.video.description =this.FAQvideo.description;
    videoCardData.video.uploadDate =this.FAQvideo.created_at;
    videoCardData.video.embedUrl = this.FAQvideo.videoPath;
    videoCardData.metadata.videoMetadata = {};
    videoCardData.metadata.videoMetadata.duration = this.FAQvideo.duration;
      this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      videoCardData, result => {
        this.decreasePendingCount();
        this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaIdKey').setValue(result.id)
      })
    this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaKey').setValue({'video':videoCardData.video})
    this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaTypeKey').setValue('video')
}
else if(this.elementDestination === 'pollMedia'){
  this.FAQvideo = obj;
 this.disableshowVideoGallery();
   const videoCardData = JSON.parse(JSON.stringify(StaticDataService.defaultVideoCardData));
   videoCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
   videoCardData.id = null;
   videoCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
   videoCardData.video.body =this.FAQvideo.standardEmbedCode;
   videoCardData.video.description =this.FAQvideo.description;
   videoCardData.video.uploadDate =this.FAQvideo.created_at;
   videoCardData.video.embedUrl = this.FAQvideo.videoPath;
   videoCardData.metadata.videoMetadata = {};
   videoCardData.metadata.videoMetadata.duration = this.FAQvideo.duration;
     this.restService.http_post(this.config.get('product').baseUrl
     + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
     videoCardData, result => {
       this.decreasePendingCount();
       if(typeof(this.videoIndex) == 'string')
       {
        this.tempnewFAQData.get('mediaIdKey').setValue(result.id);
        this.tempnewFAQData.get('mediaKey').setValue({'video':videoCardData.video});
        this.tempnewFAQData.get('mediaTypeKey').setValue('video');
       }else{
        this.tempnewFAQData.get('ansArray')['controls'][this.videoIndex].get('mediaIdValue').setValue(result.id)
        this.tempnewFAQData.get('ansArray')['controls'][this.videoIndex].get('mediaValue').setValue({'video':videoCardData.video})
        this.tempnewFAQData.get('ansArray')['controls'][this.videoIndex].get('mediaTypeValue').setValue('video')
       }
     })
    }
    else {
      this.finishChangeVideo();
    }
  }
  getpageUrlToParentfn(obj) {
    if(obj.includes('http')) {
      this.topicUrl = obj;
    } else {
      if(this.sharedService.currentDomainUrl && this.sharedService.currentDomainUrl.length>8){
        this.topicUrl = this.sharedService.currentDomainUrl + obj;
      } else {
        let urlObj = environment.domainBaseUrls.filter(e => e.id === sessionStorage.getItem(StaticDataService.domainLiteral));
        this.topicUrl = urlObj[0].baseUrl + obj;
      }
    }
    if (this.topicUrl.startsWith('https')) {
        this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/validate/link/?url='+this.topicUrl)
        .subscribe((response) => {
        if(response.statusCode === 200){
        if (this.isCKEditorEnabled) {
          const textSplit = this.selectedText.split('|#+|');
          if (textSplit.length > 2) {
            let classData = 'manualbacklink'
            this.getAutoBacklingList( textSplit[1],true);
            textSplit[1] = '<a href="' + this.topicUrl + '" class="'+ classData + '">' + textSplit[1] +'</a>';
            const totalPara = textSplit.join('');
            this.chosenEditor ? this.chosenEditor.setData(totalPara) : this.paraEditor.setData(totalPara);
            this.manualLinkCountIncr.emit();
          }
        } else if (!this.isCKEditorEnabled) {
          const del = new QuillDelta();
          this.paraEditor.focus();
          this.paraEditor.updateContents((del).retain(this.lenQuill.index).delete(this.lenQuill.length));
          this.paraEditor.clipboard.dangerouslyPasteHTML(this.lenQuill.index, '<a href="' + this.topicUrl + '">' + this.topicName +'</a>');
          this.paraEditor.setSelection(this.lenQuill.index, this.lenQuill.length);
        }
        this.isPageListing = false;
        this.isStoryListing = false;
      } else {
        this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
      }
  },error=>{
    this.snotify.error('Link is invalid', '', this.sharedService.getConfig(false));
  })
  }
  else {
    this.snotify.error('Link is invalid,link should be start with https.Please select a valid link.', '', this.sharedService.getConfig(false));
  }
}

  showTopicListing() {
    return (this.domainConfig && this.domainConfig['config']
      && this.domainConfig['config']['story'] && this.domainConfig['config']['story']['showTopicListing'] === 'true');
  }

  getremoveInvalidLink(cardData,word,type,editor,id?){
    let paraBody=cardData;
    console.log("cardData",cardData)
      if(!!word && !!cardData){
        let replaceThis = '<a[^>]*>'+word+'<\/a>'
        let regexReplace = new RegExp(`${replaceThis}`)
        let l = regexReplace.exec(paraBody);
        if(!!l && l.length>0){
          paraBody = paraBody.replace(regexReplace, word);
          cardData= paraBody;
          editor ? editor.setData(cardData):'';
          this.saveCard(true, word => {});
           this.manualLinkCountDecr.emit();
           if(type === 'parabody'){
            this.snotify.info(word, 'Removed!', this.sharedService.getConfig(false));
            delete this.autoBacklinkResponse.recommendedLinkedContent[word];
            console.log("this.autoBacklinkResponse",this.autoBacklinkResponse)
            this.updateAutoBacklinkData(id,word,false);
           }
        }
      }
  }

  checkUrlValidate(url,data,type,editor,id?) {
   var urlValid = /[a-z0-9-]*\.?[a-z0-9-]+\.[a-z0-9-]+\.?[a-z0-9-]+(\/[^<>]*)?$/;
   let allLink =  this.sharedService.findInvalidLinkWord(editor);
   let matchLinkObj = allLink.filter(e =>e.href===url)
   if(urlValid.test(url) === false) {
      this.snotify.info('Please enter valid URL', '', this.sharedService.getConfig(false));
      setTimeout(e4 => {
        if(editor) {
          this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor,id)
        }
      }, 1000);
    } else if(!url.startsWith('https')) {
      this.snotify.error('Link is invalid,link should be start with https.Please enter valid link.', '', this.sharedService.getConfig(false));
      setTimeout(e4 => {
        if(editor) {
          this.getremoveInvalidLink(data,matchLinkObj[0].linkText,type,editor,id)
        }
      }, 1000);
    }
    else{
      this.manualLinkCountIncr.emit();
    }
    return urlValid.test(url) && url.startsWith('https') ;
  }

  previewPdf(res) {
    if (res) {
      const DocumentData = JSON.parse(JSON.stringify(StaticDataService.defaultDocumentData));
      DocumentData.id = null;
      DocumentData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      DocumentData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
      DocumentData.image.images['original'] = res['images']['original'].replace(/"/gi, '');
      this.increasePendingCount();
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
        DocumentData, result => {
          this.decreasePendingCount();
          if(!this.multipleElementLiveblog) {
            this.cardData.liveBlog.inlineElementId = result.id;
          } else {
            this.cardData.liveBlog.inlineElementIdList? this.cardData.liveBlog.inlineElementIdList.push(result.id) : this.cardData.liveBlog.inlineElementIdList = [result.id];
          }
          this.changeFlag = true;
          if (result) {
            const arr = [];
            arr.push(result);
          }
        });
    }
  }

  createFaqItem(): FormGroup {
    return this.formBuilder.group({
      key: new FormControl('', [Validators.required]),
      value: new FormControl('', [Validators.required])
    });
  }

  openFaqPopup() {
    this.resetFaqSection();
    this.tempFaqData.patchValue({
      heading: this.cardData.faqSectionHeading
    });

    (<FormArray>this.tempFaqData.controls['faqs']).removeAt(0);

    this.cardData.faqs.forEach((faq) => {
      const group = this.formBuilder.group({
        key: new FormControl(faq.key, [Validators.required]),
        value: new FormControl(faq.value, [Validators.required])
      });
      (<FormArray>this.tempFaqData.get('faqs')).push(group);
    });

    this.showFaqPopup = true;
  }



  closeFaqPopup() {
    this.resetFaqSection();
    this.showFaqPopup = false;
  }

  resetFaqSection() {
    this.tempFaqData = this.formBuilder.group({
      heading: new FormControl('', [Validators.required]),
      faqs: this.formBuilder.array([ this.createFaqItem() ])
    });
  }

  addFaq() {
    this.faqs = this.tempFaqData.get('faqs') as FormArray;
    this.faqs.push(this.createFaqItem());
  }

  deleteFaq(idx){
    this.faqs = this.tempFaqData.get('faqs') as FormArray;
    this.faqs.removeAt(idx);
  }

  updateFaqs() {
    if(this.tempFaqData.valid){
      let faqData = this.tempFaqData.getRawValue();
      this.cardData.faqs = faqData.faqs;
      this.cardData.faqSectionHeading = faqData.heading;

      this.showFaqPopup = false;
      this.sharedService.overflowauto();
      this.changeFlag = true;
      this.overrideSave();
    } else {
      this.tempFaqData.get('heading').markAsTouched();
      (this.tempFaqData.get('faqs') as FormArray).controls.forEach(e => {
        Object.keys((e as FormGroup).controls).forEach(e1 => {
          (e as FormGroup).controls[e1].markAsTouched();
        });
      });
      this.snotify.error('Enter required fields', '', this.sharedService.getConfig(false));
    }
  }

  createStep(): FormGroup {
    return this.formBuilder.group({
      step: new FormControl('', [Validators.required]),
      stepImage: new FormControl(null)
    });
  }

  openAffiliatePopup() {
    this.resetOtherAffiliate();
    this.tempOtherAffiliateData.patchValue({
      productName: this.cardData.affiliate.name,
      osp: this.cardData.affiliate.osp,
      logo: this.cardData.affiliate.logo,
      curr_sell_price: this.cardData.affiliate.curr_sell_price,
      discount_perc: this.cardData.affiliate.discount_perc,
      url: this.cardData.affiliate.url,
      // images: this.cardData.affiliate.images,
    });
    this.tempOtherAffiliateProductImage = this.cardData.affiliate.images;
    // this.showRecipePopup = true;
  }

  resetOtherAffiliate() {
    this.tempOtherAffiliateData = this.formBuilder.group({
      productName: new FormControl('', [Validators.required]),
      osp: new FormControl('', []),
      logo: new FormControl(''),
      curr_sell_price: new FormControl('', []),
      discount_perc: new FormControl('', []),
      url: new FormControl('', []),
    })
    this.tempOtherAffiliateProductImage = null;
  }

  addLogoGallery() {
    this.logoGalleryFlag = true;
  }

  addProductImageGallery() {
    this.addProductImageGalleryFlag = true;
  }

  addAffiliateLogo(ev) {
    this.disableStepsInlineImage()
    if (ev.type === 'wire') {
      console.log(ev);
      this.saveCard(ev, 'logo');
    } else {

      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
        + '/' + ev.id
      )
        .subscribe(result => {
          console.log('LOGO IMAGE');
          console.log(result.image.images.original);
          this.tempOtherAffiliateData.get('logo').setValue(result.image.images.original);

        },
          err => {
            this.snotify.error('Image could not be added', '', this.sharedService.getConfig(false));
          });
    }
  }
  addProductImage(ev) {
    this.disableStepsInlineImage()
    if (ev.type === 'wire') {
      console.log(ev);
      // this.saveCard(ev, 'logo');
    } else {

      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
        + '/' + ev.id
      )
        .subscribe(result => {
          console.log('PRODUCT IMAGE');
          const elementImageURL = this.sharedService.getImageOnPriority(result['image']['images'], 'original');
          const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + elementImageURL;
          this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
            if (data !== false) {
              console.log("image data : 1 :: ", data);
              this.cropperImageUrl.data = data.data;
              this.cropperImageUrl.url = data.url;
              this.showProductImageCropper = true;
              // this.openCropper(false, data, 'product');
            } else {
              this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
            }
          });
          // this.openCropper(false, result, 'product');
        },
          err => {
            this.snotify.error('Image could not be added', '', this.sharedService.getConfig(false));
          });
    }
  }

  openRecipePopup() {
    this.recipeEditorArray = [];
    this.resetRecipe();
    this.tempRecipeData.patchValue({
      recipeName: this.cardData.recipe.recipeName,
      description: this.cardData.recipe.description,
      recipeYield: this.cardData.recipe.recipeYield,
      recipeCuisine: this.cardData.recipe.recipeCuisine,
      recipeCategory: this.cardData.recipe.recipeCategory,
      preparationTimeHr: this.cardData.recipe.preparationTimeHr,
      preparationTimeMinute: this.cardData.recipe.preparationTimeMinute,
      cookingTimeHr: this.cardData.recipe.cookingTimeHr,
      cookingTimeMinute: this.cardData.recipe.cookingTimeMinute,
      totalTimeHr: this.cardData.recipe.totalTimeHr,
      totalTimeMinute: this.cardData.recipe.totalTimeMinute,
      keywords: this.cardData.recipe.keywords,
      ingredients: this.cardData.recipe.ingredients,
      // st
    });
    (<FormArray>this.tempRecipeData.controls['steps']).removeAt(0);

    this.cardData.recipe.steps.forEach((step) => {
      const group = this.formBuilder.group({
        step: new FormControl(step.step, [Validators.required]),
        stepImage: new FormControl(step.stepImage)
      });
      (<FormArray>this.tempRecipeData.get('steps')).push(group);
    });
    this.showRecipePopup = true;
  }

  openStepPopup() {
    this.stepEditorArray = [];
    this.resetHowToStepsSection();

    this.tempHowToStepsData.patchValue({
      heading: this.cardData.heading,
      timeToComplete: this.cardData.timeToComplete,
      timeToCompleteinHrs: this.cardData.timeToCompleteinHrs,
      supplies: this.cardData.supplies,
      tools: this.cardData.tools
    });

    (<FormArray>this.tempHowToStepsData.controls['steps']).removeAt(0);

    this.cardData.steps.forEach((step) => {
      const group = this.formBuilder.group({
        step: new FormControl(step.step, [Validators.required]),
        stepImage: new FormControl(step.stepImage)
      });
      (<FormArray>this.tempHowToStepsData.get('steps')).push(group);
    });

    this.showStepPopup = true;
  }

  closeStepPopup() {
    this.resetHowToStepsSection();
    this.showStepPopup = false;
  }

  resetHowToStepsSection() {
    this.tempHowToStepsData = this.formBuilder.group({
      heading: new FormControl('', [Validators.required]),
      timeToComplete: new FormControl('', []),
      timeToCompleteinHrs: new FormControl('', []),
      supplies: new FormControl([]),
      tools: new FormControl([]),
      steps: this.formBuilder.array([ this.createStep() ])
    });
  }

  addStep() {
    this.steps = this.tempHowToStepsData.get('steps') as FormArray;
    this.steps.push(this.createStep());
  }

  deleteStep(idx){
    this.steps = this.tempHowToStepsData.get('steps') as FormArray;
    this.steps.removeAt(idx);
  }
  closeRecipePopup() {
    this.resetRecipe();
    this.showRecipePopup = false;
  }
  resetRecipe() {
    this.tempRecipeData = this.formBuilder.group({
      recipeName: new FormControl('', [Validators.required]),
      description: new FormControl(''),
      recipeYield: new FormControl(''),
      recipeCuisine: new FormControl(''),
      recipeCategory: new FormControl(''),
      preparationTimeHr: new FormControl('', []),
      preparationTimeMinute: new FormControl('', []),
      cookingTimeHr: new FormControl('', []),
      cookingTimeMinute: new FormControl('', []),
      totalTimeHr: new FormControl('', []),
      totalTimeMinute: new FormControl('', []),
      keywords: new FormControl([]),
      ingredients: new FormControl([]),
      steps: this.formBuilder.array([ this.createStep() ])
    });
  }
  updateRecipe() {
    if(this.tempRecipeData.valid){
      let recipeData = this.tempRecipeData.getRawValue();
      const card = JSON.parse(JSON.stringify(StaticDataService.defaultRecipeCardData));
      card.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
      console.log(recipeData)
      if(!recipeData.preparationTimeHr) recipeData.preparationTimeHr=0;
      if(!recipeData.preparationTimeMinute) recipeData.timeToCompleteinHrs=0;
      if(!recipeData.cookingTimeHr) recipeData.timeToComplete=0;
      if(!recipeData.cookingTimeMinute) recipeData.timeToCompleteinHrs=0;
      if(!recipeData.totalTimeHr) recipeData.timeToComplete=0;
      if(!recipeData.totalTimeMinute) recipeData.timeToCompleteinHrs=0;

      this.cardData['recipe']['recipeName'] = recipeData.recipeName;
      this.cardData['recipe']['description'] = recipeData.description;
      this.cardData['recipe']['recipeYield'] = recipeData.recipeYield;
      this.cardData['recipe']['recipeCuisine'] = recipeData.recipeCuisine;
      this.cardData['recipe']['recipeCategory'] = recipeData.recipeCategory;
      this.cardData['recipe']['keywords'] = recipeData.keywords;
      this.cardData['recipe']['ingredients'] = recipeData.ingredients;
      this.cardData['recipe']['steps'] = recipeData.steps;
      this.cardData['recipe']['preparationTimeHr'] = (recipeData.preparationTimeHr === null || recipeData.preparationTimeHr === ''
                            || recipeData.preparationTimeHr <= 999) ? recipeData.preparationTimeHr : 999;
      this.cardData['recipe']['preparationTimeMinute'] = (recipeData.preparationTimeMinute === null  || recipeData.preparationTimeMinute === ''
                            || recipeData.preparationTimeMinute <= 59) ? recipeData.preparationTimeMinute : 59;
      this.cardData['recipe']['cookingTimeHr'] = (recipeData.cookingTimeHr === null
                            || recipeData.cookingTimeHr === '' || recipeData.cookingTimeHr <= 999) ? recipeData.cookingTimeHr : 999;
      this.cardData['recipe']['cookingTimeMinute'] = (recipeData.cookingTimeMinute === null || recipeData.cookingTimeMinute === ''
                            || recipeData.cookingTimeMinute <= 59) ? recipeData.cookingTimeMinute : 59;
      this.cardData['recipe']['totalTimeHr'] = (recipeData.totalTimeHr === null || recipeData.totalTimeHr === ''
                            || recipeData.totalTimeHr <= 999) ? recipeData.totalTimeHr : 999;
      this.cardData['recipe']['totalTimeMinute'] = (recipeData.totalTimeMinute === null || recipeData.totalTimeMinute === ''
                            || recipeData.totalTimeMinute <= 59) ? recipeData.totalTimeMinute : 59;

      this.closeRecipePopup()
      this.sharedService.overflowauto();
      this.changeFlag = true;
      this.overrideSave();
    } else {
      console.log(this.tempRecipeData.getRawValue());
      this.tempRecipeData.get('recipeName').markAsTouched();
      (this.tempRecipeData.get('steps') as FormArray).controls.forEach(e => {
        Object.keys((e as FormGroup).controls).forEach(e1 => {
          (e as FormGroup).controls[e1].markAsTouched();
        });
      });
      this.snotify.error('Enter required fields', '', this.sharedService.getConfig(false));
    }
  }

  updateOtherAffiliateEmbed() {
    let otherAffiliateData = this.tempOtherAffiliateData.getRawValue();
    if(!otherAffiliateData.productName) {
      this.snotify.error('Enter Product Name', '', this.sharedService.getConfig(false));
      return;
    }
    if(!otherAffiliateData.osp) {
      this.snotify.error('Enter Original Selling Price ', '', this.sharedService.getConfig(false));
      return;
    }
    if(!otherAffiliateData.logo) {
      this.snotify.error('Enter Logo', '', this.sharedService.getConfig(false));
      return;
    }
    if(!this.tempOtherAffiliateProductImage || this.tempOtherAffiliateProductImage.length < 1) {
      this.snotify.error('Enter Product Image', '', this.sharedService.getConfig(false));
      return;
    }
    if(this.tempOtherAffiliateData.valid){
      let otherAffiliateData = this.tempOtherAffiliateData.getRawValue();


      this.cardData['affiliate']['name'] = otherAffiliateData.productName;
      this.cardData['affiliate']['osp'] = parseInt(otherAffiliateData.osp);
      this.cardData['affiliate']['logo'] = otherAffiliateData.logo;
      this.cardData['affiliate']['discount_perc'] = parseInt(otherAffiliateData.discount_perc);
      this.cardData['affiliate']['url'] = parseInt(otherAffiliateData.url);
      this.cardData['affiliate']['curr_sell_price'] = parseInt(otherAffiliateData.curr_sell_price);
      this.cardData['affiliate']['images'] = this.tempOtherAffiliateProductImage;


      // this.showStepPopup = false;
      this.embedPopup = false;
      this.sharedService.overflowauto();
      this.changeFlag = true;
      this.overrideSave();
    }
  }

  removeAffiliateImage(model) {
    if(model === 'logo') {
      this.tempOtherAffiliateData.get('logo').setValue(null);
    } else if(model === 'product') {
      this.tempOtherAffiliateProductImage = null;
    }

  }

  updateHowToSteps() {
    console.log(this.tempHowToStepsData.errors);
    if(this.tempHowToStepsData.valid){
      let howToStepsData = this.tempHowToStepsData.getRawValue();
       //sid if value null /''/undefinde assign 0
    if(!howToStepsData.timeToComplete) howToStepsData.timeToComplete=0;
    if(!howToStepsData.timeToCompleteinHrs) howToStepsData.timeToCompleteinHrs=0;
    //
      this.cardData.heading = howToStepsData.heading;
      this.cardData.timeToComplete = (howToStepsData.timeToComplete === null || howToStepsData.timeToComplete === '' || howToStepsData.timeToComplete <= 59) ? howToStepsData.timeToComplete : 59;
      this.cardData.timeToCompleteinHrs = (howToStepsData.timeToCompleteinHrs === null || howToStepsData.timeToCompleteinHrs === '' || howToStepsData.timeToCompleteinHrs <= 999) ? howToStepsData.timeToCompleteinHrs : 999;
      this.cardData.supplies = howToStepsData.supplies;
      this.cardData.tools = howToStepsData.tools;
      this.cardData.steps = howToStepsData.steps;

      this.showStepPopup = false;
      this.sharedService.overflowauto();
      this.changeFlag = true;
      this.overrideSave();
    } else {
      this.tempHowToStepsData.get('heading').markAsTouched();
      // this.tempHowToStepsData.get('timeToComplete').markAsTouched();
      (this.tempHowToStepsData.get('steps') as FormArray).controls.forEach(e => {
        Object.keys((e as FormGroup).controls).forEach(e1 => {
          (e as FormGroup).controls[e1].markAsTouched();
        });
      });
      this.snotify.error('Enter required fields', '', this.sharedService.getConfig(false));
    }
  }

  suppliesChangeFunc(ev) {
    this.tempHowToStepsData.patchValue({'supplies': ev});
  }

  toolsChangeFunc(ev) {
    this.tempHowToStepsData.patchValue({'tools': ev});
  }

  ingredientsChangeFunc(ev) {
    this.tempRecipeData.patchValue({'ingredients': ev});
  }
  keywordsChangeFunc(ev) {
    this.tempRecipeData.patchValue({'keywords': ev});
  }

  removeStepImage(idx, model){
    if (model === 'howToSteps') {
      this.steps = this.tempHowToStepsData.get('steps') as FormArray;
    } else if (model === 'recipe') {
      this.steps = this.tempRecipeData.get('steps') as FormArray;
    }
    this.steps.at(idx).patchValue({stepImage: null});
  }

  getImageNameFromUrl(images) {
    let nameArr = images.original.split('/');
    let name = nameArr.slice(-1).pop();
    return name;
  }

  addStepsInlineImage(currentStep, type) {
    if (type === 'howToSteps') { this.howToStepsInlineImageFlag = true; }
    if (type === 'recipe') { this.recipeInlineImageFlag = true; }
    this.sharedService.overflowhidden();
    this.updateCurrentHowToStep(currentStep);
  }


  updateCurrentHowToStep(currentStep) {
    this.currentStep = currentStep;
  }

  uplaodImageAndOpenCropper(imageFile, base64, type) {
    this.snotify.info('Uploading', '', this.sharedService.getConfig(false));
    let allowLowQuality = false
    if(type === 'showHowToStepsCropper' ||type === 'showRecipeStepsCropper' ||type === 'showProductImageCropper'||type === 'listicleUploadImage' ){
      allowLowQuality = true
    }
    this.sharedService.uploadImage(imageFile,allowLowQuality).
      subscribe(res => {
        console.log("NOW HERE", res)
        this.cropperImageUrl.data = base64;
        this.cropperImageUrl.url = res['images']['original'];
        if(type === 'showCropper') {
          this.showCropper = true;
        }
        else if(type === 'showHowToStepsCropper') {
          this.showHowToStepsCropper = true;
        }
        else if(type ==='addCustomVideoThumbnail') {
          this.addVideoThumbnail = true;
        }
        else if(type === 'showRecipeStepsCropper') {
          this.showRecipeStepsCropper = true;
        }
        else if(type === 'affiliateLogo') {
          this.tempOtherAffiliateData.get('logo').setValue(res['images']['original']);
        }
        else if(type === 'showProductImageCropper') {
          this.showProductImageCropper = true;
        }  else if(type === 'listicleUploadImage') {
          this.enableListicleImageOption = false;
          this.addListicleImageMedia(res['images']['original'])
        }
        else if(type === 'faqUploadImage') {
          console.log("FAQ BEIN UPLOADED")
          this.enableFAQImageOption = false;
          this.addFAQImageMedia(res['images']['original'],0)
        }
        else if(type === 'quesFaqUploadImage') {
          console.log("FAQ BEIN UPLOADED")
          this.enableQuesFAQImageOption = false;
          this.addQuesFAQImageMedia(res['images']['original'],0)
        }
        else if(type === 'quesPollUploadImage') {
          console.log("POLL IMAGE UPLOADED")
          this.enableQuesFAQImageOption = false;
          this.addPollImageMedia(res['images']['original'],0)
        }
        else if(type === 'ansPollUploadImage') {
          console.log("POLL IMAGE UPLOADED")
          this.enableFAQImageOption = false;
          this.addPollImageMedia(res['images']['original'],0)
        }
      },
        error => {
          this.SingleselectedFile = null;
          this.showLoader = false;
          this.imageUploadInProgress = false;
          this.imageLoaderShow = false;
          this.imageLoaded = true;
          this.snotify.error('Upload Failed', '', this.sharedService.getConfig(false));
        });
  }
  showRecipe() {
    console.log(this.cardData)
  }

  closeListicleEmbedPopup() {
    this.showEmbedForListcleElement = false;
    this.showListiclePopup = true;
  }

  closeFAQEmbedPopup() {
    this.showEmbedForFAQElement = false;
    this.showEmbedForQuesFAQElement = false;
    this.showNewFAQPopup = true;
  }

  onFileChangeSingle(event, model) {
    console.log("model")
    this.imageLoaderShow = true;
    const reader = new FileReader();
    if (model === 'howToStepsImage' || model === 'recipeImage' || model === 'affiliateLogo' || model === 'productImage' || model === 'listicleUploadImage' || model === 'faqUploadImage' || model === 'quesFaqUploadImage' || model === 'quesPollUploadImage' || model === 'ansPollUploadImage') {
      // console.log('file uplaod called');
      const fd = new FormData();
      this.SingleselectedFile = <File>event.target.files[0];
      // console.log(this.SingleselectedFile);
      this.imageUploadInProgress = true;
      if (event.target.files && event.target.files.length > 0) {
        if ((typeof event.target.files[0]) === 'object') {
          // console.log(event.target.files[0]);
          if ((this.SingleselectedFile.size / 1000000) <= 11) {
            const a = reader.readAsDataURL(event.target.files[0]);
            reader.onload = (e: any) => {
              this.sharedService.checkImageForAMP(reader, flag => {
                if (flag) {
                  if(model === 'howToStepsImage') {
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showHowToStepsCropper');
                  } else if(model === 'recipeImage') {
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showRecipeStepsCropper');
                  } else if (model === 'affiliateLogo') {
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'affiliateLogo');
                  } else if (model === 'productImage') {
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showProductImageCropper');
                  } else if ( model === 'listicleUploadImage') {
                    this.imageLoaded = false;
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'listicleUploadImage');
                  } else if ( model === 'faqUploadImage') {
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'faqUploadImage');
                  } else if ( model === 'quesFaqUploadImage') {
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'quesFaqUploadImage');
                  } else if ( model === 'quesPollUploadImage') {
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'quesPollUploadImage');
                  } else if ( model === 'ansPollUploadImage') {
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'ansPollUploadImage');
                  }

                } else {
                  this.sharedService.showAMPConfirmPopup(() => { // yes
                    if(model === 'howToStepsImage') {
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showHowToStepsCropper');
                    } else if(model === 'recipeImage') {
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showRecipeStepsCropper');
                    } else if (model === 'affiliateLogo') {
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'affiliateLogo');
                    } else if (model === 'productImage') {
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'showProductImageCropper');
                    } else if ( model === 'listicleUploadImage') {
                      this.imageLoaded = false;
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'listicleUploadImage');
                    } else if ( model === 'faqUploadImage') {
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'faqUploadImage');
                    } else if ( model === 'quesFaqUploadImage') {
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'quesFaqUploadImage');
                    } else if ( model === 'quesPollUploadImage') {
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'quesPollUploadImage');
                    } else if ( model === 'ansPollUploadImage') {
                      this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'ansPollUploadImage');
                    }
                  },
                    () => { // no
                      this.SingleselectedFile = null;
                      this.imageUploadInProgress = false;
                    }
                  );
                }
              });
            };
          } else {
            this.SingleselectedFile = null;
            this.imageUploadInProgress = false;
            this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
          }
        }
      }
      event.target.value = null;
      this.isLightbox = false;
      this.leadMediaImageToggle = false;
      this.inlineImageToggle = false;
    }
  }
  onFileChangeSingleThumbnail(event, model) {
    const reader = new FileReader();
    if (model === 'addCustomVideoThumbnail') {
      // console.log('file uplaod called');
      const fd = new FormData();
      this.SingleselectedFile = <File>event.target.files[0];
      // console.log(this.SingleselectedFile);
      this.imageUploadInProgress = true;
      if (event.target.files && event.target.files.length > 0) {
        if ((typeof event.target.files[0]) === 'object') {
          // console.log(event.target.files[0]);
          if ((this.SingleselectedFile.size / 1000000) <= 11) {
            const a = reader.readAsDataURL(event.target.files[0]);
            reader.onload = (e: any) => {
              this.sharedService.checkImageForAMP(reader, flag => {
                if (flag) {
                  this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'addCustomVideoThumbnail');
                } else {
                  this.sharedService.showAMPConfirmPopup(() => { // yes
                    this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result, 'addCustomVideoThumbnail');
                  },
                    () => { // no
                      this.SingleselectedFile = null;
                      this.imageUploadInProgress = false;
                    }
                  );
                }
              });
            };
          } else {
            this.SingleselectedFile = null;
            this.imageUploadInProgress = false;
            this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
          }
        }
      }
      event.target.value = null;
      this.isLightbox = false;
      this.leadMediaImageToggle = false;
      this.inlineImageToggle = false;
    }
  }

  validateKeyPressForNumberOnlyField(ev: any) {
    // Define all the allowed keys, by keycode
    let keys = {38:true,39:true,40:true,37:true,16:true,8:true,46:true,48:true,49:true, 50:true,51:true,52:true,53:true,
      54:true,55:true,56:true,57:true,96:true,97:true,98:true,99:true,100:true,101:true,102:true,103:true,104:true,105:true};

    // If the pressed key is not listed above, do not perform any action
    if(!keys[ev.keyCode]) { ev.preventDefault(); }
  }

  validateMaxPositionValue(ev: any) {
    // Restrict the max input value to: 999
    if(ev.target.value > 999)
      ev.target.value = 999;
  }
  validateMaxPositionValueMin(event: any) {
    // Restrict the max input value to: 999
    if(event.target.value > 59)
      event.target.value = 59;
  }

  addCustomThumbnail(){
    this.enableCustomThumbnail= !this.enableCustomThumbnail
  }


  addAutoBacklink(cardData,wordList) {
    let maxLimitCount = Number(this.autoBacklinkMaxLinkLimit) - 1;
    this.recommendedAutobacklinkContentData = this.sharedService.getRecommendedAutobacklinkContentMap() ? this.sharedService.getRecommendedAutobacklinkContentMap():{};
    this.autoBacklinkResponse.recommendedLinkedContent === null ? this.autoBacklinkResponse.recommendedLinkedContent = {}: this.autoBacklinkResponse.recommendedLinkedContent;
    let lengthAutoBacklink = Object.keys(this.recommendedAutobacklinkContentData).length;
    wordList.forEach(e=>{
      let url
      if(e.value.pageType === 'EXTERNAL'){
        url = e.value.externalUrl
      } else {
        url = e.value.url
      }
      if(!this.recommendedAutobacklinkContentData.hasOwnProperty(e.key) && !this.removedBacklinkList.includes(e.key) && lengthAutoBacklink<=maxLimitCount){
      lengthAutoBacklink = lengthAutoBacklink + 1;
      if(!this.autoBacklinkResponse.recommendedLinkedContent.hasOwnProperty(e.key)){
      if(!!cardData){
           let topicUrl;
            if(url.includes('https')) {
              topicUrl = url;
            } else {
              if(this.sharedService.currentDomainUrl && this.sharedService.currentDomainUrl.length>8){
                topicUrl = this.sharedService.currentDomainUrl + url;
              } else {
                let urlObj = environment.domainBaseUrls.filter(e => e.id === sessionStorage.getItem(StaticDataService.domainLiteral));
                topicUrl = urlObj[0].baseUrl + url;
              }
            }
            let paraBody = cardData;
            const pattern =new RegExp(`(?![^<]*>|[^<>]*<\\/a>)${escapeRegExp(e.key)}`, 'i');
            const replaceThis = `<a href="${topicUrl}" class="autobacklink-topic" target="_blank" data-name="${e.key}">${e.key}</a>`;
            paraBody = paraBody.replace(pattern,replaceThis);
            cardData = paraBody;
            this.saveCard(true, word => {});
            let key = e.key
            if(this.cardData.type == 'liveblog')
            {
              this.cardData.liveBlog.body = cardData;
              this.descriptionEditor ? this.descriptionEditor.setData(cardData):'';
            }else{
              this.cardData.paragraph.body= cardData;
              this.paraEditor ? this.paraEditor.setData(cardData):'';
              this.paraEditor.focus();
              this.paraEditor.model.change((writer) => {
              writer.setSelection(writer.createPositionAt(this.paraEditor.model.document.getRoot(), "end"));
              });
            }
            if(this.checkifKeyNotPresentInParagraph(cardData,e.key)){
            this.autoBacklinkResponse.recommendedLinkedContent[key] = e.value;
          }
         }
        }
      }
    })
      this.updateAutoBacklinkData(this.paraElementId,this.autoBacklinkResponse,true);
      }

  checkifKeyNotPresentInParagraph(paragraph,word){
    const regex = new RegExp(`<a.*?>${word}</a>`, "i");
    if (!regex.test(paragraph)) {
      return false;
    }
    return true;

  }
  getremoveAutoBackLinkFromList(cardData,word){
    //using child  getting from story-container method removeAutoBackLinkFromList
    let paraBody=cardData;
        //  console.log(paraBody);
      if(!!word && !!cardData){
        let paraBody=cardData;
        let replaceThis = '<a[^>]*>'+word+'<\/a>'
        let regexReplace = new RegExp(`${replaceThis}`)
        let l = regexReplace.exec(paraBody);
        if(!!l && l.length>0){
          paraBody = paraBody.replace(regexReplace, word);
          // console.log('after',paraBody)
          this.cardData.paragraph.body= paraBody;
          this.saveCard(true, word => {});
          // decrement manualcount
           this.manualLinkCountDecr.emit();
           this.snotify.info(word, 'Removed!', this.sharedService.getConfig(false));

        }else{
          console.log("not extract url",l)
        }

      }
  }

  getremoveAutoBackLinkFromListManual(cardData,paraId,word){
    //using child  getting from story-container method removeAutoBackLinkFromList
    let paraBody=cardData;
      if(!!word && !!cardData){
        let paraBody=cardData;
        let replaceThis = '<a[^>]*>'+word+'<\/a>'
        let regexReplace = new RegExp(`${replaceThis}`)
        let l = regexReplace.exec(paraBody);
        if(!!l && l.length>0){
          paraBody = paraBody.replace(regexReplace, word);
          this.cardData.paragraph.body= paraBody;
          this.paraEditor ? this.paraEditor.setData(this.cardData.paragraph.body):'';
          this.saveCard(true, word => {});
          // decrement manualcount
           this.manualLinkCountDecr.emit();
           this.snotify.info(word, 'Removed!', this.sharedService.getConfig(false));
          //  delete this.autoBacklinkResponse.recommendedLinkedContent[word];
          //  this.updateAutoBacklinkData(paraId,this.autoBacklinkResponse,false);
        }
      }
  }

addVideoCaption(){
let data;
if(!this.tempCardData.caption){
  return this.snotify.error('Please add video caption','',this.sharedService.getConfig(false));
}
//  if (this.temporaryChangesFlag) {
  data= (this.tempCardData.caption && this.tempCardData.caption.trim() !== '')
  ? (this.sharedService.isdomainConfig('story','captionStripTagDisabled') ? this.tempCardData.caption : this.htmlToPlaintext(this.tempCardData.caption)) : '';
  data=data.replaceAll('&nbsp;','');
  this.cardData.video['caption']= data;
   //sending into storyContainer
  //updateVideoCaption()
  this.sendVideoCaption.emit(data)
  this.changeFlag = true;

  this.overrideSave();

  setTimeout(e1 => {
    this.temporaryChangesFlag = false;
    this.onelementBlur();
  }, 700);
// }
// else {
//   this.discardMetaChanges(false);
//   // this.editCardFlag = false;
//   this.onelementBlur();

//   this.lockRelease(this.cardId, e => { });
// }
  this.iseditVideCaptionClick = false;;
}
addVideoImageCaption(){
let data;
if(!this.tempCardData.videoImageCaption){
  return this.snotify.error("Please add video's image caption",'',this.sharedService.getConfig(false));
}
// if (this.temporaryChangesFlag) {
  data= (this.tempCardData.videoImageCaption && this.tempCardData.videoImageCaption.trim() !== '')
  ? (this.sharedService.isdomainConfig('story','captionStripTagDisabled') ? this.tempCardData.videoImageCaption : this.htmlToPlaintext(this.tempCardData.videoImageCaption)) : '';
  data=data.replaceAll('&nbsp;','');
  this.cardData.video['image']['caption']= data;
   //sending into storyContainer
  //updateVideoImageCaption()
  this.sendVideoImageCaption.emit(data)
  this.changeFlag = true;

  this.overrideSave();

  setTimeout(e1 => {
    this.temporaryChangesFlag = false;
    this.onelementBlur();
  }, 700);
// }

// else {
//   this.discardMetaChanges(false);
//   // this.editCardFlag = false;
//   this.onelementBlur();

//   this.lockRelease(this.cardId, e => { });
// }
  this.iseditVideImageCaptionClick = false;;
}

editVideoCaption(){
this.iseditVideCaptionClick=true;
this.tempCardData.caption= this.cardData.video['caption']

}
editVideoImageCaption(){
this.iseditVideImageCaptionClick=true;
this.tempCardData.videoImageCaption= this.cardData.video['image']['caption']

}

updateVideoImageData(imageData){
//  console.log('=====LeadVideo========',imageData.images)
this.cardData.video.image.images=imageData.images
}

getlistcleBrandList(){
  this.loadBrands(true);
}


getListcleModelList(event){
  this.loadModels(event.target.value,true);
  let brandValue=event.target.value;
}

saveListcleProduct() {
  if(!!this.listcleBrand){
    const listicleCard = JSON.parse(JSON.stringify(StaticDataService.defaultListicleCardData));
  this.cardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
  // this.cardData.listicle.product.category=this.listcleCategory;
  this.cardData.listicle.product.brandName=this.listcleBrand;
  this.cardData.listicle.product.modelName=this.listcleModel;
      // this.listcleCategory = '';
      this.listcleBrand = '';
      this.listcleModel = '';
      this.listicleProductPopup = false;
    }
  else {
    this.snotify.error('Select an Option', '', this.sharedService.getConfig(false));
  }


}

openlisticleProductPopup() {
  this.getlistcleBrandList();
  this.listicleProductPopup = true;
}
closeProductPopup() {
  this.showProductPopup = false;
  this.showCategoryProductPopup = false;
  this.productElement = {};
  this.brandEleQuery = '';
  this.modelEleQuery = '';
  this.categoryEleQuery = '';
}
saveProductElement() {
  if (this.productElement['brand']) {
    // if (marketCard.indice.name) {
    this.cardData.product.brandName = this.productElement['brand'];
    this.cardData.product.modelName = this.productElement['model'];
    this.changeFlag = true;
    this.overrideSave();
    this.closeProductPopup();
  } else {
    this.snotify.error('Select a Brand', '', this.sharedService.getConfig(false));
  }
}
saveCategoryProductElement() {
  if (this.productElement['brand']) {
    const productCard = JSON.parse(JSON.stringify(StaticDataService.defaultProductCardData));
    console.log(this.productElement)

    this.cardData.product.brandName = this.productElement['brand'];
    this.cardData.product.categoryName = this.productElement['category'];
    if(this.productElement['model'].length > 0) {
    this.changeFlag = true;
    this.cardData.product.modelName = this.productElement['model'];
    this.cardData.product.modelId = this.productElement['modelId'];
    this.cardData.product.productUrl = this.productElement['url'];
    this.cardData.product.categoryId = this.productElement['categoryId']
    this.closeProductPopup();
    this.overrideSave();
    } else {
      this.snotify.error('Choose a model...', '', this.sharedService.getConfig(false));
    }
  } else {
    this.snotify.error('Select a Category & Brand', '', this.sharedService.getConfig(false));
  }
}

/**
   * load Models of a Brand
   * @param brand
   */
 private loadModels(brand:String,isListicle:Boolean){
  if(this.enableModel){
   this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/auto/'+brand+"/Products")
   .subscribe(
    data => {
      if(isListicle){
        this.listicleModelList=data;
     }else{
         this.filteredModelSuggestion =data;
      }
   },
    err => {
      // console.log(err);
     }
   );
  }
}


 /**
   * Load Brands
   */
  private  loadBrands(isListicle:Boolean){
    if (this.enableBrand ) {
      this.restService.http_get(this.config.get('product').utilUrl + '/api/cms/auto/manufacturers')
      .subscribe(
        data => {
             if(isListicle){
              this.listicleProductBrandList=data;
             }
             else{
              this.brandSuggestion=data;
             }
        },
        err => {
          // console.log(err);
        }
      );
  }
  }


selectAutoComplete(model, item) {

  if (model === 'brandEle') {
    this.productElement['brand'] = item;
    this.productElement['model'] = '';
    this.brandEleQuery = item;
    this.modelEleQuery = '';
    this.insideBrandEle = false;
    this.loadModels(item,false);

  } else if (model === 'modelEle') {
    this.productElement['model'] = item;
    if(this.domainConfig['elementsDisabled'].indexOf('categoryProductElement') === -1) {
      this.productElement['modelId'] = this.modelSuggestionValues[this.productElement['brand']][item][0];
      this.productElement['url'] = this.modelSuggestionValues[this.productElement['brand']][item][1];
    }
    this.modelEleQuery = item;
    this.modelEleQuery = item;
    this.insideModelEle = false;
  } else if (model === 'categoryEle') {
    this.brandSuggestion = [];
    this.modelSuggestion = [];
    // debugger;
    if(item.categoryName !== this.cardData.product.categoryName) {
      this.brandEleQuery = '';
      this.modelEleQuery = '';
      this.productElement['brand'] = '';
      this.productElement['model'] = '';
    }
    this.productElement['category'] = item.categoryName;
    this.productElement['categoryId'] = item.id;
    this.categoryEleQuery = item.categoryName;
    this.restService.http_get(this.config.get('product').baseUrl
        + '/api/cms/story/brandproduct/' + item.id)
        .subscribe(
          data => {
            this.brandSuggestion = Object.keys(data);
            this.modelSuggestion = (data);
            this.modelSuggestionValues = data;
          }
        );

  }

}

filterAutoCompleteUp(event, model) {
  // console.log("filterAutoCompleteUp: "+event);
  // console.log("filterAutoCompleteUp: "+model);
  if (event.keyCode !== 9 && event.keyCode !== 27 && event.key !== 'Enter') {
    if (model === 'brandEle') {
      // console.log('inside => ' + this.insideSection);
      if (this.insideBrandEle) {
        if (this.brandEleQuery.length > 0) {
          this.filteredBrandSuggestion = this.brandSuggestion.filter(function (el) {
            return el.toLowerCase().indexOf(this.brandEleQuery.toLowerCase()) > -1;
          }.bind(this));
          // console.log('array => ' + this.filteredSectionSuggestion);
        }
        else {
          this.modelEleQuery = '';
          this.filteredBrandSuggestion = this.brandSuggestion;
        }
      } else {
        // this.insideBrand = true;
        this.filteredBrandSuggestion = [];
      }
    } else if (model === 'modelEle') {
      if (this.insideModelEle) {
        if(this.productElement['brand'] && this.productElement['brand'] !== '') {
          if (this.modelEleQuery.length > 0) {
            this.filteredModelSuggestion = this.modelSuggestion[this.productElement['brand']].filter(function (el) {
              return el.toLowerCase().indexOf(this.modelEleQuery.toLowerCase()) > -1;
            }.bind(this));
          } else {
            this.productElement['model'] = '';
            this.filteredModelSuggestion = this.modelSuggestion[this.productElement['brand']];
          }
        }
      } else {
        // this.insideModelEle = true;
        this.filteredModelSuggestion = [];
      }
    } else if (model === 'categoryEle') {
      if (this.insideCategoryEle) {
        if (this.categoryEleQuery.length > 0) {
          this.filteredCategorySuggestion = this.categorySuggestion.filter(function (el) {
            return el.categoryName.toLowerCase().indexOf(this.categoryEleQuery.toLowerCase()) > -1;
          }.bind(this));
          // console.log('array => ' + this.filteredSectionSuggestion);
        }
        else {
          this.categoryEleQuery = '';
          this.filteredCategorySuggestion = this.categorySuggestion;
        }
      } else {
        // this.insideBrand = true;
        this.filteredCategorySuggestion = [];
      }
    }
    else if (model === 'modelCategoryEle') {
      if (this.insideModelEle) {
        if(this.productElement['brand'] && this.productElement['brand'] !== '') {
          if (this.modelEleQuery.length > 0) {
            this.modelSuggestion = this.modelSuggestionValues;
            this.filteredModelSuggestion = Object.keys(this.modelSuggestion[this.productElement['brand']]).filter(function (el) {
              return el.toLowerCase().indexOf(this.modelEleQuery.toLowerCase()) > -1;
            }.bind(this));
          }
          else {
            // this.productElement['model'] = '';
            this.filteredModelSuggestion = [];
          }
        }
      } else {
        // this.insideModelEle = true;
        this.filteredModelSuggestion = [];
      }
    }
  }
}

  openPodcastPopup() {
    this.showPodcastPopup = true;
  }
  closePodcastPopup() {
    this.showPodcastPopup = false;
  }

  getPodcastCardDetails(ev) {
    this.closePodcastPopup();
    this.updatePodcastCard(ev);
  }

  updatePodcastCard(ev) {
    let podcastData = ev;

    this.cardData['podcast']['podcastId'] = podcastData.id;
    this.cardData['podcast']['podcastTitle'] = podcastData.title;
    this.cardData['podcast']['podcastContent'] = podcastData.content;
    this.cardData['podcast']['podcastImage'] = podcastData.episode_image;
    this.cardData['podcast']['podcastUrl'] = podcastData.href;
    this.cardData['podcast']['podcastMp3Url'] = podcastData.mp3_url;
    this.cardData['podcast']['podcastPublisher']['id'] = podcastData.publisherId;
    this.cardData['podcast']['podcastPublisher']['name'] = podcastData.publisherName;

    this.showPodcastPopup = false;
    this.sharedService.overflowauto();
    this.changeFlag = true;
    this.overrideSave();

    let audioTag : any = document.getElementById("podcastAudio");
    audioTag.load();

  }


focusInSuggest(model) {
  if (model === 'brandEle') {
    this.insideBrandEle = true;
    if (this.brandEleQuery === '') {
      this.filteredBrandSuggestion = this.brandSuggestion;
    }
  }
  if(model === 'modelEle') {
    this.insideModelEle = true;
    if (this.modelEleQuery === '') {
      if(this.productElement['brand'] && this.productElement['brand'] !== '') {
        this.filteredModelSuggestion = this.modelSuggestion[this.productElement['brand']] ? this.modelSuggestion[this.productElement['brand']] : [];
      } else {
        this.filteredModelSuggestion = [];
      }
    }
  }
  if (model === 'categoryEle') {
    this.insideCategoryEle = true;
    if (this.categoryEleQuery === '') {
      this.filteredCategorySuggestion = this.categorySuggestion;
    }
  }
}
speechToText(){
   this.speechButton = false;

  this.speechRecognitionService.record(this.langCode)
    .subscribe(
      //listener
      (value) => {
        // this = this.speechData + ' ' + value;
        // this.msg = (this.msg +' ' + value).trim();
        if(value['finalValue']){
           this.msg +=' '+ value['term'];
          this.msg1='';
          console.log('speechhhh',this.msg)
          this.cardData.paragraph.body +=' '+ value['term']

          // this.msg1=this.msg;
          // this.finalStream=true;

        }else{
          this.msg1=value['term'];
          // this.finalStream=false;
        }
      },
      //errror
      (err) => {
        if (err.error == "no-speech") {
          // console.log(err)
          this.snotify.error('kindly click on mic to continue', err.error.toUpperCase(), this.sharedService.getConfig(false));
          this.speechButton = true;
        }
      },
      // completion
      () => {
        console.log('complete')
        this.speechButton = true;
        // this.activateSpeech();
        this.snotify.info('Voice Recognition is complete kindly click on mic to continue', 'Complete', this.sharedService.getConfig(false));
      }
      );
  let eventCategory='Text to Speech Activate';
  let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
  let eventLabel='';
  let eventValue=null;
  this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
}
speechStop(){
  this.speechButton=true;
  this.speechRecognitionService.DestroySpeechObject();
  let eventCategory='Text to Speech Deactivate';
  let eventAction=sessionStorage.getItem(StaticDataService.tenantName);
  let eventLabel='';
  let eventValue=null;
  this.googleAnalytics(eventCategory,eventAction,eventLabel,eventValue)
}
googleAnalytics(eventCategory,eventAction,eventLabel,eventValue){
  this.gaService.gaEventView(eventCategory,eventAction,eventLabel,eventValue)
 }

toggleVerticalSwitch() {
  this.tempCardData.verticalImage = !this.tempCardData.verticalImage;
}

editLiveBlogPost()
{
  this.liveBlogPostEdit = true;
}

closeEditLiveBlogPost()
{
  this.liveBlogPostEdit = false;
}

openlisticlePopup() {
  this.resetListicleSection();
  this.tempListicleData.patchValue({
    heading: this.cardData.listicleHeadline,
    listicleBulletType: this.cardData.listicleBulletType
  });

  (<FormArray>this.tempListicleData.controls['listicleArray']).removeAt(0);

  this.cardData.listicleArray.forEach((list) => {
    if(list.mediaType === 'embed') {
      this.sharedService.runEmbedProcessor(list.media.embedCode, this.embedElement);
    }
  })

  this.cardData.listicleArray.forEach((list) => {
    const group = this.formBuilder.group({
      key: new FormControl(list.key, [Validators.required]),
      value: new FormControl(list.value, [Validators.required]),
      url: new FormControl(list.url),
      media: new FormControl(list.media),
      mediaType: new FormControl(list.mediaType),
      mediaId: new FormControl(list.mediaId)
    });
    (<FormArray>this.tempListicleData.get('listicleArray')).push(group);

  });
  this.showListiclePopup = true;
}

openNewFaqPopup() {
  this.resetNewFaqSection();
  this.tempnewFAQData.patchValue({
    heading: this.cardData.faqSectionHeading,
  });

  (<FormArray>this.tempnewFAQData.controls['faqArray']).removeAt(0);

  this.cardData.faqs.forEach((list) => {
    if(list.mediaType === 'embed') {
      this.sharedService.runEmbedProcessor(list.media.embedCode, this.embedElement);
    }
  })

  this.cardData.faqs.forEach((list) => {
    const group = this.formBuilder.group({
      key: new FormControl(list.key, [Validators.required]),
      value: new FormControl(list.value, [Validators.required]),
      mediaKey: new FormControl(list.mediaKey),
      mediaTypeKey: new FormControl(list.mediaTypeKey),
      mediaIdKey: new FormControl(list.mediaIdKey),
      mediaValue: new FormControl(list.mediaValue),
      mediaTypeValue: new FormControl(list.mediaTypeValue),
      mediaIdValue: new FormControl(list.mediaIdValue)
    });
    (<FormArray>this.tempnewFAQData.get('faqArray')).push(group);

  });
  this.showNewFAQPopup = true;
}

openNewPollPopup() {
  this.resetNewPollSection();
  this.tempnewFAQData.patchValue({
    heading: this.cardData.poll.heading,
    key: this.cardData.poll.key,
    mediaKey: this.cardData.poll.mediaKey,
    mediaTypeKey: this.cardData.poll.mediaTypeKey,
    mediaIdKey: this.cardData.poll.mediaIdKey,
    questionType: this.cardData.poll.questionType
  });
  (<FormArray>this.tempnewFAQData.controls['ansArray']).removeAt(0);
  this.cardData.poll.ansArray.forEach((list) => {
    const group = this.formBuilder.group({
      value: new FormControl(list.value, [Validators.required]),
      mediaValue: new FormControl(list.mediaValue),
      mediaTypeValue: new FormControl(list.mediaTypeValue),
      mediaIdValue: new FormControl(list.mediaIdValue)
    });
    (<FormArray>this.tempnewFAQData.get('ansArray')).push(group);

  });
  this.showNewPollPopup = true;
}

openLabelPopup() {
  this.label = this.cardData.label;
  this.showLabelPopup = true;
}
closeLabelPopup() {
  this.label = '';
  this.showLabelPopup = false;
}
openSeparatorPopup() {
  this.separator = this.cardData.separator;
  this.showSeparatorPopup = true;
}
closeSepartorPopup() {
  this.separator = '';
  this.showSeparatorPopup = false;
}

resetListicleSection() {
  this.tempListicleData = this.formBuilder.group({
    heading: new FormControl('', [Validators.required]),
    listicleBulletType: new FormControl('number', [Validators.required]),
    listicleArray: this.formBuilder.array([ this.createListicleItem() ])
  });
}

addFAQImage(index,el: HTMLElement) {
  this.videoIndex = index;
  this.enableFAQImageOption = true
  // setTimeout(() => {
  //   el.scrollIntoView();
  // }, 500);
}
addQuesFAQImage(index,el: HTMLElement) {
  this.videoIndex = index;
  this.enableQuesFAQImageOption = true
  // setTimeout(() => {
  //   el.scrollIntoView();
  // }, 500);
}

resetNewFaqSection() {
  this.tempnewFAQData = this.formBuilder.group({
    heading: new FormControl('', [Validators.required]),
    faqArray: this.formBuilder.array([ this.createNewFaqItem() ])
  });
}

resetNewPollSection() {
  this.tempnewFAQData = this.formBuilder.group({
    heading: new FormControl('', [Validators.required]),
    questionType: new FormControl('singleSelect', [Validators.required]),
    key: new FormControl('', [Validators.required]),
    mediaKey: new FormControl(null),
    mediaTypeKey: new FormControl(''),
    mediaIdKey: new FormControl(''),
    ansArray: this.formBuilder.array([ this.createNewPollItem() ])
  });
}

addListicle(el: HTMLElement) {
  this.listicleArray = this.tempListicleData.get('listicleArray') as FormArray;
  this.listicleArray.push(this.createListicleItem());
  setTimeout(() => {
    el.scrollIntoView();
  }, 500);
}

createListicleItem(): FormGroup {
  return this.formBuilder.group({
    key: new FormControl('', [Validators.required]),
    value: new FormControl('', [Validators.required]),
    url: new FormControl(null),
    media: new FormControl(null),
    mediaType: new FormControl(''),
    mediaId: new FormControl('')
  });
}

createNewFaqItem(): FormGroup {
  return this.formBuilder.group({
    key: new FormControl('', [Validators.required]),
    value: new FormControl('', [Validators.required]),
    mediaValue: new FormControl(null),
    mediaTypeValue: new FormControl(''),
    mediaIdValue: new FormControl(''),
    mediaKey: new FormControl(null),
    mediaTypeKey: new FormControl(''),
    mediaIdKey: new FormControl('')
  });
}

createNewPollItem(): FormGroup {
  return this.formBuilder.group({
    value: new FormControl('', [Validators.required]),
    mediaValue: new FormControl(null),
    mediaTypeValue: new FormControl(''),
    mediaIdValue: new FormControl(''),
  });
}

closeListiclePopup() {
  this.resetListicleSection();
  this.showListiclePopup = false;
  this.enableListicleImageOption = false;
}

updateListicleElement() {
  let listicleData = this.tempListicleData.getRawValue();
  this.cardData.listicleArray = listicleData.listicleArray;
  this.cardData.listicleHeadline = listicleData.heading;
  this.cardData.listicleBulletType = listicleData.listicleBulletType;
  this.showListiclePopup = false;
  this.sharedService.overflowauto();
  this.overrideSave();
}

updateNewFAQElement() {
  let faqData = this.tempnewFAQData.getRawValue();
  this.cardData.faqs = faqData.faqArray;
  this.cardData.faqSectionHeading = faqData.heading;
  this.showNewFAQPopup = false;
  this.sharedService.overflowauto();
  this.overrideSave();
}

saveLabel(){
  this.cardData.label = this.label;
  this.showLabelPopup = false;
  this.sharedService.overflowauto();
  this.overrideSave();
}
saveSeparator(){
  this.cardData.separator = this.separator;
  this.showSeparatorPopup = false;
  this.sharedService.overflowauto();
  this.overrideSave();
}

updateNewPollElement() {
  let pollData = this.tempnewFAQData.getRawValue();
  this.cardData.poll = pollData;
  this.showNewPollPopup = false;
  this.sharedService.overflowauto();
  this.overrideSave();
}

closeNewFAQPopup() {
  this.resetNewFaqSection();
  this.showNewFAQPopup = false;
  this.enableFAQImageOption = false;
}

closeNewPollPopup() {
  this.resetNewPollSection
  this.showNewPollPopup = false;
  this.enableFAQImageOption = false;
}

deleteListicleMedia(index) {
  this.tempListicleData.get('listicleArray')['controls'][index].patchValue({
    'media': null,
    'mediaId':'',
    'mediaType':''
  });
}

deleteListicle(idx){
  this.listicleArray = this.tempListicleData.get('listicleArray') as FormArray;
  this.listicleArray.removeAt(idx);
}

addNewFAQ(el: HTMLElement) {
  this.faqArray = this.tempnewFAQData.get('faqArray') as FormArray;
  this.faqArray.push(this.createNewFaqItem());
    setTimeout(() => {
      el.scrollIntoView();
    }, 500);
}

addNewPollAnswer(el : HTMLElement)
  {
    this.ansArray = this.tempnewFAQData.get('ansArray') as FormArray;
    this.ansArray.push(this.createNewPollItem());
      setTimeout(() => {
        el.scrollIntoView();
      }, 500);
  }

deleteNewFAQ(idx){
  this.faqArray = this.tempnewFAQData.get('faqArray') as FormArray;
  this.faqArray.removeAt(idx);
}

deleteNewPollAns(idx){
  this.ansArray = this.tempnewFAQData.get('ansArray') as FormArray;
  this.ansArray.removeAt(idx);
}

deleteNewFAQMedia(index) {
  this.tempnewFAQData.get('faqArray')['controls'][index].patchValue({
    'mediaValue': null,
    'mediaIdValue':'',
    'mediaTypeValue':'',
  });
}
deleteNewQuesFAQMedia(index) {
  this.tempnewFAQData.get('faqArray')['controls'][index].patchValue({
    'mediaKey': null,
    'mediaIdKey':'',
    'mediaTypeKey':''
  });
}

deleteNewQuesPollMedia()
  {
    this.tempnewFAQData.get('mediaKey').patchValue(null);
    this.tempnewFAQData.get('mediaIdKey').patchValue('');
    this.tempnewFAQData.get('mediaTypeKey').patchValue('');
  }

deleteNewAnsPollMedia(index)
  {
    this.tempnewFAQData.get('ansArray')['controls'][index].patchValue({
      'mediaValue': null,
      'mediaIdValue':'',
      'mediaTypeValue':''
    });
  }

showListcleEmbed(index) {
  this.enableListicleImageOption = false;
  this.videoIndex = index;
  this.listicleEmbedCode = '';
  this.showEmbedForListcleElement = true;
  this.showListiclePopup = false;
}

showFAQEmbed(index) {
  this.enableFAQImageOption = false;
  this.videoIndex = index;
  this.faqEmbedCode = '';
  this.showEmbedForFAQElement = true;
  this.showNewFAQPopup = false;
}

showQuesFAQEmbed(index) {
  this.enableQuesFAQImageOption = false;
  this.videoIndex = index;
  this.quesFaqEmbedCode = '';
  this.showEmbedForQuesFAQElement = true;
  this.showNewFAQPopup = false;
}

saveEmbedData(){
  this.showEmbedForListcleElement = false;
  this.showListiclePopup = true;
  this.sharedService.runEmbedProcessor(this.listicleEmbedCode, this.embedElement);
  this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('media').setValue({'embedCode': this.listicleEmbedCode});
  this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaType').setValue('embed');
  const embedCardData = JSON.parse(JSON.stringify(StaticDataService.defaultEmbedCardData));
  embedCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
  embedCardData.id = null;
  embedCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
  embedCardData.embed.body = this.listicleEmbedCode;
  this.SingleselectedFile = null;
  this.increasePendingCount();
  this.restService.http_post(this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
    embedCardData, res => {
      this.decreasePendingCount();
      this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaId').setValue(res.id);
      this.videoIndex = ''
     });
  }

  saveFAQEmbedData(){
    this.showEmbedForFAQElement = false;
    this.showNewFAQPopup = true;
    this.sharedService.runEmbedProcessor(this.faqEmbedCode, this.embedElement);
    this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaValue').setValue({'embedCode': this.faqEmbedCode});
    this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaTypeValue').setValue('embed');
    const embedCardData = JSON.parse(JSON.stringify(StaticDataService.defaultEmbedCardData));
    embedCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    embedCardData.id = null;
    embedCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
    embedCardData.embed.body = this.faqEmbedCode;
    this.SingleselectedFile = null;
    this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      embedCardData, res => {
        this.decreasePendingCount();
        this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaIdValue').setValue(res.id);
        this.videoIndex = ''
       });
  }

  saveQuesFAQEmbedData(){
    this.showEmbedForQuesFAQElement = false;
    this.showNewFAQPopup = true;
    this.sharedService.runEmbedProcessor(this.quesFaqEmbedCode, this.embedElement);
    this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaKey').setValue({'embedCode': this.quesFaqEmbedCode});
    this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaTypeKey').setValue('embed');
    const embedCardData = JSON.parse(JSON.stringify(StaticDataService.defaultEmbedCardData));
    embedCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    embedCardData.id = null;
    embedCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
    embedCardData.embed.body = this.quesFaqEmbedCode;
    this.SingleselectedFile = null;
    this.increasePendingCount();
    this.restService.http_post(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
      embedCardData, res => {
        this.decreasePendingCount();
        this.tempnewFAQData.get('faqArray')['controls'][this.videoIndex].get('mediaIdKey').setValue(res.id);
        this.videoIndex = ''
       });
  }

  addListicleImage(index,el: HTMLElement) {
    this.videoIndex = index;
    this.enableListicleImageOption = true
    setTimeout(() => {
      el.scrollIntoView();
    }, 500);
  }

  addListicleInlineImage() {
    this.imageLoaderShow = true;
    this.enableListicleImageOption = false;
    this.listicleInlineImageFlag = true;
    this.imageLoaded = false;
  }
  onImageLoad() {
    this.imageLoaded = true;
  }

  addFAQInlineImage() {
    this.enableFAQImageOption = false;
    this.FAQInlineImageFlag = true;
  }
  addQuesFAQInlineImage() {
    this.enableQuesFAQImageOption = false;
    this.quesFAQInlineImageFlag = true;
  }

  addQuesPollInlineImage() {
    this.imageLoaderShow = true;
    this.enableQuesFAQImageOption = false;
    this.pollInlineImageFlag = true;
  }

  addAnsPollInlineImage() {
    this.imageLoaderShow = true;
    this.enableFAQImageOption = false;
    this.pollInlineImageFlag = true;
  }

  finishCroppingListicleImage(event, model) {
    const requests = event.cropRequests;
    const verticalFlag = event.verticalFlag;
    const differentLeadFlag = event.differentImage;
    this.cancelCropping();
    this.increasePendingCount();
    this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
      this.decreasePendingCount();
      if (!data.hasOwnProperty('error')) {
        const { ampFlag, imagemap } = data;
        const ImageCardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
        ImageCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        ImageCardData.id = null;
        ImageCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
        ImageCardData.image.images = imagemap;
        this.SingleselectedFile = null;
        this.increasePendingCount();
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          ImageCardData, image => {
            this.decreasePendingCount();
            this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaId').setValue(image.id);
            this.videoIndex = ''
          });
        let obj = { image: ImageCardData.image}
        this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('media').setValue(obj);
        this.tempListicleData.get('listicleArray')['controls'][this.videoIndex].get('mediaType').setValue('image');
        this.SingleselectedFile = null;
      } else {
        this.snotify.error('Image cropping failed', '', this.sharedService.getConfig(false));
      }
    });
  }

  movieImageUplaod(event) {
    const Files = event.target.files;
    const length = Files['length'];
    if (event.target.files && (event.target.files.length > 0)) {
      let hasAnImage = false;
      for (let i = 0; i < length; i++) {
        let file_name = <File>event.target.files[i].name;
        const image = <File>Files[i];
        if(!this.checkSpecialChars(file_name)) {
          if ((image.size / 1000000) <= 11) {
            hasAnImage = true;
            const fd = new FormData();
            fd.append('file', image, image.name);
            this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
              subscribe(res => {
              this.tempMovieReviewData.image= res;
               if(event.target.files.length === i+1 ){
                event.target.value = '';
               }
              },
              err => {
                  event.target.value = '';
                  this.snotify.error('Image is of low quality, Please upload a new image( > 100KB)' , '', this.sharedService.getConfig(false));
              });
          }
        }
      }

    }
  }

  checkSpecialChars(imageFileName) {
    let regex = new RegExp(/[^a-zA-z0-9-_.\s]+/g);
    let m;
      m = regex.exec(imageFileName);
      if (m) {
          imageFileName = imageFileName.replace(regex, '');
          console.log("rejected => ", imageFileName)
          this.snotify.error('Special Chars not Allowed in uploaded image', '', this.sharedService.getConfig(false));
          return true;
      }
    if(imageFileName.length > 50) {
      this.snotify.error('File Name should be less than 50 Charecters', '', this.sharedService.getConfig(false));
      imageFileName = imageFileName.slice(0,50);
      return true;
    }
    return false;
  }

  setMovieImage(event){
    let defaultImagecardData = Object.assign({}, event.data);
    let imageData = defaultImagecardData.image.images.original;
    defaultImagecardData.image.images = {};
    defaultImagecardData.image.images = {'original': imageData};
    this.tempMovieReviewData.image = defaultImagecardData.image ;
    this.disableshowGallery();
  }

  deleteMovieImage(){
    this.tempMovieReviewData.image= {};
  }
}
